var Ir = Object.defineProperty;
var Ar = (e, t, n) => t in e ? Ir(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var we = (e, t, n) => Ar(e, typeof t != "symbol" ? t + "" : t, n);
import { defineComponent as B, ref as G, createElementBlock as S, openBlock as g, mergeProps as me, mergeModels as oe, useModel as fe, computed as C, createBlock as D, withKeys as yt, normalizeClass as M, createElementVNode as R, createCommentVNode as A, withModifiers as Xt, toDisplayString as Z, resolveDynamicComponent as Fe, withCtx as K, resolveComponent as Er, useAttrs as it, toValue as q, isRef as zr, getCurrentScope as go, onScopeDispose as yo, onMounted as gn, nextTick as Mr, watch as se, getCurrentInstance as yn, hasInjectionContext as xo, inject as $r, toRef as xn, readonly as Fr, customRef as Nr, shallowRef as Ae, watchEffect as Or, unref as I, Comment as Lr, Text as Dr, Fragment as tt, useSlots as pe, renderSlot as V, createVNode as re, createTextVNode as Co, shallowReadonly as Le, useTemplateRef as He, withDirectives as Ee, Transition as ko, normalizeStyle as Rn, useId as Ne, vModelCheckbox as To, vModelText as So, createSlots as Io, vShow as Ao, renderList as Zt, onBeforeUnmount as Rr, Teleport as Pr } from "vue";
const Hr = "groover", Vr = 1746441930, Br = {
  charts: {
    body: '<path fill="currentColor" d="M14.968 7.08q0-.215.093-.413.094-.198.265-.35.173-.152.397-.235c.148-.054.307-.082.468-.082h5.587c.324 0 .635.114.864.316.23.203.358.478.358.764s-.129.562-.358.764c-.23.203-.54.317-.864.317H16.19c-.16 0-.32-.028-.468-.082a1.2 1.2 0 01-.397-.235c-.113-.1-.203-.22-.265-.35a1 1 0 01-.093-.414m6.81 7.563H12a1.3 1.3 0 00-.864.316c-.23.203-.358.478-.358.764s.129.562.358.764c.229.203.54.317.864.317h9.778c.324 0 .635-.114.864-.317.23-.202.358-.477.358-.764 0-.286-.129-.561-.358-.764a1.3 1.3 0 00-.864-.316m0-4.36H12a1.3 1.3 0 00-.864.316c-.23.203-.358.478-.358.764s.129.562.358.764c.229.203.54.317.864.317h9.778c.324 0 .635-.114.864-.317.23-.202.358-.477.358-.764 0-.286-.129-.561-.358-.764a1.3 1.3 0 00-.864-.316M10.603 8.16H7.635v6.907c0 .58-.194 1.147-.559 1.629a3.26 3.26 0 01-1.489 1.08 3.7 3.7 0 01-1.917.167 3.47 3.47 0 01-1.698-.803 2.85 2.85 0 01-.908-1.501 2.62 2.62 0 01.189-1.695 3.04 3.04 0 011.221-1.316 3.64 3.64 0 011.844-.494c.295.004.589.043.873.116V7.08c0-.287.128-.562.358-.765S6.089 6 6.413 6h4.19c.324 0 .635.114.864.316.23.203.358.478.358.764s-.129.562-.358.764c-.229.203-.54.317-.864.317"/>',
    width: 24,
    height: 24
  },
  "groover-plus": {
    body: '<g fill="currentColor"><path fill-opacity="15.5%" d="m11.395 23.685-9.771-8.802-1.265-1.265a1.227 1.227 0 010-1.735L11.873.36c.257-.257.615-.387.978-.354l10.035.913A1.226 1.226 0 0124 2.14v9.586c0 .316-.122.62-.34.848L13.1 23.62a1.225 1.225 0 01-1.705.064"/><path d="M19.323 5.881H21.6v1.473h-2.277v2.254h-1.445V7.354H15.6V5.881h2.278V3.603h1.445zM14.222 17.74l-.258-1.225h-.032c-.725 1.048-1.901 1.5-3.303 1.5-1.547 0-2.868-.532-3.802-1.532-1.064-1.129-1.595-2.677-1.595-4.467 0-3.402 2.159-6.014 5.72-6.014 3.012 0 4.913 1.564 5.284 4.128H12.98c-.177-.742-.87-1.355-1.9-1.355-1.612 0-2.434 1.355-2.434 3.241s.935 3.29 2.562 3.29c1.225 0 1.82-.661 2.03-1.435h-1.53v-2.387h4.752v6.257z"/></g>',
    width: 24,
    height: 24
  },
  "groover-plus-logo": {
    body: '<path fill="currentColor" d="M20.55 5.32h3.321v2.147H20.55v3.283h-2.108V7.467h-3.32V5.32h3.32V2h2.108zM13.11 22.6l-.375-1.785h-.047C11.63 22.342 9.915 23 7.87 23c-2.256 0-4.182-.775-5.545-2.232C.776 19.123 0 16.868 0 14.259c0-4.957 3.148-8.763 8.341-8.763 4.394 0 7.166 2.279 7.707 6.015h-4.746c-.259-1.081-1.27-1.974-2.773-1.974-2.35 0-3.548 1.973-3.548 4.722s1.363 4.794 3.736 4.794c1.786 0 2.655-.964 2.96-2.091H9.445v-3.478h6.932v9.117z"/>',
    width: 24,
    height: 24
  },
  logo: {
    body: '<path xmlns="http://www.w3.org/2000/svg" fill="currentColor" d="M101.447 30.545c0 13.948-6.004 25.907-14.596 31.045a3 3 0 01-1.539.41h-15.73a3.03 3.03 0 01-1.539-.41c-4.795-2.869-8.789-7.881-11.375-14.162a.35.35 0 00-.67.056c-1.407 5.836-3.529 10.54-6.08 13.472a3.05 3.05 0 01-2.299 1.04H40.04a3.03 3.03 0 01-2.309-1.05c-3.224-3.73-5.765-10.33-7.052-18.411-.066-.42-.658-.4-.703.02-.815 7.662-2.41 13.995-4.431 17.792-.538 1.008-1.574 1.65-2.704 1.65h-3.499a3.05 3.05 0 01-2.697-1.626c-1.803-3.366-3.266-8.725-4.136-15.234-.056-.43-.673-.41-.714.021-.552 6.235-1.443 11.392-2.552 14.782C8.837 61.18 7.66 62 6.362 62h-.264c-1.352 0-2.53-.82-2.936-2.07C1.266 54.14 0 43.155 0 30.545c-.01-11.9 1.11-22.341 2.826-28.352A3.05 3.05 0 015.752 0h.87a3.06 3.06 0 012.937 2.203c.956 3.366 1.726 8.116 2.222 13.717.031.431.659.442.714.021.78-5.835 2.035-10.75 3.585-14.127C16.597.708 17.675 0 18.874 0h4.424c1.2 0 2.278.697 2.784 1.793 1.772 3.875 3.159 9.756 3.904 16.74.045.42.638.431.704.021 1.165-7.341 3.377-13.475 6.181-17.328A3.01 3.01 0 0139.323 0h9.042c.967 0 1.879.441 2.45 1.23 2.147 2.945 3.96 7.24 5.19 12.378a.353.353 0 00.673.056c2.299-5.58 5.697-10.15 9.791-13.121A3 3 0 0168.22 0H86.7c.627 0 1.245.179 1.75.553 7.722 5.612 13.002 16.93 13.002 29.992"/>',
    width: 101.45,
    height: 62
  },
  "opportunity-advice": {
    body: '<g fill="currentColor"><path d="M25.386 25.526a2.49 2.49 0 002.489-2.489v-9.55a2.49 2.49 0 00-2.489-2.49H12.492a2.49 2.49 0 00-2.49 2.49v9.55a2.49 2.49 0 002.49 2.49h.375v3.262c0 .23.139.444.358.53a.57.57 0 00.63-.12l3.672-3.673zm-11.358-.577a.58.58 0 00-.578-.578h-.952c-.734 0-1.334-.6-1.334-1.334v-9.55c0-.734.6-1.335 1.334-1.335h12.894c.734 0 1.334.601 1.334 1.334v9.551c0 .734-.6 1.334-1.334 1.334h-8.095a.6.6 0 00-.22.046.6.6 0 00-.19.127l-2.853 2.853v-2.442z"/><path d="M33.505 18.643H29.21a.58.58 0 00-.578.577c0 .318.26.578.578.578h4.296c.733 0 1.334.6 1.334 1.334v9.55c0 .734-.6 1.335-1.334 1.335h-.953a.58.58 0 00-.577.577v2.443l-2.853-2.853a.55.55 0 00-.19-.127.6.6 0 00-.22-.046h-8.095c-.734 0-1.334-.6-1.334-1.334v-3.823a.58.58 0 00-.578-.577.58.58 0 00-.577.577v3.823a2.49 2.49 0 002.489 2.489h7.859l3.672 3.672a.581.581 0 00.988-.41v-3.262h.375A2.49 2.49 0 0036 30.677v-9.551a2.49 2.49 0 00-2.489-2.489z"/><path d="M32.553 27.715H21.09a.58.58 0 00-.577.577c0 .318.26.578.577.578h11.463a.58.58 0 00.577-.578.58.58 0 00-.578-.577m-3.343-1.235h3.343a.58.58 0 00.578-.578.58.58 0 00-.578-.578H29.21a.58.58 0 00-.577.578c0 .317.26.577.577.577m-.001-2.385h3.343a.58.58 0 00.578-.577.58.58 0 00-.578-.578H29.21a.58.58 0 00-.577.578c0 .317.26.577.577.577M12.273 9.549a.58.58 0 00.577-.578V6.39a.58.58 0 00-.577-.577.58.58 0 00-.578.577v2.58c0 .318.26.578.578.578M7.815 7.995a.575.575 0 10-.814.814l1.825 1.825a.59.59 0 00.82 0 .575.575 0 000-.814L7.82 7.995zm.155 4.701H5.39a.58.58 0 00-.578.577c0 .318.26.578.577.578h2.582a.58.58 0 00.577-.578.58.58 0 00-.577-.577m10.971 8.748 2.223 1.172a.6.6 0 00.272.064.578.578 0 00.572-.676l-.428-2.477 1.802-1.756a.58.58 0 00-.324-.987l-2.489-.364-1.114-2.252c-.196-.393-.843-.393-1.034 0l-1.114 2.252-2.489.364a.58.58 0 00-.468.393.58.58 0 00.145.594l1.801 1.756-.427 2.477a.58.58 0 00.231.566.59.59 0 00.606.046l2.224-1.172zm-2.795-3.684 1.629-.237a.56.56 0 00.433-.318l.727-1.478.728 1.478a.58.58 0 00.433.318l1.628.237-1.178 1.149a.58.58 0 00-.167.514l.277 1.622-1.455-.768a.59.59 0 00-.537 0l-1.455.768.277-1.622a.57.57 0 00-.167-.514l-1.178-1.15z"/></g>'
  },
  "opportunity-article": {
    body: '<g fill="currentColor"><path d="M33.848 5.839H8.155A3.156 3.156 0 005.004 8.99v24.202a3.156 3.156 0 003.152 3.151h25.692A3.156 3.156 0 0037 33.194V8.99a3.16 3.16 0 00-3.152-3.152M8.155 6.899h25.691c1.153 0 2.091.94 2.091 2.092v1.48H6.064v-1.48c0-1.154.938-2.092 2.09-2.092m25.693 28.387H8.155a2.093 2.093 0 01-2.092-2.092V11.531H35.94v21.662a2.094 2.094 0 01-2.091 2.093"/><path d="M8.677 9.423h1.862a.53.53 0 100-1.06H8.677a.53.53 0 100 1.06m4.535 0h1.861a.53.53 0 100-1.06h-1.86a.53.53 0 100 1.06m4.537 0h1.861a.53.53 0 100-1.06h-1.86a.53.53 0 100 1.06m15.791 4.025H8.46a.53.53 0 00-.53.53v5.77c0 .293.238.53.53.53h25.084a.53.53 0 00.53-.53V13.98a.53.53 0 00-.532-.531m-.528 5.77H8.99v-4.71h24.022zm.528 6.017h-7.165a.53.53 0 00-.53.53v7.164c0 .293.237.53.53.53h7.165a.53.53 0 00.53-.53l.001-7.164a.53.53 0 00-.531-.53m-.529 7.166H26.91v-6.105h6.105zm.529-9.984H8.46a.53.53 0 100 1.06h25.084a.53.53 0 10-.002-1.06M22.84 25.617H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06m0 3.203H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06m0 3.199H8.46a.53.53 0 100 1.06h14.38a.53.53 0 100-1.06"/></g>'
  },
  "opportunity-audio-interview": {
    body: '<g fill="currentColor"><path d="M12.886 17.76a.66.66 0 00.065-.931 3.9 3.9 0 01-.953-2.567c0-.948.339-1.86.953-2.567a.66.66 0 10-.996-.865 5.23 5.23 0 00-1.275 3.432c0 1.267.452 2.485 1.275 3.432a.656.656 0 00.93.064zm17.203-6.93a.66.66 0 00-.995.866c.614.707.953 1.619.953 2.567s-.34 1.86-.953 2.567a.66.66 0 00.996.866 5.23 5.23 0 001.276-3.432 5.23 5.23 0 00-1.276-3.432z"/><path d="M32.094 9.114a.66.66 0 10-1.001.859 6.58 6.58 0 011.588 4.29 6.58 6.58 0 01-1.588 4.29.66.66 0 001.001.86 7.906 7.906 0 000-10.298M9.361 14.263c0-1.576.564-3.098 1.587-4.29a.66.66 0 00-1-.859 7.9 7.9 0 00-1.906 5.149c0 1.89.678 3.719 1.906 5.149a.659.659 0 101-.86 6.58 6.58 0 01-1.587-4.29zm19.571 6.952a.66.66 0 00-.659.66 4.813 4.813 0 01-4.808 4.807H18.58a4.813 4.813 0 01-4.808-4.808.659.659 0 10-1.317 0A6.133 6.133 0 0018.579 28h1.784v2.637h-3.296a1.98 1.98 0 00-1.977 1.977 1.98 1.98 0 001.977 1.978h7.91a1.98 1.98 0 001.977-1.978 1.98 1.98 0 00-1.977-1.977h-3.296V28h1.783a6.133 6.133 0 006.127-6.126.66.66 0 00-.66-.659m-3.296 11.399a.66.66 0 01-.66.659h-7.91a.66.66 0 010-1.318h7.91a.66.66 0 01.66.659"/><path d="M18.579 25.363h4.886a3.493 3.493 0 003.489-3.49V10.397a3.493 3.493 0 00-3.489-3.489h-4.887a3.493 3.493 0 00-3.488 3.49v11.477a3.493 3.493 0 003.488 3.489m0-17.139h4.886c1.198 0 2.172.974 2.172 2.17v1.125h-1.978a.659.659 0 100 1.318h1.978v2.636h-1.978a.658.658 0 100 1.317h1.978v2.637h-1.978a.659.659 0 100 1.317h1.978v1.125a2.174 2.174 0 01-2.172 2.171h-4.887a2.173 2.173 0 01-2.17-2.171v-1.125h1.978a.66.66 0 000-1.317h-1.978V16.79h1.978a.66.66 0 000-1.317h-1.978v-2.636h1.978a.66.66 0 000-1.318h-1.978v-1.124c0-1.198.974-2.17 2.17-2.17"/></g>'
  },
  "opportunity-channel": {
    body: '<g fill="currentColor" stroke="currentColor" stroke-width=".1"><path d="M6.526 29.012H35.78l.003.004h.02c.56 0 1.011-.455 1.011-1.011V8.019c0-.56-.455-1.01-1.01-1.01H6.526c-.56 0-1.01.455-1.01 1.01v19.982c0 .56.454 1.011 1.01 1.011Zm29.12-20.84v19.677H6.68V8.172z"/><path d="M17.614 22.685h.05v-.005a.6.6 0 00.24-.076l7.094-4.094a.584.584 0 000-1.008l-7.093-4.094a.584.584 0 00-.873.504v8.192c0 .21.113.4.29.504h.001a.6.6 0 00.29.077Zm.581-7.769 5.349 3.09-5.349 3.09zm-4.763 19.549H36.23a.581.581 0 100-1.163H13.432a.581.581 0 100 1.163Zm-7.335 0h3.215a.581.581 0 100-1.163H6.097a.581.581 0 100 1.163Z"/><path d="M8.734 33.883a2.64 2.64 0 002.638 2.637 2.643 2.643 0 002.638-2.637 2.643 2.643 0 00-2.638-2.638 2.643 2.643 0 00-2.638 2.638Zm1.164-.004c0-.812.661-1.474 1.474-1.474s1.474.662 1.474 1.474c0 .813-.662 1.474-1.474 1.474a1.476 1.476 0 01-1.474-1.474Z"/></g>'
  },
  "opportunity-detailed-feedback": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="M33.011 24.616A1.397 1.397 0 0034.4 23.22v-7.905a1.396 1.396 0 00-1.388-1.397H19.573a1.397 1.397 0 00-1.388 1.397V25.96c.32-.043.961-.37 1.575-.682.662-.338 1.295-.66 1.64-.66zm-5.049-5.349-3.64-2.115v4.23zm.75-.261a.303.303 0 010 .522l-4.521 2.627a.3.3 0 01-.169.052.3.3 0 01-.3-.302v-5.276a.3.3 0 01.041-.15.3.3 0 01.41-.11zm-2.12 6.215v7.275A1.503 1.503 0 0125.1 34H10.67a1.505 1.505 0 01-1.494-1.504V7.384a1.503 1.503 0 011.494-1.503h14.429a1.505 1.505 0 011.494 1.504v5.927h6.418c.546 0 1.043.225 1.403.588.362.365.586.865.586 1.414v7.906c0 .549-.224 1.049-.584 1.412a1.98 1.98 0 01-1.405.59zm-.6-11.909V7.384a.9.9 0 00-.893-.898H10.67a.9.9 0 00-.893.899v25.111a.9.9 0 00.893.9h14.429a.9.9 0 00.893-.899V25.22H21.4c-.206 0-.776.29-1.372.594-.72.368-1.476.753-1.908.753-.337 0-.537-.15-.537-.516V15.314a2 2 0 01.584-1.412c.362-.365.86-.59 1.405-.59zM15.748 9.014a.302.302 0 010-.605h4.27a.302.302 0 010 .605z"/><path fill="currentColor" fill-rule="evenodd" d="M33.778 23.995c.199-.2.32-.474.32-.776v-7.905a1.096 1.096 0 00-1.087-1.097H19.573a1.1 1.1 0 00-1.088 1.097v10.241q.113-.045.253-.109c.27-.123.577-.28.885-.436l.008-.004c.326-.167.656-.335.949-.461.282-.122.579-.229.82-.229h11.611c.299 0 .57-.123.767-.32m-15.293 1.881a1.5 1.5 0 01-.3.082V15.315a1.397 1.397 0 011.388-1.397H33.01a1.396 1.396 0 011.388 1.397v7.906a1.397 1.397 0 01-1.388 1.396H21.4c-.345 0-.978.323-1.64.66h-.001c-.458.234-.931.476-1.275.6m7.244 7.256a.9.9 0 01-.63.263H10.67a.9.9 0 01-.893-.899V7.384a.9.9 0 01.893-.898h14.429a.9.9 0 01.893.899v5.927h-6.42c-.544 0-1.042.225-1.404.59a2 2 0 00-.584 1.412v10.738c0 .366.2.516.537.516.432 0 1.187-.385 1.907-.752h.001c.596-.304 1.166-.595 1.372-.595h4.59v7.275a.9.9 0 01-.262.636m-.038-7.61v6.974a.6.6 0 01-.592.6H10.67a.6.6 0 01-.593-.599V7.383a.6.6 0 01.593-.598h14.429a.6.6 0 01.593.599v5.627h-6.12c-.629 0-1.201.26-1.617.678a2.3 2.3 0 00-.671 1.624v10.738c0 .236.066.46.24.618.17.153.39.198.597.198.284 0 .631-.12.964-.263.342-.146.718-.337 1.074-.519l.007-.003c.299-.153.584-.298.82-.406a4 4 0 01.296-.122c.076-.027.11-.032.117-.034h4.292m-1.368-9.413c.088.051 4.703 2.763 4.758 2.857a.603.603 0 01-.219.821L24.35 22.41a.602.602 0 01-.927-.505v-5.282a.6.6 0 01.08-.294m.689 5.826 4.52-2.627a.303.303 0 000-.522l-4.538-2.638a.3.3 0 00-.41.11.3.3 0 00-.041.151v5.276a.302.302 0 00.469.25m.132-6.046a.6.6 0 00-.82.22ZM9.616 33.559a1.5 1.5 0 01-.44-1.063V7.384a1.503 1.503 0 011.494-1.503h14.429a1.505 1.505 0 011.494 1.504v5.927h6.418c.546 0 1.043.225 1.403.588.362.365.586.865.586 1.414v7.906c0 .549-.224 1.049-.584 1.412a1.98 1.98 0 01-1.405.59h-6.419v7.274A1.503 1.503 0 0125.1 34H10.67c-.41 0-.783-.169-1.054-.441m17.276-8.038v6.975c0 .496-.201.947-.525 1.273a1.8 1.8 0 01-1.268.531H10.67a1.806 1.806 0 01-1.794-1.804V7.384a1.803 1.803 0 011.794-1.803h14.429a1.806 1.806 0 011.794 1.804v5.627h6.118c.63 0 1.203.26 1.616.677.415.418.673.993.673 1.625v7.906a2.3 2.3 0 01-.671 1.623 2.28 2.28 0 01-1.618.678zm-2.57-8.369v4.23l3.64-2.115zm.3.521 2.743 1.594-2.742 1.593zM15.75 9.315a.602.602 0 010-1.205h4.27a.602.602 0 010 1.205zm-.3-.602c0 .167.135.302.3.302h4.27a.302.302 0 000-.605h-4.27c-.165 0-.3.136-.3.303" clip-rule="evenodd"/><path fill="currentColor" d="M19 31a1 1 0 11-2 0 1 1 0 012 0"/></g>'
  },
  "opportunity-dj-set": {
    body: '<g fill="currentColor"><path d="M18.616 13.769a7.23 7.23 0 107.23 7.23 7.243 7.243 0 00-7.23-7.23m0 13.184a5.954 5.954 0 115.953-5.954 5.96 5.96 0 01-5.953 5.954"/><path d="M18.616 18.447a2.553 2.553 0 100 5.105 2.553 2.553 0 000-5.105m0 3.829a1.276 1.276 0 110-2.553 1.276 1.276 0 010 2.553"/><path d="M34.92 7.478h-1.972a2.086 2.086 0 00-2.08 2.086v4.352a2.08 2.08 0 002.08 2.08h.344v1.06a2.73 2.73 0 01-1.276 2.22A13.438 13.438 0 1032.138 21v-.293l.638-.383a3.83 3.83 0 001.831-3.267v-1.06h.351A2.08 2.08 0 0037 13.916V9.564a2.087 2.087 0 00-2.08-2.086M18.616 33.245A12.245 12.245 0 1130.804 20.01l-1.276.779a2.074 2.074 0 10.65 1.097l.639-.395a12.25 12.25 0 01-12.201 11.754M28.96 22.339a.804.804 0 11-1.608 0 .804.804 0 011.608 0m6.764-8.423a.81.81 0 01-.804.804h-1.972a.804.804 0 01-.804-.804V9.564a.804.804 0 01.804-.81h1.972a.81.81 0 01.804.81z"/><path d="M21.213 12.149a.639.639 0 10-.364 1.225c.602.179 1.18.427 1.723.74a.64.64 0 00.32.083.64.64 0 00.555-.32.64.64 0 00-.236-.867 9.4 9.4 0 00-1.998-.861"/><path d="M13.339 12.48a.64.64 0 00.319-.083 9.93 9.93 0 019.91 0 .64.64 0 00.867-.236.64.64 0 00-.197-.867 11.3 11.3 0 00-8.462-1.143c-.964.257-1.891.639-2.756 1.136a.638.638 0 00.319 1.187zm5.277 17.74a.638.638 0 000-1.276 7.9 7.9 0 01-3.95-1.06.639.639 0 10-.638 1.104 9.17 9.17 0 004.588 1.232"/><path d="M23.6 29.601a9.93 9.93 0 01-9.91 0 .638.638 0 00-.639 1.104c.855.497 1.771.881 2.725 1.142a11.2 11.2 0 008.462-1.142.638.638 0 00-.639-1.104"/></g>'
  },
  "opportunity-live-events": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="M35.878 22.982a.32.32 0 00.322-.323V18.1a.32.32 0 00-.322-.323h-3.223l-.334-.718c-.072-.168-.263-.227-.43-.156a1.627 1.627 0 01-2.148-.801 1.64 1.64 0 01-.048-1.256c.155-.407.442-.718.836-.898a.28.28 0 00.167-.18.3.3 0 00-.012-.25L28.764 9.39a.31.31 0 00-.43-.155L23.048 11.7h-.012L5.383 19.907a.33.33 0 00-.155.431l1.91 4.127c.071.168.262.228.43.156a1.624 1.624 0 012.147.802c.18.394.203.837.06 1.244-.143.406-.441.73-.835.92a.33.33 0 00-.155.432l1.91 4.14c.035.07.095.143.178.167.036.011.072.023.108.023a.24.24 0 00.13-.035l1.875-.874h22.892a.32.32 0 00.322-.323V26.56a.32.32 0 00-.322-.323c-.895 0-1.611-.73-1.611-1.627s.727-1.627 1.61-1.627m-24.742 8.602L9.488 28.02a2.24 2.24 0 00.883-1.125 2.3 2.3 0 00-.072-1.735 2.25 2.25 0 00-2.697-1.22l-1.647-3.565 17.067-7.956.43.921c.06.12.167.192.287.192a.24.24 0 00.13-.036c.156-.072.228-.263.156-.431l-.43-.921 4.727-2.202 1.659 3.566a2.23 2.23 0 00-.883 1.1 2.25 2.25 0 00.071 1.759 2.284 2.284 0 002.697 1.22l1.66 3.566-4.727 2.2-.43-.92a.32.32 0 00-.43-.156c-.154.072-.226.263-.154.43l.43.922zm22.486-6.975a2.27 2.27 0 001.934 2.25v3.935H14.37l14.394-6.7h.012l.012-.011 5.3-2.465c.071-.036.143-.096.166-.18a.37.37 0 00-.011-.25l-1.29-2.764h2.602v3.936a2.27 2.27 0 00-1.933 2.249"/><path fill="currentColor" d="M24.695 14.5a.31.31 0 00-.43-.155.33.33 0 00-.155.43l.56 1.22c.06.12.168.192.287.192a.24.24 0 00.131-.036.33.33 0 00.156-.43zm1.23 2.656a.31.31 0 00-.43-.156.33.33 0 00-.155.43l.56 1.221c.06.12.168.192.287.192a.24.24 0 00.131-.036.33.33 0 00.155-.431zm1.215 2.643a.32.32 0 00-.429-.156.33.33 0 00-.155.43l.56 1.221c.06.12.168.191.287.191a.24.24 0 00.132-.035.33.33 0 00.155-.431zm-7.196 2.058 1.456-2.62a.31.31 0 00-.048-.37.31.31 0 00-.37-.072l-2.71 1.256-2.04-2.201a.31.31 0 00-.37-.072.306.306 0 00-.18.335l.359 2.979-2.71 1.268a.306.306 0 00-.178.335.304.304 0 00.262.275l2.936.574.358 2.98c.012.143.12.25.263.274h.06c.119 0 .226-.06.286-.167l1.456-2.62 2.936.574a.33.33 0 00.346-.155.31.31 0 00-.047-.371zM18.63 23.33a.33.33 0 00-.346.155l-1.086 1.962-.263-2.225a.305.305 0 00-.262-.275l-2.197-.43 2.03-.946a.306.306 0 00.178-.335l-.262-2.225 1.528 1.64c.095.107.25.13.37.07l2.029-.944-1.087 1.962a.31.31 0 00.048.37l1.516 1.64z"/><path fill="currentColor" fill-rule="evenodd" d="M31.891 16.904c.167-.071.358-.012.43.156l.334.718h3.223a.32.32 0 01.322.323v4.558a.32.32 0 01-.322.323c-.883 0-1.611.73-1.611 1.627s.716 1.627 1.61 1.627c.18 0 .323.144.323.323v4.558a.32.32 0 01-.322.323H12.986l-1.874.874a.24.24 0 01-.131.035.4.4 0 01-.108-.023c-.083-.024-.143-.096-.179-.168l-1.91-4.14a.33.33 0 01.156-.43 1.624 1.624 0 00.775-2.166 1.624 1.624 0 00-2.148-.801c-.167.072-.358.012-.43-.156l-1.91-4.127a.33.33 0 01.156-.43L23.035 11.7h.012l5.288-2.464a.31.31 0 01.43.155l1.92 4.128a.3.3 0 01.013.25.28.28 0 01-.167.18c-.394.18-.68.49-.836.898-.155.406-.131.861.048 1.256a1.627 1.627 0 002.148.801m-1.966-.885a1.43 1.43 0 001.883.703l.005-.002c.25-.108.567-.025.69.258l.28.6h3.095a.52.52 0 01.522.523v4.558c0 .29-.233.523-.522.523-.772 0-1.411.64-1.411 1.427 0 .788.628 1.427 1.41 1.427.29 0 .523.233.523.523v4.558c0 .29-.233.524-.522.524H13.03l-1.822.85a.45.45 0 01-.227.059.5.5 0 01-.165-.032l-.003-.001a.5.5 0 01-.298-.27l-.003-.005-1.911-4.144a.53.53 0 01.253-.691c.348-.17.608-.453.733-.807a1.46 1.46 0 00-.054-1.094 1.424 1.424 0 00-1.883-.703l-.004.002c-.251.108-.568.025-.691-.258l-1.911-4.13a.53.53 0 01.255-.692m24.625-3.706a1.44 1.44 0 01-.042-1.1c.137-.36.386-.63.73-.786a.48.48 0 00.274-.296.5.5 0 00-.016-.397l-1.923-4.131a.51.51 0 00-.699-.254L23.003 11.5h-.012L5.3 19.725m5.073 7.17a2.23 2.23 0 01-.883 1.124l1.647 3.565 17.08-7.956-.43-.921a.33.33 0 01.155-.43.32.32 0 01.43.155l.43.92 4.726-2.2-1.66-3.566a2.284 2.284 0 01-2.697-1.22 2.25 2.25 0 01-.072-1.759c.168-.454.478-.837.884-1.1l-1.66-3.566-4.726 2.202.43.921a.33.33 0 01-.155.43.24.24 0 01-.131.037.32.32 0 01-.287-.192l-.43-.921-17.067 7.956 1.647 3.565a2.25 2.25 0 012.697 1.22 2.3 2.3 0 01.072 1.735m-2.658-3.193a2.45 2.45 0 012.768 1.374 2.5 2.5 0 01.079 1.885c-.162.45-.447.842-.82 1.125l1.492 3.231L27.95 23.53l-.347-.745a.53.53 0 01.252-.69.52.52 0 01.698.25l.345.74 4.364-2.032-1.505-3.232a2.49 2.49 0 01-2.766-1.37l-.001-.001a2.45 2.45 0 01-.078-1.914c.162-.44.447-.819.818-1.098l-1.503-3.231-4.364 2.032.348.745a.53.53 0 01-.242.685.44.44 0 01-.229.061.52.52 0 01-.465-.302l-.002-.005-.345-.74L6.22 20.471zm21.062.393h-.012l-14.394 6.7h21.186v-3.937a2.27 2.27 0 01-1.934-2.249 2.27 2.27 0 011.934-2.25v-3.935h-2.602l1.289 2.763a.37.37 0 01.011.252c-.023.083-.095.143-.167.18l-5.299 2.464zm.129.154c-.022.01-.229.122-.229.122l-13.4 6.223h20.08v-3.568a2.47 2.47 0 01-1.934-2.417c0-1.188.834-2.177 1.934-2.417v-3.568h-2.088l1.159 2.484m.02.386a.5.5 0 01-.27.303l-.005.003-5.267 2.45m-4.795-9.475a.33.33 0 01.155-.43.31.31 0 01.43.155l.549 1.22a.33.33 0 01-.156.431.24.24 0 01-.13.036.32.32 0 01-.287-.191zm1.075 1.552a.44.44 0 01-.228.06.52.52 0 01-.465-.302l-.003-.005-.563-1.226a.53.53 0 01.252-.69.51.51 0 01.7.255l.55 1.223a.53.53 0 01-.243.685m.716 2.324-.561-1.22a.33.33 0 01.155-.43.31.31 0 01.43.155l.549 1.22a.33.33 0 01-.156.43.24.24 0 01-.13.037.32.32 0 01-.287-.192m.514.331a.53.53 0 00.242-.685l-.55-1.222a.51.51 0 00-.699-.256.53.53 0 00-.252.69l.563 1.226.003.006c.088.177.26.302.465.302a.44.44 0 00.228-.06m.907.733.001.001.55 1.224a.53.53 0 01-.242.685.44.44 0 01-.228.06.52.52 0 01-.465-.301l-.003-.006-.563-1.225a.53.53 0 01.252-.69.52.52 0 01.698.252m-.611-.072a.32.32 0 01.43.155l.549 1.22a.33.33 0 01-.155.431.24.24 0 01-.132.036.32.32 0 01-.286-.191l-.561-1.22a.33.33 0 01.155-.431m-5.729-.848a.31.31 0 01.37.071c.096.096.12.252.048.371l-1.456 2.62 2.065 2.202a.306.306 0 01.047.37.33.33 0 01-.346.156l-2.936-.574-1.456 2.62a.32.32 0 01-.286.168h-.06a.305.305 0 01-.263-.276l-.358-2.979-2.936-.574a.305.305 0 01-.262-.275.306.306 0 01.179-.335l2.709-1.268-.358-2.98a.306.306 0 01.179-.334.31.31 0 01.37.072l2.04 2.2zm-2.661 1.013-1.941-2.093a.51.51 0 00-.6-.12m2.54 2.213 2.58-1.196a.51.51 0 01.598.117.51.51 0 01.075.608l-1.383 2.49 1.962 2.092a.51.51 0 01.076.614.53.53 0 01-.55.25l-.006-.001-2.794-.547-1.385 2.493a.52.52 0 01-.461.27h-.077l-.016-.002a.505.505 0 01-.429-.452l-.34-2.83-2.79-.547a.505.505 0 01-.426-.447.506.506 0 01.294-.542l2.577-1.206-.34-2.831a.506.506 0 01.294-.546m2.89 5.537 1.598.305-1.1-1.19a.51.51 0 01-.077-.61l.787-1.42-1.47.685a.51.51 0 01-.604-.118l-1.11-1.19.19 1.614a.506.506 0 01-.293.544l-1.47.685 1.59.312a.505.505 0 01.425.452l.19 1.605.788-1.425a.53.53 0 01.55-.25zm-1.47 2.314-.263-2.225a.305.305 0 00-.262-.275l-2.197-.43 2.03-.946a.306.306 0 00.178-.335l-.262-2.225 1.528 1.64c.095.107.25.13.37.07l2.029-.944-1.087 1.962a.31.31 0 00.048.37l1.516 1.64-2.196-.419a.33.33 0 00-.346.155z" clip-rule="evenodd"/><path fill="currentColor" d="M34.204 21.818c.352-.198.293-.558.22-.714l-2.388.714-3.486 2.607c1.738-.786 5.303-2.41 5.654-2.607"/></g>'
  },
  "opportunity-management-deal": {
    body: '<g fill="currentColor"><path d="M14.14 35.264h-3.533a1.735 1.735 0 01-1.767-1.766V8.767C8.84 7.765 9.606 7 10.607 7h14.132c1 0 1.766.765 1.766 1.767V12.3c0 .353-.235.588-.589.588-.353 0-.588-.235-.588-.588V8.767c0-.354-.236-.59-.59-.59h-14.13c-.354 0-.59.236-.59.59v24.73c0 .354.236.59.59.59h3.533c.353 0 .588.235.588.588 0 .354-.235.59-.588.59"/><path d="M22.972 36.442a11.183 11.183 0 01-11.188-11.188 11.183 11.183 0 0111.188-11.188A11.183 11.183 0 0134.16 25.254a11.183 11.183 0 01-11.188 11.188m0-21.198a10 10 0 00-10.01 10.01c0 5.535 4.475 10.01 10.01 10.01s10.01-4.475 10.01-10.01-4.475-10.01-10.01-10.01m-2.709-4.711h-5.24c-.825 0-1.531-.53-1.708-1.354L12.785 7h9.775l-.53 2.179c-.236.824-.942 1.354-1.767 1.354m-5.947-2.355.177.706c.059.236.294.471.589.471h5.24c.295 0 .53-.176.59-.47l.117-.707z"/><path d="M19.145 33.203a2.916 2.916 0 01-2.945-2.944 2.916 2.916 0 012.945-2.945 2.916 2.916 0 012.944 2.945 2.916 2.916 0 01-2.944 2.944m0-4.71a1.735 1.735 0 00-1.767 1.766c0 1 .766 1.766 1.767 1.766a1.735 1.735 0 001.766-1.766 1.735 1.735 0 00-1.766-1.767m7.655 1.767a2.916 2.916 0 01-2.945-2.944A2.916 2.916 0 0126.8 24.37a2.916 2.916 0 012.945 2.944 2.916 2.916 0 01-2.945 2.944m0-4.71a1.735 1.735 0 00-1.767 1.766c0 1 .765 1.766 1.766 1.766a1.735 1.735 0 001.767-1.766 1.735 1.735 0 00-1.767-1.767"/><path d="M22.089 30.259H20.91v-9.245l8.833-2.767v9.068h-1.178v-7.42l-6.477 1.944z"/></g>'
  },
  "opportunity-permanent-social-media-share": {
    body: '<g fill="currentColor"><path d="M13.089 14.625a.62.62 0 00.62-.621v-1.76c0-.932.76-1.69 1.69-1.69h4.935a.62.62 0 00.622-.622.62.62 0 00-.622-.621h-4.968a2.915 2.915 0 00-2.897 2.897v1.76c.033.38.274.657.62.657m15.045 6.52a.62.62 0 00-.621.621v9.524H13.71v-2.38a.62.62 0 00-.62-.622.62.62 0 00-.622.621v5.14a2.915 2.915 0 002.897 2.898H25.82a2.915 2.915 0 002.898-2.897l.001-12.284c0-.345-.241-.621-.586-.621M25.856 35.74H15.368c-.931 0-1.69-.76-1.69-1.69v-1.553h13.835v1.553c0 .93-.76 1.69-1.657 1.69"/><path d="M21.924 33.496H19.3a.62.62 0 00-.621.621c0 .346.276.622.621.622h2.623a.62.62 0 00.621-.622.62.62 0 00-.621-.62M34.377 5.895h-9.522a2.62 2.62 0 00-2.623 2.623v7.314a2.63 2.63 0 002.553 2.623v2.38c0 .241.138.448.38.552a.6.6 0 00.241.035c.138 0 .31-.068.414-.172l3.037-2.83h5.52A2.62 2.62 0 0037 15.799v-7.28a2.62 2.62 0 00-2.623-2.623m1.415 9.937a1.4 1.4 0 01-1.415 1.415l-5.761-.001a.64.64 0 00-.414.172l-2.208 2.035v-1.587a.62.62 0 00-.621-.622h-.553a1.4 1.4 0 01-1.415-1.415l.002-7.311a1.4 1.4 0 011.415-1.415h9.523a1.4 1.4 0 011.415 1.415l-.002 7.314zM15.816 28.527a.7.7 0 00.241-.07.61.61 0 00.346-.552v-2.139a2.63 2.63 0 002.552-2.622v-4.59a2.62 2.62 0 00-2.623-2.622l-9.487.001a2.62 2.62 0 00-2.622 2.623v4.588a2.62 2.62 0 002.622 2.622h5.556l3.037 2.623c.102.103.24.138.378.138m-.587-3.348v1.449L13.02 24.73a.52.52 0 00-.38-.137l-5.796-.002c-.793-.033-1.415-.654-1.415-1.448v-4.59a1.4 1.4 0 011.415-1.415h9.524a1.4 1.4 0 011.415 1.415l-.001 4.59a1.4 1.4 0 01-1.416 1.415h-.552c-.31 0-.586.275-.586.62"/><path d="M32.825 8.862c-.931-.655-2.347-.553-3.243.276a2.47 2.47 0 00-1.966-.725c-.725.068-1.415.449-1.83 1.035-.654.931-.517 2.45.346 3.313l3.037 3.036a.64.64 0 00.413.173.64.64 0 00.414-.173l3.14-3.14a2.47 2.47 0 00.725-1.966c-.035-.726-.415-1.382-1.036-1.83m-.518 2.966-2.725 2.692-2.623-2.623c-.448-.45-.552-1.277-.207-1.725a1.4 1.4 0 01.966-.553h.104c.345 0 .655.137.931.38l.45.449a.64.64 0 00.413.172.57.57 0 00.414-.172l.38-.38c.449-.449 1.276-.553 1.725-.208.31.242.517.553.553.967 0 .346-.138.725-.38 1.001m-24.703 8.25h8.004a.62.62 0 00.621-.622.62.62 0 00-.621-.621H7.605a.62.62 0 00-.622.621c.035.345.277.622.622.622m8.591 2.173a.62.62 0 00-.622-.621l-7.97.001a.62.62 0 00-.62.622c0 .345.276.62.62.62h8.005c.31-.034.586-.31.586-.622"/></g>'
  },
  "opportunity-publishing-deal": {
    body: '<g fill="currentColor"><path d="M21.22 33.364a6.203 6.203 0 006.199-6.199 6.203 6.203 0 00-6.199-6.199 6.203 6.203 0 00-6.199 6.2 6.2 6.2 0 006.199 6.198m0-11.27a5.08 5.08 0 015.072 5.071 5.08 5.08 0 01-5.072 5.072 5.08 5.08 0 01-5.072-5.072 5.08 5.08 0 015.072-5.071"/><path d="M9.386 19.84v15.604L8 37.163c-.276.338-.327.8-.14 1.195.185.394.58.642 1.013.642H33.58a1.12 1.12 0 001.014-.637c.192-.394.14-.85-.13-1.189l-1.408-1.78V19.84c0-.93-.761-1.69-1.691-1.69H11.077c-.93 0-1.69.76-1.69 1.69m24.198 18.033H8.874l1.363-1.69h22l1.342 1.69zM31.928 19.84v15.215H10.513V19.84c0-.31.254-.564.564-.564h20.287c.31 0 .564.254.564.564"/><path d="M19.23 29.9a.56.56 0 00.553.022l4.508-2.254a.563.563 0 000-1.003l-4.508-2.255a.57.57 0 00-.547.023.56.56 0 00-.265.479v4.508c0 .197.102.378.265.48zm.863-4.075 2.682 1.341-2.682 1.341zm1.69-11.057V6.315l.677.901.901-.676-1.69-2.254c-.215-.282-.688-.282-.902 0l-1.69 2.254.901.676.676-.901v8.453zm4.582.327 3.601-7.016.192 1.11 1.11-.191-.474-2.779a.56.56 0 00-.298-.405.54.54 0 00-.502 0l-2.536 1.234.496 1.014 1.015-.496-3.601 7.016 1.003.513zm9.991-4.255-2.79.39.159 1.115 1.115-.158-3.595 3.579.795.8 3.595-3.579-.163 1.116 1.115.164.406-2.79a.56.56 0 00-.158-.479.58.58 0 00-.479-.163zM14.982 7.042l-2.536-1.234a.555.555 0 00-.8.406l-.474 2.778 1.11.191.192-1.11 3.6 7.016 1.004-.513-3.601-7.016 1.014.496.496-1.014zm-9.378 3.956a.56.56 0 00-.157.479l.405 2.79 1.116-.164-.163-1.116 3.595 3.579.795-.8-3.596-3.579 1.116.158.158-1.116-2.79-.389a.55.55 0 00-.479.164zm24.069 21.803H30.8v1.127h-1.127zm-2.254 0h1.127v1.127h-1.127zm-15.779 0h3.381v1.127H11.64z"/></g>'
  },
  "opportunity-radio-broadcast": {
    body: '<path fill="currentColor" fill-rule="evenodd" d="M8.518 31.872A1.73 1.73 0 017 30.152V19.089a14.43 14.43 0 014.237-10.214 14.48 14.48 0 0110.23-4.231h.066c3.837 0 7.517 1.521 10.23 4.231A14.43 14.43 0 0136 19.09v11.065c0 .882-.66 1.611-1.518 1.72v2.03a.58.58 0 01-.578.576h-2.033v2.03c0 .318-.26.577-.578.577h-4.066a1.734 1.734 0 01-1.735-1.734v-8.117c0-.958.776-1.734 1.735-1.734h4.066c.319 0 .578.259.578.577v2.03h2.033c.32 0 .578.258.578.58v2a.58.58 0 00.362-.535V19.089c0-3.524-1.403-6.904-3.9-9.398a13.33 13.33 0 00-9.411-3.893h-.066c-3.53 0-6.914 1.402-9.411 3.893a13.28 13.28 0 00-3.9 9.398v11.063c0 .243.15.45.362.537v-2c0-.322.259-.58.578-.58h2.033v-2.03c0-.318.26-.577.578-.577h4.066c.959 0 1.735.776 1.735 1.734v8.117c0 .958-.776 1.734-1.735 1.734h-4.066a.58.58 0 01-.578-.577v-2.03H9.096a.58.58 0 01-.578-.577zm23.353 1.452h1.454v-4.059H31.87zm-1.158 2.609v-9.274h-3.486c-.32 0-.58.258-.58.577v8.117c0 .321.26.58.58.58zM11.13 29.265H9.675v4.059h1.454zm1.158 4.638v2.03h3.486a.58.58 0 00.58-.58v-8.117a.58.58 0 00-.58-.577h-3.486zm8.635-11.7a5.784 5.784 0 01-5.209-5.75.578.578 0 011.158 0 4.63 4.63 0 004.629 4.624 4.63 4.63 0 004.63-4.623.578.578 0 011.157 0 5.784 5.784 0 01-5.209 5.75v1.377a7.3 7.3 0 012.412.604.577.577 0 11-.465 1.059c-1.584-.692-3.273-.699-5.07.009a.579.579 0 01-.425-1.077 8.7 8.7 0 012.392-.584zm4.527-10.646v4.899a3.944 3.944 0 01-3.948 3.942H21.5a3.944 3.944 0 01-3.948-3.942v-4.899a3.944 3.944 0 013.948-3.94h.002a3.944 3.944 0 013.948 3.94m-1.158 0a2.787 2.787 0 00-2.79-2.786H21.5a2.787 2.787 0 00-2.79 2.786v4.899a2.787 2.787 0 002.79 2.786h.002a2.787 2.787 0 002.79-2.786zm-3.949 5.169a.578.578 0 110-1.156h2.327a.578.578 0 110 1.156zm.02-2.753a.579.579 0 010-1.156h2.328a.578.578 0 010 1.156zm-.02-2.754a.578.578 0 110-1.154h2.327c.32 0 .58.258.58.577s-.26.577-.58.577z" clip-rule="evenodd"/>'
  },
  "opportunity-record-deal": {
    body: '<path fill="currentColor" fill-rule="evenodd" d="m15.09 23.218 9.334-2.075v6.583a3.501 3.501 0 00-5.833 2.608c0 1.931 1.567 3.5 3.5 3.5 1.931 0 3.5-1.569 3.5-3.5v-14a.584.584 0 00-.71-.57l-10.5 2.333a.584.584 0 00-.457.57v10.225A3.501 3.501 0 008.09 31.5a3.5 3.5 0 007 0zM13.924 31.5a2.334 2.334 0 10-4.669.002 2.334 2.334 0 004.669-.002m10.5-1.167a2.334 2.334 0 10-4.669.002 2.334 2.334 0 004.669-.002m0-10.384V17.06l-9.334 2.075v2.888zm.583-11.782a7.59 7.59 0 017.583 7.583.584.584 0 001.167 0c0-4.829-3.921-8.75-8.75-8.75a.584.584 0 000 1.167m0 2.916a4.67 4.67 0 014.667 4.667.583.583 0 001.166 0 5.835 5.835 0 00-5.833-5.833.584.584 0 000 1.166m0 2.917c.966 0 1.75.784 1.75 1.75a.583.583 0 001.167 0 2.92 2.92 0 00-2.917-2.917.584.584 0 000 1.167" clip-rule="evenodd"/>'
  },
  "opportunity-share-to-my-team": {
    body: '<path fill="currentColor" d="M35.218 21.003c-.642 0-1.263.227-1.76.64a2.85 2.85 0 00-.968 1.626h-4.743c.28-.993.31-2.042.089-3.05a6.2 6.2 0 00-1.354-2.723l3.369-5.388a4.1 4.1 0 003.06.175 4.2 4.2 0 002.353-2 4.32 4.32 0 00.377-3.097 4.25 4.25 0 00-1.803-2.523 4.1 4.1 0 00-3.01-.59 4.17 4.17 0 00-2.595 1.663 4.306 4.306 0 00.677 5.764l-3.247 5.197a6.02 6.02 0 00-4.071-1.352 6.04 6.04 0 00-3.94 1.71l-3.34-3.4a3.4 3.4 0 00.844-2.286 3.4 3.4 0 00-.899-2.265 3.266 3.266 0 00-4.46-.331 3.38 3.38 0 00-1.211 2.107c-.13.833.05 1.685.508 2.387a3.3 3.3 0 001.96 1.409 3.26 3.26 0 002.38-.313l3.484 3.547a6.3 6.3 0 00-1.18 3.636 6.3 6.3 0 001.136 3.65l-6.012 3.569a4.15 4.15 0 00-2.935-.958 4.17 4.17 0 00-2.788 1.34A4.32 4.32 0 004 32.063a4.32 4.32 0 001.124 2.922 4.17 4.17 0 002.78 1.355 4.15 4.15 0 002.941-.943 4.3 4.3 0 001.517-2.732 4.34 4.34 0 00-.724-3.05l5.978-3.55a6.1 6.1 0 002.016 1.309v4.964a1.7 1.7 0 00-1.123.049c-.36.142-.661.403-.86.74a1.79 1.79 0 00.258 2.15l1.725 1.816v.34c0 .15.059.295.163.401a.55.55 0 00.394.166h8.906c.147 0 .289-.06.393-.166a.57.57 0 00.163-.4v-9.632c0-.328-.093-.65-.269-.924a1.7 1.7 0 00-.72-.627 1.64 1.64 0 00-1.794.285 1.65 1.65 0 00-.838-.408 6.2 6.2 0 001.279-1.726h5.181a2.85 2.85 0 00.72 1.396c.364.387.83.66 1.34.788a2.74 2.74 0 001.548-.063c.5-.17.941-.48 1.275-.895a2.88 2.88 0 00.359-3.006 2.8 2.8 0 00-1.027-1.18 2.75 2.75 0 00-1.487-.439m-6.68-12.748c0-.616.18-1.219.516-1.731a3.07 3.07 0 011.374-1.148 3 3 0 011.769-.177c.594.12 1.14.417 1.567.853s.72.99.838 1.595a3.17 3.17 0 01-.174 1.8 3.1 3.1 0 01-1.128 1.4 3 3 0 01-1.7.524c-.812 0-1.59-.33-2.164-.913a3.15 3.15 0 01-.898-2.203M11.84 13.638a2.2 2.2 0 01-1.237-.382 2.26 2.26 0 01-.82-1.017 2.3 2.3 0 01-.127-1.31 2.3 2.3 0 01.61-1.16 2.2 2.2 0 011.14-.62 2.2 2.2 0 011.286.129c.407.171.754.462 1 .834a2.296 2.296 0 01-.278 2.862 2.2 2.2 0 01-1.574.664m-3.618 21.53a3 3 0 01-1.7-.526 3.1 3.1 0 01-1.128-1.399 3.17 3.17 0 01-.175-1.8c.118-.604.41-1.16.838-1.595a3.05 3.05 0 011.568-.853 3 3 0 011.768.177c.56.236 1.038.635 1.374 1.148a3.156 3.156 0 01-.381 3.934 3.04 3.04 0 01-2.164.913m18.09-7.366v1.7c0 .15.058.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7a.57.57 0 01.163-.4.55.55 0 01.787 0c.105.105.163.25.163.4v9.065h-7.792a.57.57 0 00-.157-.393l-1.887-1.99a.64.64 0 01-.006-.882.62.62 0 01.865-.04l.184.248a.56.56 0 00.621.194.56.56 0 00.275-.206.57.57 0 00.105-.33v-9.066a.56.56 0 01.062-.248l.588-.299c.128.02.245.087.33.188.084.1.132.227.133.36v5.099c0 .15.058.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7a.57.57 0 01.163-.4.55.55 0 01.787 0c.105.105.163.25.163.4v1.7c0 .15.059.294.163.4a.55.55 0 00.787 0 .57.57 0 00.163-.4v-1.7c0-.15.06-.295.163-.4a.55.55 0 01.788 0 .57.57 0 01.163.4m-5.566-4.995V20.22l2.651 1.35-2.262 1.15a1.6 1.6 0 00-.39.087m3.228 3.379a1.66 1.66 0 00-1.002.013v-1.797a1.7 1.7 0 00-.431-1.13l2.35-1.192a.56.56 0 00.308-.508.57.57 0 00-.308-.507L20.438 18.8a.55.55 0 00-.734.23.6.6 0 00-.072.274v4.533q.002.105.042.2-.04.18-.042.366v1.737a5.07 5.07 0 01-2.322-2.41 5.2 5.2 0 01-.34-3.357 5.12 5.12 0 011.793-2.84 4.96 4.96 0 013.142-1.081 4.96 4.96 0 013.118 1.149 5.12 5.12 0 011.733 2.878 5.2 5.2 0 01-.41 3.35 5.06 5.06 0 01-2.372 2.358m11.244-.65c-.33 0-.654-.1-.928-.287a1.7 1.7 0 01-.615-.763 1.73 1.73 0 01.362-1.852 1.64 1.64 0 011.82-.368c.305.128.565.346.749.625a1.72 1.72 0 01-.208 2.147 1.66 1.66 0 01-1.18.497"/>'
  },
  "opportunity-spotify-playlist": {
    body: '<g fill="currentColor"><path d="M7.236 22.068a.6.6 0 01-.596-.545 5 5 0 01-.016-.42c0-6.516 5.3-11.816 11.816-11.816a.6.6 0 110 1.2c-5.852 0-10.616 4.76-10.616 10.617q-.002.154.008.308a.6.6 0 01-.54.652h-.056zM18.44 23.79a2.683 2.683 0 01-2.68-2.68 2.685 2.685 0 012.68-2.68 2.685 2.685 0 012.68 2.68 2.685 2.685 0 01-2.68 2.68m0-4.16c-.816 0-1.48.664-1.48 1.48s.664 1.48 1.48 1.48 1.48-.664 1.48-1.48-.664-1.48-1.48-1.48"/><path d="M18.446 27.374a6.276 6.276 0 01-6.268-6.268 6.276 6.276 0 016.268-6.268 6.276 6.276 0 016.268 6.268 6.276 6.276 0 01-6.268 6.268m0-11.332a5.075 5.075 0 00-5.068 5.068 5.07 5.07 0 005.068 5.068 5.07 5.07 0 005.068-5.068 5.07 5.07 0 00-5.068-5.068m7.31 18.12a.6.6 0 01-.268-1.136 13.85 13.85 0 006.604-9.588.6.6 0 01.692-.493.6.6 0 01.492.692 15.05 15.05 0 01-6.928 10.273c-.088.06-.204.132-.316.188a.6.6 0 01-.268.064z"/><path d="M18.447 36.157c-8.296 0-15.049-6.748-15.049-15.048S10.151 6.061 18.447 6.061c7.388 0 13.78 5.504 14.872 12.8a.603.603 0 01-.504.684.603.603 0 01-.684-.504c-1.004-6.716-6.888-11.78-13.684-11.78-7.636 0-13.849 6.212-13.849 13.848s6.213 13.848 13.849 13.848c1.008 0 1.992-.104 2.928-.312a.6.6 0 11.26 1.172c-1.02.228-2.096.34-3.188.34"/><path d="M26.03 34.43a.6.6 0 01-.6-.6V20.434c0-.28.196-.524.472-.584l11.976-2.64c.18-.04.364.004.504.12s.224.284.224.468v12.924a.6.6 0 11-1.2 0V18.546L26.63 20.922v12.912a.6.6 0 01-.6.6z"/><path d="M23.73 37.54c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9m0-4.6c-.936 0-1.7.764-1.7 1.7s.764 1.7 1.7 1.7 1.7-.764 1.7-1.7-.764-1.7-1.7-1.7m11.979 1.49c-1.6 0-2.9-1.301-2.9-2.901s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9m0-4.601c-.936 0-1.7.764-1.7 1.7s.764 1.7 1.7 1.7 1.7-.764 1.7-1.7-.764-1.7-1.7-1.7m-9.679-4.331a.6.6 0 01-.12-1.188l11.977-2.436a.6.6 0 01.24 1.176L26.15 25.485a.6.6 0 01-.12.012"/></g>'
  },
  "opportunity-springboard-selection": {
    body: '<g fill="currentColor"><path d="M16.468 32.811a2.461 2.461 0 01-1.74-4.197 2.459 2.459 0 111.74 4.197m0-3.851a1.39 1.39 0 00-.985 2.376 1.39 1.39 0 002.377-.985 1.394 1.394 0 00-1.392-1.391"/><path d="M18.393 30.885a.533.533 0 01-.533-.533v-8.298a.533.533 0 111.066 0v8.298a.533.533 0 01-.533.533m5.717-.45a2.458 2.458 0 110-4.916 2.458 2.458 0 010 4.916m0-3.85a1.392 1.392 0 100 2.783 1.392 1.392 0 000-2.783"/><path d="M26.035 28.51a.534.534 0 01-.534-.534v-8.298a.534.534 0 011.067 0v8.299a.533.533 0 01-.533.533"/><path d="M18.393 22.588a.534.534 0 01-.158-1.043l7.642-2.375a.534.534 0 11.316 1.018l-7.642 2.376a.5.5 0 01-.158.024m0 2.994a.532.532 0 01-.158-1.043l7.642-2.375a.533.533 0 11.316 1.018l-7.642 2.377a.6.6 0 01-.158.023m-6.104-12.049h-1.067a1.96 1.96 0 01-1.955-1.955V6.956A1.96 1.96 0 0111.222 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.955 1.955m-1.067-7.466a.89.89 0 00-.889.889v4.622a.89.89 0 00.89.889h1.066a.89.89 0 00.889-.89v-4.62a.89.89 0 00-.89-.89zm10.312 7.466h-1.067a1.96 1.96 0 01-1.956-1.955V6.956A1.96 1.96 0 0120.467 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.956 1.955m-1.067-7.466a.89.89 0 00-.89.889v4.622a.89.89 0 00.89.889h1.066a.89.89 0 00.89-.89v-4.62a.89.89 0 00-.89-.89zm10.312 7.466H29.71a1.96 1.96 0 01-1.956-1.955V6.956A1.96 1.96 0 0129.711 5h1.067a1.96 1.96 0 011.955 1.956v4.622a1.96 1.96 0 01-1.955 1.955M29.71 6.067a.89.89 0 00-.889.889v4.622a.89.89 0 00.889.889h1.067a.89.89 0 00.889-.89v-4.62a.89.89 0 00-.89-.89z"/><path d="M19.044 10.334h-5.333a.534.534 0 010-1.067h5.333a.533.533 0 010 1.067"/><path d="M35.044 37H6.956A1.96 1.96 0 015 35.045V11.223a1.96 1.96 0 011.956-1.956H9.8a.533.533 0 010 1.067H6.956a.89.89 0 00-.89.889v23.822a.89.89 0 00.89.889h28.088a.89.89 0 00.89-.89v-23.82a.89.89 0 00-.89-.89H32.2a.534.534 0 010-1.066h2.844A1.96 1.96 0 0137 11.223v23.822A1.96 1.96 0 0135.044 37"/><path d="M28.289 10.334h-5.334a.534.534 0 010-1.067h5.334a.533.533 0 010 1.067m8.178 6.222H5.533a.533.533 0 010-1.067h30.934a.533.533 0 010 1.067"/></g>'
  },
  "opportunity-sync-deal": {
    body: '<g fill="currentColor"><path d="M32.49 10.656H22.138l3.642-3.641a.594.594 0 10-.84-.84l-4.09 4.085-4.087-4.087a.594.594 0 10-.84.84l3.641 3.642H9.51c-2.95 0-5.349 2.4-5.349 5.349V32.15c0 2.95 2.4 5.35 5.35 5.35h22.98c2.95 0 5.35-2.4 5.35-5.35V16.005c0-2.95-2.4-5.35-5.35-5.35m4.161 21.495a4.165 4.165 0 01-4.16 4.16H9.509a4.165 4.165 0 01-4.16-4.16V16.005a4.165 4.165 0 014.16-4.16h22.982a4.165 4.165 0 014.16 4.16z"/><path d="M28.231 14.222H9.212c-.983 0-1.783.813-1.783 1.813v15.987c0 1 .8 1.813 1.783 1.813h19.019c.983 0 1.783-.813 1.783-1.813V16.035c0-1-.8-1.813-1.783-1.813m.594 17.8c0 .344-.266.624-.594.624H9.212c-.328 0-.594-.28-.594-.624V16.035c0-.344.266-.624.594-.624h19.019c.328 0 .594.28.594.624zm4.427-4.823c-1.148 0-2.08.933-2.08 2.08s.933 2.08 2.08 2.08 2.08-.933 2.08-2.08-.933-2.08-2.08-2.08m0 2.971a.892.892 0 11.001-1.784.892.892 0 01-.001 1.785m1.486-7.034h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.189m.001-2.774h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.189m.001-2.773h-2.972a.594.594 0 100 1.189h2.971a.594.594 0 100-1.19"/><path d="M17.788 26.982a.604.604 0 01-.602-.602v-4.32a.601.601 0 01.952-.49l3.026 2.16a.603.603 0 010 .978l-3.026 2.162a.6.6 0 01-.35.113m.602-3.755v1.983l1.389-.99z"/></g>'
  },
  "opportunity-temporary-social-media-share": {
    body: '<g fill="none"><rect/><path fill="currentColor" d="m24.369 20.283-4.474-3.217a.37.37 0 00-.378-.03.36.36 0 00-.2.319v6.433a.357.357 0 00.364.358q.116 0 .214-.069l4.474-3.216a.356.356 0 000-.578m-4.325 2.801V18.06l3.495 2.513z"/><path fill="currentColor" d="M27.853 7.19H14.147c-1.077 0-1.954.864-1.954 1.925v24.77c0 1.061.877 1.925 1.954 1.925h13.706c1.077 0 1.954-.864 1.954-1.925V9.115c0-1.061-.877-1.925-1.954-1.925m-14.934 4.324h16.162v17.914H12.919zm1.228-3.608h13.706a1.22 1.22 0 011.228 1.21v1.682H12.919V9.115c0-.667.551-1.21 1.228-1.21m13.706 27.188H14.147a1.22 1.22 0 01-1.228-1.21v-3.74h16.162v3.74a1.22 1.22 0 01-1.228 1.21"/><path fill="currentColor" d="M21 30.926c-.994 0-1.803.79-1.803 1.761s.809 1.761 1.803 1.761 1.803-.79 1.803-1.76c0-.972-.809-1.762-1.803-1.762m0 2.807c-.594 0-1.077-.47-1.077-1.046s.483-1.045 1.077-1.045 1.077.469 1.077 1.045c0 .577-.483 1.046-1.077 1.046m0-19.209c-3.397 0-6.16 2.723-6.16 6.07s2.763 6.07 6.16 6.07 6.162-2.723 6.162-6.07-2.764-6.07-6.162-6.07m0 11.425c-2.997 0-5.435-2.402-5.435-5.355 0-2.952 2.438-5.354 5.435-5.354s5.436 2.402 5.436 5.354S23.997 25.95 21 25.95"/><path fill="currentColor" fill-rule="evenodd" d="M19.517 17.036a.37.37 0 01.378.03l4.474 3.217a.356.356 0 010 .578l-4.474 3.216a.37.37 0 01-.378.03.36.36 0 01-.2-.319v-6.433a.36.36 0 01.2-.32m-.088 7.24a.55.55 0 01-.304-.488v-6.433c0-.206.117-.395.304-.489a.56.56 0 01.58.046l4.473 3.217m-4.473 4.102 4.473-3.217Zm-.58.046a.56.56 0 00.58-.046m.035-1.147 3.495-2.512-3.495-2.513zm.193-.374 2.974-2.138-2.974-2.139zM14.147 7h13.706C29.037 7 30 7.949 30 9.115v24.77C30 35.05 29.037 36 27.853 36H14.147C12.963 36 12 35.051 12 33.885V9.115C12 7.95 12.963 7 14.147 7m14.74 4.704H13.113v17.534h15.776zm-1.034-3.608H14.147c-.57 0-1.035.457-1.035 1.02v1.492h15.776V9.115a1.03 1.03 0 00-1.035-1.02M14.147 34.904h13.706c.57 0 1.035-.457 1.035-1.02v-3.55H13.112v3.55c0 .563.465 1.02 1.035 1.02m4.857-2.217c0-1.077.897-1.95 1.996-1.95 1.1 0 1.996.873 1.996 1.95 0 1.078-.897 1.951-1.996 1.951s-1.996-.873-1.996-1.95m1.112 0c0 .47.394.856.884.856s.884-.387.884-.856-.394-.855-.884-.855-.884.386-.884.855m-5.47-12.093c0-3.452 2.85-6.26 6.354-6.26s6.355 2.808 6.355 6.26-2.85 6.26-6.355 6.26c-3.504 0-6.354-2.808-6.354-6.26m1.112 0c0 2.848 2.352 5.165 5.242 5.165s5.243-2.317 5.243-5.165S23.89 15.43 21 15.43s-5.242 2.317-5.242 5.164M14.147 7.19h13.706c1.077 0 1.954.864 1.954 1.925v24.77c0 1.061-.877 1.925-1.954 1.925H14.147c-1.077 0-1.954-.864-1.954-1.925V9.115c0-1.061.877-1.925 1.954-1.925m-1.228 4.324v17.914h16.162V11.514zm14.934-3.608H14.147a1.22 1.22 0 00-1.228 1.21v1.682h16.162V9.115a1.22 1.22 0 00-1.228-1.21M14.147 35.094h13.706a1.22 1.22 0 001.228-1.21v-3.74H12.919v3.74c0 .668.551 1.21 1.228 1.21M21 30.926c-.994 0-1.803.79-1.803 1.761s.809 1.761 1.803 1.761 1.803-.79 1.803-1.76c0-.972-.809-1.762-1.803-1.762m0 2.807c-.594 0-1.077-.47-1.077-1.046s.483-1.045 1.077-1.045 1.077.469 1.077 1.045c0 .577-.483 1.046-1.077 1.046m-6.16-13.139c0-3.347 2.763-6.07 6.16-6.07s6.162 2.723 6.162 6.07-2.764 6.07-6.162 6.07c-3.397 0-6.16-2.723-6.16-6.07m.725 0c0 2.953 2.438 5.355 5.435 5.355s5.436-2.402 5.436-5.355c0-2.952-2.439-5.354-5.436-5.354s-5.435 2.402-5.435 5.354" clip-rule="evenodd"/><path fill="currentColor" d="M24.709 20.772c.18-.412-.299-.706-.478-.824-.18-.118-4.603 4.004-4.603 4.004l-.21.324.569-.03c1.415-1.03 4.423-2.973 4.722-3.474"/></g>'
  },
  "smile-meter-0": {
    body: '<path fill="currentColor" d="M12.813 15.89c-.391.352-.977.352-1.329-.038A1.97 1.97 0 0010 15.187c-.742 0-1.25.352-1.523.665-.352.39-.938.39-1.329.039-.39-.352-.39-.938-.039-1.328A3.94 3.94 0 0110 13.313c1.328 0 2.305.664 2.852 1.25.351.39.351.976-.04 1.328M5.625 9.876c0-.312.117-.625.352-.86l-1.211-.39c-.313-.117-.47-.469-.391-.82a.654.654 0 01.82-.39l3.75 1.25c.313.116.47.468.39.82-.116.312-.468.468-.82.39l-.39-.156v.156c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25m8.75 0c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25V9.72l-.43.156c-.351.078-.703-.078-.82-.39-.078-.352.078-.704.39-.82l3.75-1.25a.654.654 0 01.82.39c.08.351-.077.703-.39.82l-1.21.39c.234.196.39.547.39.86M0 10.5C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10 0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10m10 8.125c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625"/>',
    width: 20,
    height: 21
  },
  "smile-meter-1": {
    body: '<path fill="currentColor" d="M5.586 16.086c-.469-.156-.742-.703-.547-1.211C5.703 13 7.734 11.75 10 11.75c2.227 0 4.258 1.25 4.922 3.125.195.508-.078 1.055-.547 1.21-.508.196-1.055-.077-1.21-.546-.352-1.016-1.563-1.914-3.165-1.914-1.64 0-2.852.898-3.203 1.914-.156.469-.703.742-1.211.547m2.539-7.461c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m3.75 0c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  },
  "smile-meter-2": {
    body: '<path fill="currentColor" d="M5.625 8.625c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25m8.75 0c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m-1.562 4.688a.95.95 0 01.937.937c0 .547-.43.938-.937.938H7.187c-.546 0-.937-.391-.937-.938 0-.508.39-.937.938-.937zM20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10m-10 8.125c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625"/>',
    width: 20,
    height: 21
  },
  "smile-meter-3": {
    body: '<path fill="currentColor" d="M10 14.25c1.445 0 2.46-.664 3.047-1.29a.933.933 0 011.328-.077c.39.351.39.937.04 1.328A5.93 5.93 0 0110 16.125c-2.11 0-3.594-.977-4.453-1.914-.352-.39-.352-.977.039-1.328a.933.933 0 011.328.078C7.5 13.586 8.516 14.25 10 14.25M8.125 8.625c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25m3.75 0c0-.664.547-1.25 1.25-1.25s1.25.586 1.25 1.25c0 .703-.547 1.25-1.25 1.25s-1.25-.547-1.25-1.25M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  },
  "smile-meter-4": {
    body: '<path fill="currentColor" d="M13.633 12.57c.742-.195 1.406.47.976 1.094-.937 1.484-2.656 2.461-4.648 2.461-1.953 0-3.672-.977-4.648-2.46-.391-.626.273-1.29 1.015-1.095 1.133.274 2.344.39 3.633.39 1.328 0 2.539-.116 3.672-.39M8.477 9.445s0-.039-.04-.039q0-.058-.117-.117c-.078-.117-.234-.273-.39-.43-.352-.273-.742-.546-1.055-.546-.352 0-.742.273-1.094.546-.156.157-.312.313-.39.43q-.118.06-.118.117c-.039 0-.039.04-.039.04a.315.315 0 01-.351.117c-.117-.04-.195-.157-.195-.313 0-.664.234-1.367.625-1.875.39-.508.937-.937 1.562-.937.586 0 1.133.43 1.523.937.391.508.665 1.21.665 1.875a.34.34 0 01-.235.313.315.315 0 01-.351-.118m6.25 0s0-.039-.04-.039q0-.058-.117-.117c-.078-.117-.234-.273-.39-.43-.352-.273-.742-.546-1.055-.546-.352 0-.742.273-1.094.546-.156.157-.312.313-.39.43q-.118.06-.118.117c-.039 0-.039.04-.039.04a.315.315 0 01-.351.117c-.117-.04-.195-.157-.195-.313 0-.664.234-1.367.624-1.875.391-.508.938-.937 1.563-.937.586 0 1.133.43 1.523.937.391.508.665 1.21.665 1.875a.34.34 0 01-.235.313.315.315 0 01-.351-.118M20 10.5c0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10C0 4.992 4.453.5 10 .5c5.508 0 10 4.492 10 10M10 2.375c-4.492 0-8.125 3.672-8.125 8.125A8.12 8.12 0 0010 18.625c4.453 0 8.125-3.633 8.125-8.125 0-4.453-3.672-8.125-8.125-8.125"/>',
    width: 20,
    height: 21
  }
}, jr = 42, Ur = 42, Wr = {
  prefix: Hr,
  lastModified: Vr,
  icons: Br,
  width: jr,
  height: Ur
};
/**
* (c) Iconify
*
* For the full copyright and license information, please view the license.txt
* files at https://github.com/iconify/iconify
*
* Licensed under MIT.
*
* @license MIT
* @version 2.1.0
*/
const Eo = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), xt = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), st = Object.freeze({
  ...Eo,
  ...xt
}), Jt = Object.freeze({
  ...st,
  body: "",
  hidden: !1
}), _r = Object.freeze({
  width: null,
  height: null
}), zo = Object.freeze({
  // Dimensions
  ..._r,
  // Transformations
  ...xt
});
function Kr(e, t = 0) {
  const n = e.replace(/^-?[0-9.]*/, "");
  function o(r) {
    for (; r < 0; )
      r += 4;
    return r % 4;
  }
  if (n === "") {
    const r = parseInt(e);
    return isNaN(r) ? 0 : o(r);
  } else if (n !== e) {
    let r = 0;
    switch (n) {
      case "%":
        r = 25;
        break;
      case "deg":
        r = 90;
    }
    if (r) {
      let a = parseFloat(e.slice(0, e.length - n.length));
      return isNaN(a) ? 0 : (a = a / r, a % 1 === 0 ? o(a) : 0);
    }
  }
  return t;
}
const qr = /[\s,]+/;
function Gr(e, t) {
  t.split(qr).forEach((n) => {
    switch (n.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
const Mo = {
  ...zo,
  preserveAspectRatio: ""
};
function Pn(e) {
  const t = {
    ...Mo
  }, n = (o, r) => e.getAttribute(o) || r;
  return t.width = n("width", null), t.height = n("height", null), t.rotate = Kr(n("rotate", "")), Gr(t, n("flip", "")), t.preserveAspectRatio = n("preserveAspectRatio", n("preserveaspectratio", "")), t;
}
function Qr(e, t) {
  for (const n in Mo)
    if (e[n] !== t[n])
      return !0;
  return !1;
}
const Ze = /^[a-z0-9]+(-[a-z0-9]+)*$/, lt = (e, t, n, o = "") => {
  const r = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (r.length < 2 || r.length > 3)
      return null;
    o = r.shift().slice(1);
  }
  if (r.length > 3 || !r.length)
    return null;
  if (r.length > 1) {
    const s = r.pop(), l = r.pop(), c = {
      // Allow provider without '@': "provider:prefix:name"
      provider: r.length > 0 ? r[0] : o,
      prefix: l,
      name: s
    };
    return t && !bt(c) ? null : c;
  }
  const a = r[0], i = a.split("-");
  if (i.length > 1) {
    const s = {
      provider: o,
      prefix: i.shift(),
      name: i.join("-")
    };
    return t && !bt(s) ? null : s;
  }
  if (n && o === "") {
    const s = {
      provider: o,
      prefix: "",
      name: a
    };
    return t && !bt(s, n) ? null : s;
  }
  return null;
}, bt = (e, t) => e ? !!((e.provider === "" || e.provider.match(Ze)) && (t && e.prefix === "" || e.prefix.match(Ze)) && e.name.match(Ze)) : !1;
function Yr(e, t) {
  const n = {};
  !e.hFlip != !t.hFlip && (n.hFlip = !0), !e.vFlip != !t.vFlip && (n.vFlip = !0);
  const o = ((e.rotate || 0) + (t.rotate || 0)) % 4;
  return o && (n.rotate = o), n;
}
function Hn(e, t) {
  const n = Yr(e, t);
  for (const o in Jt)
    o in xt ? o in e && !(o in n) && (n[o] = xt[o]) : o in t ? n[o] = t[o] : o in e && (n[o] = e[o]);
  return n;
}
function Xr(e, t) {
  const n = e.icons, o = e.aliases || /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  function a(i) {
    if (n[i])
      return r[i] = [];
    if (!(i in r)) {
      r[i] = null;
      const s = o[i] && o[i].parent, l = s && a(s);
      l && (r[i] = [s].concat(l));
    }
    return r[i];
  }
  return Object.keys(n).concat(Object.keys(o)).forEach(a), r;
}
function Zr(e, t, n) {
  const o = e.icons, r = e.aliases || /* @__PURE__ */ Object.create(null);
  let a = {};
  function i(s) {
    a = Hn(
      o[s] || r[s],
      a
    );
  }
  return i(t), n.forEach(i), Hn(e, a);
}
function $o(e, t) {
  const n = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return n;
  e.not_found instanceof Array && e.not_found.forEach((r) => {
    t(r, null), n.push(r);
  });
  const o = Xr(e);
  for (const r in o) {
    const a = o[r];
    a && (t(r, Zr(e, r, a)), n.push(r));
  }
  return n;
}
const Jr = {
  provider: "",
  aliases: {},
  not_found: {},
  ...Eo
};
function Bt(e, t) {
  for (const n in t)
    if (n in e && typeof e[n] != typeof t[n])
      return !1;
  return !0;
}
function Fo(e) {
  if (typeof e != "object" || e === null)
    return null;
  const t = e;
  if (typeof t.prefix != "string" || !e.icons || typeof e.icons != "object" || !Bt(e, Jr))
    return null;
  const n = t.icons;
  for (const r in n) {
    const a = n[r];
    if (!r.match(Ze) || typeof a.body != "string" || !Bt(
      a,
      Jt
    ))
      return null;
  }
  const o = t.aliases || /* @__PURE__ */ Object.create(null);
  for (const r in o) {
    const a = o[r], i = a.parent;
    if (!r.match(Ze) || typeof i != "string" || !n[i] && !o[i] || !Bt(
      a,
      Jt
    ))
      return null;
  }
  return t;
}
const Ct = /* @__PURE__ */ Object.create(null);
function ea(e, t) {
  return {
    provider: e,
    prefix: t,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function be(e, t) {
  const n = Ct[e] || (Ct[e] = /* @__PURE__ */ Object.create(null));
  return n[t] || (n[t] = ea(e, t));
}
function Cn(e, t) {
  return Fo(t) ? $o(t, (n, o) => {
    o ? e.icons[n] = o : e.missing.add(n);
  }) : [];
}
function ta(e, t, n) {
  try {
    if (typeof n.body == "string")
      return e.icons[t] = { ...n }, !0;
  } catch {
  }
  return !1;
}
function na(e, t) {
  let n = [];
  return (typeof e == "string" ? [e] : Object.keys(Ct)).forEach((r) => {
    (typeof r == "string" && typeof t == "string" ? [t] : Object.keys(Ct[r] || {})).forEach((i) => {
      const s = be(r, i);
      n = n.concat(
        Object.keys(s.icons).map(
          (l) => (r !== "" ? "@" + r + ":" : "") + i + ":" + l
        )
      );
    });
  }), n;
}
let nt = !1;
function No(e) {
  return typeof e == "boolean" && (nt = e), nt;
}
function ot(e) {
  const t = typeof e == "string" ? lt(e, !0, nt) : e;
  if (t) {
    const n = be(t.provider, t.prefix), o = t.name;
    return n.icons[o] || (n.missing.has(o) ? null : void 0);
  }
}
function Oo(e, t) {
  const n = lt(e, !0, nt);
  if (!n)
    return !1;
  const o = be(n.provider, n.prefix);
  return ta(o, n.name, t);
}
function Vn(e, t) {
  if (typeof e != "object")
    return !1;
  if (typeof t != "string" && (t = e.provider || ""), nt && !t && !e.prefix) {
    let r = !1;
    return Fo(e) && (e.prefix = "", $o(e, (a, i) => {
      i && Oo(a, i) && (r = !0);
    })), r;
  }
  const n = e.prefix;
  if (!bt({
    provider: t,
    prefix: n,
    name: "a"
  }))
    return !1;
  const o = be(t, n);
  return !!Cn(o, e);
}
function Bn(e) {
  return !!ot(e);
}
function oa(e) {
  const t = ot(e);
  return t ? {
    ...st,
    ...t
  } : null;
}
function ra(e) {
  const t = {
    loaded: [],
    missing: [],
    pending: []
  }, n = /* @__PURE__ */ Object.create(null);
  e.sort((r, a) => r.provider !== a.provider ? r.provider.localeCompare(a.provider) : r.prefix !== a.prefix ? r.prefix.localeCompare(a.prefix) : r.name.localeCompare(a.name));
  let o = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((r) => {
    if (o.name === r.name && o.prefix === r.prefix && o.provider === r.provider)
      return;
    o = r;
    const a = r.provider, i = r.prefix, s = r.name, l = n[a] || (n[a] = /* @__PURE__ */ Object.create(null)), c = l[i] || (l[i] = be(a, i));
    let d;
    s in c.icons ? d = t.loaded : i === "" || c.missing.has(s) ? d = t.missing : d = t.pending;
    const u = {
      provider: a,
      prefix: i,
      name: s
    };
    d.push(u);
  }), t;
}
function Lo(e, t) {
  e.forEach((n) => {
    const o = n.loaderCallbacks;
    o && (n.loaderCallbacks = o.filter((r) => r.id !== t));
  });
}
function aa(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const t = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!t.length)
      return;
    let n = !1;
    const o = e.provider, r = e.prefix;
    t.forEach((a) => {
      const i = a.icons, s = i.pending.length;
      i.pending = i.pending.filter((l) => {
        if (l.prefix !== r)
          return !0;
        const c = l.name;
        if (e.icons[c])
          i.loaded.push({
            provider: o,
            prefix: r,
            name: c
          });
        else if (e.missing.has(c))
          i.missing.push({
            provider: o,
            prefix: r,
            name: c
          });
        else
          return n = !0, !0;
        return !1;
      }), i.pending.length !== s && (n || Lo([e], a.id), a.callback(
        i.loaded.slice(0),
        i.missing.slice(0),
        i.pending.slice(0),
        a.abort
      ));
    });
  }));
}
let ia = 0;
function sa(e, t, n) {
  const o = ia++, r = Lo.bind(null, n, o);
  if (!t.pending.length)
    return r;
  const a = {
    id: o,
    icons: t,
    callback: e,
    abort: r
  };
  return n.forEach((i) => {
    (i.loaderCallbacks || (i.loaderCallbacks = [])).push(a);
  }), r;
}
const en = /* @__PURE__ */ Object.create(null);
function jn(e, t) {
  en[e] = t;
}
function tn(e) {
  return en[e] || en[""];
}
function la(e, t = !0, n = !1) {
  const o = [];
  return e.forEach((r) => {
    const a = typeof r == "string" ? lt(r, t, n) : r;
    a && o.push(a);
  }), o;
}
var ca = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function ua(e, t, n, o) {
  const r = e.resources.length, a = e.random ? Math.floor(Math.random() * r) : e.index;
  let i;
  if (e.random) {
    let z = e.resources.slice(0);
    for (i = []; z.length > 1; ) {
      const $ = Math.floor(Math.random() * z.length);
      i.push(z[$]), z = z.slice(0, $).concat(z.slice($ + 1));
    }
    i = i.concat(z);
  } else
    i = e.resources.slice(a).concat(e.resources.slice(0, a));
  const s = Date.now();
  let l = "pending", c = 0, d, u = null, f = [], h = [];
  typeof o == "function" && h.push(o);
  function m() {
    u && (clearTimeout(u), u = null);
  }
  function y() {
    l === "pending" && (l = "aborted"), m(), f.forEach((z) => {
      z.status === "pending" && (z.status = "aborted");
    }), f = [];
  }
  function w(z, $) {
    $ && (h = []), typeof z == "function" && h.push(z);
  }
  function p() {
    return {
      startTime: s,
      payload: t,
      status: l,
      queriesSent: c,
      queriesPending: f.length,
      subscribe: w,
      abort: y
    };
  }
  function x() {
    l = "failed", h.forEach((z) => {
      z(void 0, d);
    });
  }
  function k() {
    f.forEach((z) => {
      z.status === "pending" && (z.status = "aborted");
    }), f = [];
  }
  function T(z, $, U) {
    const W = $ !== "success";
    switch (f = f.filter((Q) => Q !== z), l) {
      case "pending":
        break;
      case "failed":
        if (W || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if ($ === "abort") {
      d = U, x();
      return;
    }
    if (W) {
      d = U, f.length || (i.length ? F() : x());
      return;
    }
    if (m(), k(), !e.random) {
      const Q = e.resources.indexOf(z.resource);
      Q !== -1 && Q !== e.index && (e.index = Q);
    }
    l = "completed", h.forEach((Q) => {
      Q(U);
    });
  }
  function F() {
    if (l !== "pending")
      return;
    m();
    const z = i.shift();
    if (z === void 0) {
      if (f.length) {
        u = setTimeout(() => {
          m(), l === "pending" && (k(), x());
        }, e.timeout);
        return;
      }
      x();
      return;
    }
    const $ = {
      status: "pending",
      resource: z,
      callback: (U, W) => {
        T($, U, W);
      }
    };
    f.push($), c++, u = setTimeout(F, e.rotate), n(z, t, $.callback);
  }
  return setTimeout(F), p;
}
function Do(e) {
  const t = {
    ...ca,
    ...e
  };
  let n = [];
  function o() {
    n = n.filter((s) => s().status === "pending");
  }
  function r(s, l, c) {
    const d = ua(
      t,
      s,
      l,
      (u, f) => {
        o(), c && c(u, f);
      }
    );
    return n.push(d), d;
  }
  function a(s) {
    return n.find((l) => s(l)) || null;
  }
  return {
    query: r,
    find: a,
    setIndex: (s) => {
      t.index = s;
    },
    getIndex: () => t.index,
    cleanup: o
  };
}
function kn(e) {
  let t;
  if (typeof e.resources == "string")
    t = [e.resources];
  else if (t = e.resources, !(t instanceof Array) || !t.length)
    return null;
  return {
    // API hosts
    resources: t,
    // Root path
    path: e.path || "/",
    // URL length limit
    maxURL: e.maxURL || 500,
    // Timeout before next host is used.
    rotate: e.rotate || 750,
    // Timeout before failing query.
    timeout: e.timeout || 5e3,
    // Randomise default API end point.
    random: e.random === !0,
    // Start index
    index: e.index || 0,
    // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const Ft = /* @__PURE__ */ Object.create(null), Ge = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], gt = [];
for (; Ge.length > 0; )
  Ge.length === 1 || Math.random() > 0.5 ? gt.push(Ge.shift()) : gt.push(Ge.pop());
Ft[""] = kn({
  resources: ["https://api.iconify.design"].concat(gt)
});
function Un(e, t) {
  const n = kn(t);
  return n === null ? !1 : (Ft[e] = n, !0);
}
function Nt(e) {
  return Ft[e];
}
function da() {
  return Object.keys(Ft);
}
function Wn() {
}
const jt = /* @__PURE__ */ Object.create(null);
function fa(e) {
  if (!jt[e]) {
    const t = Nt(e);
    if (!t)
      return;
    const n = Do(t), o = {
      config: t,
      redundancy: n
    };
    jt[e] = o;
  }
  return jt[e];
}
function Ro(e, t, n) {
  let o, r;
  if (typeof e == "string") {
    const a = tn(e);
    if (!a)
      return n(void 0, 424), Wn;
    r = a.send;
    const i = fa(e);
    i && (o = i.redundancy);
  } else {
    const a = kn(e);
    if (a) {
      o = Do(a);
      const i = e.resources ? e.resources[0] : "", s = tn(i);
      s && (r = s.send);
    }
  }
  return !o || !r ? (n(void 0, 424), Wn) : o.query(t, r, n)().abort;
}
const _n = "iconify2", rt = "iconify", Po = rt + "-count", Kn = rt + "-version", Ho = 36e5, ha = 168, ma = 50;
function nn(e, t) {
  try {
    return e.getItem(t);
  } catch {
  }
}
function Tn(e, t, n) {
  try {
    return e.setItem(t, n), !0;
  } catch {
  }
}
function qn(e, t) {
  try {
    e.removeItem(t);
  } catch {
  }
}
function on(e, t) {
  return Tn(e, Po, t.toString());
}
function rn(e) {
  return parseInt(nn(e, Po)) || 0;
}
const Te = {
  local: !0,
  session: !0
}, Vo = {
  local: /* @__PURE__ */ new Set(),
  session: /* @__PURE__ */ new Set()
};
let Sn = !1;
function pa(e) {
  Sn = e;
}
let dt = typeof window > "u" ? {} : window;
function Bo(e) {
  const t = e + "Storage";
  try {
    if (dt && dt[t] && typeof dt[t].length == "number")
      return dt[t];
  } catch {
  }
  Te[e] = !1;
}
function jo(e, t) {
  const n = Bo(e);
  if (!n)
    return;
  const o = nn(n, Kn);
  if (o !== _n) {
    if (o) {
      const s = rn(n);
      for (let l = 0; l < s; l++)
        qn(n, rt + l.toString());
    }
    Tn(n, Kn, _n), on(n, 0);
    return;
  }
  const r = Math.floor(Date.now() / Ho) - ha, a = (s) => {
    const l = rt + s.toString(), c = nn(n, l);
    if (typeof c == "string") {
      try {
        const d = JSON.parse(c);
        if (typeof d == "object" && typeof d.cached == "number" && d.cached > r && typeof d.provider == "string" && typeof d.data == "object" && typeof d.data.prefix == "string" && // Valid item: run callback
        t(d, s))
          return !0;
      } catch {
      }
      qn(n, l);
    }
  };
  let i = rn(n);
  for (let s = i - 1; s >= 0; s--)
    a(s) || (s === i - 1 ? (i--, on(n, i)) : Vo[e].add(s));
}
function Uo() {
  if (!Sn) {
    pa(!0);
    for (const e in Te)
      jo(e, (t) => {
        const n = t.data, o = t.provider, r = n.prefix, a = be(
          o,
          r
        );
        if (!Cn(a, n).length)
          return !1;
        const i = n.lastModified || -1;
        return a.lastModifiedCached = a.lastModifiedCached ? Math.min(a.lastModifiedCached, i) : i, !0;
      });
  }
}
function va(e, t) {
  const n = e.lastModifiedCached;
  if (
    // Matches or newer
    n && n >= t
  )
    return n === t;
  if (e.lastModifiedCached = t, n)
    for (const o in Te)
      jo(o, (r) => {
        const a = r.data;
        return r.provider !== e.provider || a.prefix !== e.prefix || a.lastModified === t;
      });
  return !0;
}
function wa(e, t) {
  Sn || Uo();
  function n(o) {
    let r;
    if (!Te[o] || !(r = Bo(o)))
      return;
    const a = Vo[o];
    let i;
    if (a.size)
      a.delete(i = Array.from(a).shift());
    else if (i = rn(r), i >= ma || !on(r, i + 1))
      return;
    const s = {
      cached: Math.floor(Date.now() / Ho),
      provider: e.provider,
      data: t
    };
    return Tn(
      r,
      rt + i.toString(),
      JSON.stringify(s)
    );
  }
  t.lastModified && !va(e, t.lastModified) || Object.keys(t.icons).length && (t.not_found && (t = Object.assign({}, t), delete t.not_found), n("local") || n("session"));
}
function Gn() {
}
function ba(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, aa(e);
  }));
}
function ga(e, t) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(t).sort() : e.iconsToLoad = t, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: n, prefix: o } = e, r = e.iconsToLoad;
    delete e.iconsToLoad;
    let a;
    if (!r || !(a = tn(n)))
      return;
    a.prepare(n, o, r).forEach((s) => {
      Ro(n, s, (l) => {
        if (typeof l != "object")
          s.icons.forEach((c) => {
            e.missing.add(c);
          });
        else
          try {
            const c = Cn(
              e,
              l
            );
            if (!c.length)
              return;
            const d = e.pendingIcons;
            d && c.forEach((u) => {
              d.delete(u);
            }), wa(e, l);
          } catch (c) {
            console.error(c);
          }
        ba(e);
      });
    });
  }));
}
const In = (e, t) => {
  const n = la(e, !0, No()), o = ra(n);
  if (!o.pending.length) {
    let l = !0;
    return t && setTimeout(() => {
      l && t(
        o.loaded,
        o.missing,
        o.pending,
        Gn
      );
    }), () => {
      l = !1;
    };
  }
  const r = /* @__PURE__ */ Object.create(null), a = [];
  let i, s;
  return o.pending.forEach((l) => {
    const { provider: c, prefix: d } = l;
    if (d === s && c === i)
      return;
    i = c, s = d, a.push(be(c, d));
    const u = r[c] || (r[c] = /* @__PURE__ */ Object.create(null));
    u[d] || (u[d] = []);
  }), o.pending.forEach((l) => {
    const { provider: c, prefix: d, name: u } = l, f = be(c, d), h = f.pendingIcons || (f.pendingIcons = /* @__PURE__ */ new Set());
    h.has(u) || (h.add(u), r[c][d].push(u));
  }), a.forEach((l) => {
    const { provider: c, prefix: d } = l;
    r[c][d].length && ga(l, r[c][d]);
  }), t ? sa(t, o, a) : Gn;
}, ya = (e) => new Promise((t, n) => {
  const o = typeof e == "string" ? lt(e, !0) : e;
  if (!o) {
    n(e);
    return;
  }
  In([o || e], (r) => {
    if (r.length && o) {
      const a = ot(o);
      if (a) {
        t({
          ...st,
          ...a
        });
        return;
      }
    }
    n(e);
  });
});
function xa(e) {
  try {
    const t = typeof e == "string" ? JSON.parse(e) : e;
    if (typeof t.body == "string")
      return {
        ...t
      };
  } catch {
  }
}
function Ca(e, t) {
  const n = typeof e == "string" ? lt(e, !0, !0) : null;
  if (!n) {
    const a = xa(e);
    return {
      value: e,
      data: a
    };
  }
  const o = ot(n);
  if (o !== void 0 || !n.prefix)
    return {
      value: e,
      name: n,
      data: o
      // could be 'null' -> icon is missing
    };
  const r = In([n], () => t(e, n, ot(n)));
  return {
    value: e,
    name: n,
    loading: r
  };
}
let Wo = !1;
try {
  Wo = navigator.vendor.indexOf("Apple") === 0;
} catch {
}
function ka(e, t) {
  switch (t) {
    case "svg":
    case "bg":
    case "mask":
      return t;
  }
  return t !== "style" && (Wo || e.indexOf("<a") === -1) ? "svg" : e.indexOf("currentColor") === -1 ? "bg" : "mask";
}
const Ta = /(-?[0-9.]*[0-9]+[0-9.]*)/g, Sa = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function an(e, t, n) {
  if (t === 1)
    return e;
  if (n = n || 100, typeof e == "number")
    return Math.ceil(e * t * n) / n;
  if (typeof e != "string")
    return e;
  const o = e.split(Ta);
  if (o === null || !o.length)
    return e;
  const r = [];
  let a = o.shift(), i = Sa.test(a);
  for (; ; ) {
    if (i) {
      const s = parseFloat(a);
      isNaN(s) ? r.push(a) : r.push(Math.ceil(s * t * n) / n);
    } else
      r.push(a);
    if (a = o.shift(), a === void 0)
      return r.join("");
    i = !i;
  }
}
function Ia(e, t = "defs") {
  let n = "";
  const o = e.indexOf("<" + t);
  for (; o >= 0; ) {
    const r = e.indexOf(">", o), a = e.indexOf("</" + t);
    if (r === -1 || a === -1)
      break;
    const i = e.indexOf(">", a);
    if (i === -1)
      break;
    n += e.slice(r + 1, a).trim(), e = e.slice(0, o).trim() + e.slice(i + 1);
  }
  return {
    defs: n,
    content: e
  };
}
function Aa(e, t) {
  return e ? "<defs>" + e + "</defs>" + t : t;
}
function Ea(e, t, n) {
  const o = Ia(e);
  return Aa(o.defs, t + o.content + n);
}
const za = (e) => e === "unset" || e === "undefined" || e === "none";
function _o(e, t) {
  const n = {
    ...st,
    ...e
  }, o = {
    ...zo,
    ...t
  }, r = {
    left: n.left,
    top: n.top,
    width: n.width,
    height: n.height
  };
  let a = n.body;
  [n, o].forEach((y) => {
    const w = [], p = y.hFlip, x = y.vFlip;
    let k = y.rotate;
    p ? x ? k += 2 : (w.push(
      "translate(" + (r.width + r.left).toString() + " " + (0 - r.top).toString() + ")"
    ), w.push("scale(-1 1)"), r.top = r.left = 0) : x && (w.push(
      "translate(" + (0 - r.left).toString() + " " + (r.height + r.top).toString() + ")"
    ), w.push("scale(1 -1)"), r.top = r.left = 0);
    let T;
    switch (k < 0 && (k -= Math.floor(k / 4) * 4), k = k % 4, k) {
      case 1:
        T = r.height / 2 + r.top, w.unshift(
          "rotate(90 " + T.toString() + " " + T.toString() + ")"
        );
        break;
      case 2:
        w.unshift(
          "rotate(180 " + (r.width / 2 + r.left).toString() + " " + (r.height / 2 + r.top).toString() + ")"
        );
        break;
      case 3:
        T = r.width / 2 + r.left, w.unshift(
          "rotate(-90 " + T.toString() + " " + T.toString() + ")"
        );
        break;
    }
    k % 2 === 1 && (r.left !== r.top && (T = r.left, r.left = r.top, r.top = T), r.width !== r.height && (T = r.width, r.width = r.height, r.height = T)), w.length && (a = Ea(
      a,
      '<g transform="' + w.join(" ") + '">',
      "</g>"
    ));
  });
  const i = o.width, s = o.height, l = r.width, c = r.height;
  let d, u;
  i === null ? (u = s === null ? "1em" : s === "auto" ? c : s, d = an(u, l / c)) : (d = i === "auto" ? l : i, u = s === null ? an(d, c / l) : s === "auto" ? c : s);
  const f = {}, h = (y, w) => {
    za(w) || (f[y] = w.toString());
  };
  h("width", d), h("height", u);
  const m = [r.left, r.top, l, c];
  return f.viewBox = m.join(" "), {
    attributes: f,
    viewBox: m,
    body: a
  };
}
function An(e, t) {
  let n = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const o in t)
    n += " " + o + '="' + t[o] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + n + ">" + e + "</svg>";
}
function Ma(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function $a(e) {
  return "data:image/svg+xml," + Ma(e);
}
function Ko(e) {
  return 'url("' + $a(e) + '")';
}
const Fa = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
};
let kt = Fa();
function Na(e) {
  kt = e;
}
function Oa() {
  return kt;
}
function La(e, t) {
  const n = Nt(e);
  if (!n)
    return 0;
  let o;
  if (!n.maxURL)
    o = 0;
  else {
    let r = 0;
    n.resources.forEach((i) => {
      r = Math.max(r, i.length);
    });
    const a = t + ".json?icons=";
    o = n.maxURL - r - n.path.length - a.length;
  }
  return o;
}
function Da(e) {
  return e === 404;
}
const Ra = (e, t, n) => {
  const o = [], r = La(e, t), a = "icons";
  let i = {
    type: a,
    provider: e,
    prefix: t,
    icons: []
  }, s = 0;
  return n.forEach((l, c) => {
    s += l.length + 1, s >= r && c > 0 && (o.push(i), i = {
      type: a,
      provider: e,
      prefix: t,
      icons: []
    }, s = l.length), i.icons.push(l);
  }), o.push(i), o;
};
function Pa(e) {
  if (typeof e == "string") {
    const t = Nt(e);
    if (t)
      return t.path;
  }
  return "/";
}
const Ha = (e, t, n) => {
  if (!kt) {
    n("abort", 424);
    return;
  }
  let o = Pa(t.provider);
  switch (t.type) {
    case "icons": {
      const a = t.prefix, s = t.icons.join(","), l = new URLSearchParams({
        icons: s
      });
      o += a + ".json?" + l.toString();
      break;
    }
    case "custom": {
      const a = t.uri;
      o += a.slice(0, 1) === "/" ? a.slice(1) : a;
      break;
    }
    default:
      n("abort", 400);
      return;
  }
  let r = 503;
  kt(e + o).then((a) => {
    const i = a.status;
    if (i !== 200) {
      setTimeout(() => {
        n(Da(i) ? "abort" : "next", i);
      });
      return;
    }
    return r = 501, a.json();
  }).then((a) => {
    if (typeof a != "object" || a === null) {
      setTimeout(() => {
        a === 404 ? n("abort", a) : n("next", r);
      });
      return;
    }
    setTimeout(() => {
      n("success", a);
    });
  }).catch(() => {
    n("next", r);
  });
}, Va = {
  prepare: Ra,
  send: Ha
};
function Qn(e, t) {
  switch (e) {
    case "local":
    case "session":
      Te[e] = t;
      break;
    case "all":
      for (const n in Te)
        Te[n] = t;
      break;
  }
}
const Ut = "data-style";
let qo = "";
function Go(e) {
  qo = e;
}
function Yn(e, t) {
  let n = Array.from(e.childNodes).find((o) => o.hasAttribute && o.hasAttribute(Ut));
  n || (n = document.createElement("style"), n.setAttribute(Ut, Ut), e.appendChild(n)), n.textContent = ":host{display:inline-block;vertical-align:" + (t ? "-0.125em" : "0") + "}span,svg{display:block}" + qo;
}
function Qo() {
  jn("", Va), No(!0);
  let e;
  try {
    e = window;
  } catch {
  }
  if (e) {
    if (Uo(), e.IconifyPreload !== void 0) {
      const n = e.IconifyPreload, o = "Invalid IconifyPreload syntax.";
      typeof n == "object" && n !== null && (n instanceof Array ? n : [n]).forEach((r) => {
        try {
          // Check if item is an object and not null/array
          (typeof r != "object" || r === null || r instanceof Array || // Check for 'icons' and 'prefix'
          typeof r.icons != "object" || typeof r.prefix != "string" || // Add icon set
          !Vn(r)) && console.error(o);
        } catch {
          console.error(o);
        }
      });
    }
    if (e.IconifyProviders !== void 0) {
      const n = e.IconifyProviders;
      if (typeof n == "object" && n !== null)
        for (const o in n) {
          const r = "IconifyProviders[" + o + "] is invalid.";
          try {
            const a = n[o];
            if (typeof a != "object" || !a || a.resources === void 0)
              continue;
            Un(o, a) || console.error(r);
          } catch {
            console.error(r);
          }
        }
    }
  }
  return {
    enableCache: (n) => Qn(n, !0),
    disableCache: (n) => Qn(n, !1),
    iconLoaded: Bn,
    iconExists: Bn,
    // deprecated, kept to avoid breaking changes
    getIcon: oa,
    listIcons: na,
    addIcon: Oo,
    addCollection: Vn,
    calculateSize: an,
    buildIcon: _o,
    iconToHTML: An,
    svgToURL: Ko,
    loadIcons: In,
    loadIcon: ya,
    addAPIProvider: Un,
    appendCustomStyle: Go,
    _api: {
      getAPIConfig: Nt,
      setAPIModule: jn,
      sendAPIQuery: Ro,
      setFetch: Na,
      getFetch: Oa,
      listAPIProviders: da
    }
  };
}
const sn = {
  "background-color": "currentColor"
}, Yo = {
  "background-color": "transparent"
}, Xn = {
  image: "var(--svg)",
  repeat: "no-repeat",
  size: "100% 100%"
}, Zn = {
  "-webkit-mask": sn,
  mask: sn,
  background: Yo
};
for (const e in Zn) {
  const t = Zn[e];
  for (const n in Xn)
    t[e + "-" + n] = Xn[n];
}
function Jn(e) {
  return e ? e + (e.match(/^[-0-9.]+$/) ? "px" : "") : "inherit";
}
function Ba(e, t, n) {
  const o = document.createElement("span");
  let r = e.body;
  r.indexOf("<a") !== -1 && (r += "<!-- " + Date.now() + " -->");
  const a = e.attributes, i = An(r, {
    ...a,
    width: t.width + "",
    height: t.height + ""
  }), s = Ko(i), l = o.style, c = {
    "--svg": s,
    width: Jn(a.width),
    height: Jn(a.height),
    ...n ? sn : Yo
  };
  for (const d in c)
    l.setProperty(d, c[d]);
  return o;
}
let Je;
function ja() {
  try {
    Je = window.trustedTypes.createPolicy("iconify", {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      createHTML: (e) => e
    });
  } catch {
    Je = null;
  }
}
function Ua(e) {
  return Je === void 0 && ja(), Je ? Je.createHTML(e) : e;
}
function Wa(e) {
  const t = document.createElement("span"), n = e.attributes;
  let o = "";
  n.width || (o = "width: inherit;"), n.height || (o += "height: inherit;"), o && (n.style = o);
  const r = An(e.body, n);
  return t.innerHTML = Ua(r), t.firstChild;
}
function ln(e) {
  return Array.from(e.childNodes).find((t) => {
    const n = t.tagName && t.tagName.toUpperCase();
    return n === "SPAN" || n === "SVG";
  });
}
function eo(e, t) {
  const n = t.icon.data, o = t.customisations, r = _o(n, o);
  o.preserveAspectRatio && (r.attributes.preserveAspectRatio = o.preserveAspectRatio);
  const a = t.renderedMode;
  let i;
  switch (a) {
    case "svg":
      i = Wa(r);
      break;
    default:
      i = Ba(r, {
        ...st,
        ...n
      }, a === "mask");
  }
  const s = ln(e);
  s ? i.tagName === "SPAN" && s.tagName === i.tagName ? s.setAttribute("style", i.getAttribute("style")) : e.replaceChild(i, s) : e.appendChild(i);
}
function to(e, t, n) {
  const o = n && (n.rendered ? n : n.lastRender);
  return {
    rendered: !1,
    inline: t,
    icon: e,
    lastRender: o
  };
}
function _a(e = "iconify-icon") {
  let t, n;
  try {
    t = window.customElements, n = window.HTMLElement;
  } catch {
    return;
  }
  if (!t || !n)
    return;
  const o = t.get(e);
  if (o)
    return o;
  const r = [
    // Icon
    "icon",
    // Mode
    "mode",
    "inline",
    "noobserver",
    // Customisations
    "width",
    "height",
    "rotate",
    "flip"
  ], a = class extends n {
    /**
     * Constructor
     */
    constructor() {
      super();
      // Root
      we(this, "_shadowRoot");
      // Initialised
      we(this, "_initialised", !1);
      // Icon state
      we(this, "_state");
      // Attributes check queued
      we(this, "_checkQueued", !1);
      // Connected
      we(this, "_connected", !1);
      // Observer
      we(this, "_observer", null);
      we(this, "_visible", !0);
      const l = this._shadowRoot = this.attachShadow({
        mode: "open"
      }), c = this.hasAttribute("inline");
      Yn(l, c), this._state = to({
        value: ""
      }, c), this._queueCheck();
    }
    /**
     * Connected to DOM
     */
    connectedCallback() {
      this._connected = !0, this.startObserver();
    }
    /**
     * Disconnected from DOM
     */
    disconnectedCallback() {
      this._connected = !1, this.stopObserver();
    }
    /**
     * Observed attributes
     */
    static get observedAttributes() {
      return r.slice(0);
    }
    /**
     * Observed properties that are different from attributes
     *
     * Experimental! Need to test with various frameworks that support it
     */
    /*
    static get properties() {
        return {
            inline: {
                type: Boolean,
                reflect: true,
            },
            // Not listing other attributes because they are strings or combination
            // of string and another type. Cannot have multiple types
        };
    }
    */
    /**
     * Attribute has changed
     */
    attributeChangedCallback(l) {
      switch (l) {
        case "inline": {
          const c = this.hasAttribute("inline"), d = this._state;
          c !== d.inline && (d.inline = c, Yn(this._shadowRoot, c));
          break;
        }
        case "noobserver": {
          this.hasAttribute("noobserver") ? this.startObserver() : this.stopObserver();
          break;
        }
        default:
          this._queueCheck();
      }
    }
    /**
     * Get/set icon
     */
    get icon() {
      const l = this.getAttribute("icon");
      if (l && l.slice(0, 1) === "{")
        try {
          return JSON.parse(l);
        } catch {
        }
      return l;
    }
    set icon(l) {
      typeof l == "object" && (l = JSON.stringify(l)), this.setAttribute("icon", l);
    }
    /**
     * Get/set inline
     */
    get inline() {
      return this.hasAttribute("inline");
    }
    set inline(l) {
      l ? this.setAttribute("inline", "true") : this.removeAttribute("inline");
    }
    /**
     * Get/set observer
     */
    get observer() {
      return this.hasAttribute("observer");
    }
    set observer(l) {
      l ? this.setAttribute("observer", "true") : this.removeAttribute("observer");
    }
    /**
     * Restart animation
     */
    restartAnimation() {
      const l = this._state;
      if (l.rendered) {
        const c = this._shadowRoot;
        if (l.renderedMode === "svg")
          try {
            c.lastChild.setCurrentTime(0);
            return;
          } catch {
          }
        eo(c, l);
      }
    }
    /**
     * Get status
     */
    get status() {
      const l = this._state;
      return l.rendered ? "rendered" : l.icon.data === null ? "failed" : "loading";
    }
    /**
     * Queue attributes re-check
     */
    _queueCheck() {
      this._checkQueued || (this._checkQueued = !0, setTimeout(() => {
        this._check();
      }));
    }
    /**
     * Check for changes
     */
    _check() {
      if (!this._checkQueued)
        return;
      this._checkQueued = !1;
      const l = this._state, c = this.getAttribute("icon");
      if (c !== l.icon.value) {
        this._iconChanged(c);
        return;
      }
      if (!l.rendered || !this._visible)
        return;
      const d = this.getAttribute("mode"), u = Pn(this);
      (l.attrMode !== d || Qr(l.customisations, u) || !ln(this._shadowRoot)) && this._renderIcon(l.icon, u, d);
    }
    /**
     * Icon value has changed
     */
    _iconChanged(l) {
      const c = Ca(l, (d, u, f) => {
        const h = this._state;
        if (h.rendered || this.getAttribute("icon") !== d)
          return;
        const m = {
          value: d,
          name: u,
          data: f
        };
        m.data ? this._gotIconData(m) : h.icon = m;
      });
      c.data ? this._gotIconData(c) : this._state = to(c, this._state.inline, this._state);
    }
    /**
     * Force render icon on state change
     */
    _forceRender() {
      if (!this._visible) {
        const l = ln(this._shadowRoot);
        l && this._shadowRoot.removeChild(l);
        return;
      }
      this._queueCheck();
    }
    /**
     * Got new icon data, icon is ready to (re)render
     */
    _gotIconData(l) {
      this._checkQueued = !1, this._renderIcon(l, Pn(this), this.getAttribute("mode"));
    }
    /**
     * Re-render based on icon data
     */
    _renderIcon(l, c, d) {
      const u = ka(l.data.body, d), f = this._state.inline;
      eo(this._shadowRoot, this._state = {
        rendered: !0,
        icon: l,
        inline: f,
        customisations: c,
        attrMode: d,
        renderedMode: u
      });
    }
    /**
     * Start observer
     */
    startObserver() {
      if (!this._observer && !this.hasAttribute("noobserver"))
        try {
          this._observer = new IntersectionObserver((l) => {
            const c = l.some((d) => d.isIntersecting);
            c !== this._visible && (this._visible = c, this._forceRender());
          }), this._observer.observe(this);
        } catch {
          if (this._observer) {
            try {
              this._observer.disconnect();
            } catch {
            }
            this._observer = null;
          }
        }
    }
    /**
     * Stop observer
     */
    stopObserver() {
      this._observer && (this._observer.disconnect(), this._observer = null, this._visible = !0, this._connected && this._forceRender());
    }
  };
  r.forEach((s) => {
    s in a.prototype || Object.defineProperty(a.prototype, s, {
      get: function() {
        return this.getAttribute(s);
      },
      set: function(l) {
        l !== null ? this.setAttribute(s, l) : this.removeAttribute(s);
      }
    });
  });
  const i = Qo();
  for (const s in i)
    a[s] = a.prototype[s] = i[s];
  return t.define(e, a), a;
}
const Xo = _a() || Qo(), {
  enableCache: Ka,
  disableCache: qa,
  iconLoaded: Ga,
  iconExists: Qa,
  // deprecated, kept to avoid breaking changes
  getIcon: Ya,
  listIcons: Xa,
  addIcon: Za,
  addCollection: Zo,
  calculateSize: Ja,
  buildIcon: ei,
  iconToHTML: ti,
  svgToURL: ni,
  loadIcons: oi,
  loadIcon: ri,
  addAPIProvider: ai,
  _api: ii
} = Xo, A0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconifyIconComponent: Xo,
  _api: ii,
  addAPIProvider: ai,
  addCollection: Zo,
  addIcon: Za,
  appendCustomStyle: Go,
  buildIcon: ei,
  calculateSize: Ja,
  disableCache: qa,
  enableCache: Ka,
  getIcon: Ya,
  iconExists: Qa,
  iconLoaded: Ga,
  iconToHTML: ti,
  listIcons: Xa,
  loadIcon: ri,
  loadIcons: oi,
  svgToURL: ni
}, Symbol.toStringTag, { value: "Module" }));
function si(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Jo = {}, er = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  function t(o, r) {
    return {
      handler: o,
      config: r
    };
  }
  t.withOptions = function(o, r = () => ({})) {
    const a = function(i) {
      return {
        __options: i,
        handler: o(i),
        config: r(i)
      };
    };
    return a.__isOptionsFunction = !0, a.__pluginFunction = o, a.__configFunction = r, a;
  };
  const n = t;
})(er);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return o;
    }
  });
  const t = /* @__PURE__ */ n(er);
  function n(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  const o = t.default;
})(Jo);
let Wt = Jo;
var li = (Wt.__esModule ? Wt : { default: Wt }).default;
const ci = /* @__PURE__ */ si(li), ee = {
  white: "#FFFFFF",
  lin: "#F7F6F0",
  charcoal: "#2B2B2B",
  black: "#131313"
}, te = {
  700: "#BA5225",
  600: "#CD4D16",
  500: "#EB512F",
  // Corale
  450: "#F9885E",
  400: "#F5B1A2",
  300: "#FCE2DD",
  200: "#FDEFEC",
  100: "#FEF7F5"
}, X = {
  750: "#1D1D1D",
  700: "#404040",
  600: "#525252",
  500: "#737373",
  400: "#A3A3A3",
  300: "#D4D4D4",
  200: "#E5E5E5",
  150: "#EEEEEE",
  100: "#F5F5F5"
}, Ve = {
  500: "#1C6BB8",
  // Lapis-lazuli
  450: "#528BDD",
  300: "#71B9FF",
  100: "#EAEFF8"
}, ft = {
  700: "#247A5E",
  200: "#EBF8F3"
}, ht = {
  600: "#C83844",
  500: "#EB4452",
  200: "#F8EFF0"
}, mt = {
  800: "#95672B",
  500: "#FBBA66",
  200: "#FFF8F0"
}, ue = {
  500: "#9C3BC9",
  400: "#BF8FE4",
  300: "#D3ADEF",
  100: "#F0DBFF",
  50: "#F8F1FC"
}, ne = {
  "orange-600-25": "#CD4D1640",
  "neutral-800-15": "#17171726",
  "neutral-800-25": "#17171740",
  "lin-25": "#F7F6F040",
  "lavender-300-25": "#D3ADEF40",
  transparent: "#00000000"
}, _t = {
  DEFAULT: Ve[450],
  focus: Ve[450],
  "focus-inverse": Ve[300]
}, cn = [
  "Circular",
  '"system-ui"',
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  "Roboto",
  '"Helvetica Neue"',
  "Arial",
  '"Noto Sans"',
  "sans-serif",
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
  '"Noto Color Emoji"'
], ui = ["neue-haas-display", ...cn], pt = {
  background: {
    default: X[150],
    surface: ee.white,
    "surface-hover": X[100],
    "surface-neutral": X[100],
    fill: ee.lin,
    "fill-accent": ue[300],
    "fill-accent-discrete": ue[100],
    "fill-accent-discrete2": ue[50],
    "fill-accent-hover": ue[400],
    "fill-accent-disabled": ne["lavender-300-25"],
    "fill-alt": ee.charcoal,
    "fill-alt-hover": X[750],
    "fill-brand": te[100],
    "fill-hover": X[150],
    "fill-hover-primary": te[200],
    "fill-alt-disabled": ne["neutral-800-15"],
    "fill-primary": te[600],
    "fill-primary-disabled": ne["orange-600-25"],
    "fill-primary-hover": te[700],
    "fill-tip": Ve[100],
    "fill-error": ht[200],
    "fill-success": ft[200],
    "fill-caution": mt[200],
    "fill-discrete": X[300],
    "fill-discrete2": X[200],
    "fill-discrete3": X[150],
    "fill-neutral": X[500],
    "fill-neutral-hover": X[700],
    "fill-neutral-alt-hover": X[400],
    "fill-primary-discrete": te[300],
    "fill-primary-discrete2": te[200],
    "fill-primary-discrete1": te[100],
    transparent: ne.transparent
  },
  text: {
    // adding this to make sure there's always a way to access the default color
    "default-color": ee.charcoal,
    accent: ue[500],
    "accent-disabled": ne["lavender-300-25"],
    inverse: ee.lin,
    "inverse-accent": ue[300],
    "inverse-disabled": ee.lin,
    abovePrimary: ee.lin,
    "abovePrimary-disabled": ne["lin-25"],
    primary: te[600],
    "primary-disabled": ne["orange-600-25"],
    "primary-discrete": te[400],
    discrete: X[600],
    discrete2: X[500],
    discrete3: X[400],
    disabled: ne["neutral-800-25"],
    success: ft[700],
    error: ht[600],
    caution: mt[800],
    link: te[600],
    "link-inverse": te[450]
  },
  border: {
    default: ee.charcoal,
    // adding this to make sure there's always a way to access the default color
    "default-color": ee.charcoal,
    inverse: ee.lin,
    accent: ue[500],
    "accent-disabled": ne["lavender-300-25"],
    "inverse-accent": ue[300],
    primary: te[600],
    "primary-disabled": ne["orange-600-25"],
    error: ht[500],
    success: ft[700],
    tip: Ve[500],
    caution: mt[500],
    discrete: X[500],
    discrete2: X[400],
    discrete3: X[300],
    disabled: ne["neutral-800-25"],
    brand: te[400],
    transparent: ne.transparent
  },
  icon: {
    icon: ee.charcoal,
    // default
    "icon-accent": ue[500],
    "icon-accent-disabled": ne["lavender-300-25"],
    "icon-inverse-accent": ue[300],
    "icon-inverse": ee.lin,
    "icon-primary": te[600],
    "icon-brand": te[500],
    "icon-abovePrimary": ee.lin,
    "icon-abovePrimary-disabled": ee.lin,
    "icon-primary-disabled": ne["orange-600-25"],
    "icon-discrete": X[600],
    "icon-discrete2": X[500],
    "icon-discrete3": X[400],
    "icon-disabled": ne["neutral-800-25"],
    "icon-success": ft[700],
    "icon-error": ht[600],
    "icon-tip": Ve[500],
    "icon-caution": mt[500]
  }
}, di = {
  screens: {
    sm: "320px",
    md: "768px",
    lg: "1024px"
  },
  fontFamily: {
    DEFAULT: cn,
    sans: cn,
    title: ui
  },
  fontSize: {
    DEFAULT: "1rem",
    // 16px
    "2xs": "0.75rem",
    // 12px
    xs: "0.8125rem",
    // 13px
    sm: "0.875rem",
    // 14px
    base: "1rem",
    // 16px
    lg: "1.125rem",
    // 18px
    xl: "1.25rem",
    // 20px
    "2xl": "1.5rem",
    // 24px
    "3xl": "1.75rem",
    // 28px
    "4xl": "2.25rem",
    // 36px
    "5xl": "3rem",
    // 48px
    "6xl": "3.75rem"
    // 60px
  },
  lineHeight: {
    DEFAULT: "1.5rem",
    // 24px
    sm: "1.25rem",
    // 20px
    "3xl": "2rem",
    // 32px
    "4xl": "3rem",
    // 40px
    "5xl": "3.5rem",
    // 64px
    "6xl": "4.5rem"
    // 72px
  },
  fontWeight: {
    DEFAULT: "450",
    normal: "450",
    medium: "500",
    bold: "700",
    black: "900"
  },
  spacing: {
    zero: "0px",
    "4xs": "1px",
    "3xs": "2px",
    "2xs": "4px",
    xs: "6px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "20px",
    "2xl": "24px",
    "3xl": "32px",
    "4xl": "40px",
    "5xl": "48px",
    "6xl": "64px",
    "7xl": "80px",
    "8xl": "120px",
    "9xl": "150px",
    "10xl": "256px"
  },
  borderRadius: {
    DEFAULT: "4px",
    none: "0",
    xs: "2px",
    sm: "4px",
    md: "6px",
    lg: "8px",
    xl: "12px",
    "2xl": "16px",
    "3xl": "24px",
    "4xl": "40px",
    full: "9999px"
  },
  boxShadow: {
    DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
    base: "0 1px 3px 0 rgb(0 0 0 / 0.1)",
    sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    md: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
    lg: "0 10px 15px -3px rgb(0 0 0 / 0.1)",
    xl: "0 20px 25px -5px rgb(0 0 0 / 0.1)",
    "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
    reverse: "0 -10px 15px -3 rgb(0 0 0 / 0.05)"
  },
  color: {
    transparent: "transparent",
    black: ee.black,
    white: ee.white
  },
  borderColor: {
    ...pt.border
  },
  outlineColor: () => _t,
  ringColor: () => _t,
  ringOffsetColor: () => _t,
  backgroundColor: {
    ...pt.background
  },
  textColor: {
    ...pt.text,
    ...pt.icon
  },
  transitionTimingFunction: {
    "slow-down": "cubic-bezier(0, 0.35, 0, 1)",
    smooth: "cubic-bezier(0.35, 0.1, 0, 1)"
  }
}, fi = {
  theme: {
    ...di
  }
}, E0 = ci(
  function({ addBase: e, addComponents: t, theme: n }) {
    const o = {
      fontSize: n("fontSize.6xl"),
      fontFamily: n("fontFamily.title"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.6xl"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.5xl"),
        lineHeight: n("lineHeight.5xl")
      }
    }, r = {
      fontSize: n("fontSize.5xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.5xl"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.4xl"),
        lineHeight: n("lineHeight.4xl")
      }
    }, a = {
      fontSize: n("fontSize.4xl"),
      fontWeight: n("fontWeight.black"),
      fontFamily: n("fontFamily.title"),
      lineHeight: n("lineHeight.4xl"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.3xl"),
        lineHeight: n("lineHeight.3xl")
      }
    }, i = {
      fontSize: n("fontSize.3xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.3xl"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.2xl"),
        lineHeight: n("lineHeight.2xl")
      }
    }, s = {
      fontSize: n("fontSize.2xl"),
      lineHeight: n("lineHeight.3xl"),
      fontWeight: n("fontWeight.black"),
      fontFamily: n("fontFamily.title"),
      "@media (max-width: 767px)": {
        fontSize: n("fontSize.xl"),
        lineHeight: n("lineHeight.xl")
      }
    }, l = {
      fontSize: n("fontSize.xl"),
      fontWeight: n("fontWeight.black"),
      lineHeight: n("lineHeight.DEFAULT"),
      fontFamily: n("fontFamily.title")
    };
    t({
      ".text-h1": o,
      ".text-h2": r,
      ".text-h3": a,
      ".text-h4": i,
      ".text-h5": s,
      ".text-h6": l,
      ".text-body": {
        fontSize: n("fontSize.DEFAULT"),
        lineHeight: n("lineHeight.DEFAULT")
      },
      ".text-body-lg": {
        fontSize: n("fontSize.lg"),
        lineHeight: n("lineHeight.DEFAULT")
      },
      ".text-body-sm": {
        fontSize: n("fontSize.sm"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-body-xs": {
        fontSize: n("fontSize.xs"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-form-error": {
        color: n("textColor.error"),
        fontSize: n("fontSize.sm"),
        fontWeight: n("fontWeight.medium"),
        lineHeight: n("lineHeight.sm")
      },
      ".text-heading-uppercase": {
        fontSize: n("fontSize.2xs"),
        fontWeight: n("fontWeight.medium"),
        lineHeight: n("lineHeight.sm"),
        textTransform: "uppercase"
      }
    });
  },
  {
    theme: {
      ...fi.theme
    }
  }
), hi = ["icon", "aria-label"], mi = {}, j = /* @__PURE__ */ B({
  ...mi,
  __name: "UIIcon",
  props: {
    name: {},
    size: { default: "base" }
  },
  setup(e) {
    let t;
    ((r) => {
      r.sm = "16", r.base = "20", r.lg = "24", r.xl = "32", r["2xl"] = "40";
    })(t || (t = {}));
    const n = e, o = G({
      height: `${t[n.size]}px`,
      width: `${t[n.size]}px`,
      style: {
        height: `${t[n.size]}px`,
        width: `${t[n.size]}px`
      },
      class: "tw-inline-block",
      role: "img",
      "data-allow-mismatch": !0
    });
    return (r, a) => (g(), S("iconify-icon", me({ icon: r.name }, o.value, { "aria-label": r.name }), null, 16, hi));
  }
}), pi = ["disabled", "checked"], tr = /* @__PURE__ */ B({
  __name: "BaseChip",
  props: /* @__PURE__ */ oe({
    color: { default: "default" },
    component: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    iconLeftName: { default: "" },
    iconRightName: { default: "" },
    size: { default: "base" },
    text: { default: "" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ oe(["click"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = t, o = fe(e, "modelValue"), r = C(() => ({
      "tw-flex tw-w-fit tw-items-center tw-gap-2xs tw-rounded-full tw-transition-all": !0
    })), a = C(() => ({
      "tw-cursor-not-allowed": e.disabled,
      "tw-bg-fill-discrete3": e.color === "default",
      "hover:tw-bg-fill-discrete2": e.color === "default" && !e.disabled,
      "tw-bg-fill-alt": e.color === "alt",
      "tw-bg-fill-success": e.color === "success",
      "tw-bg-fill-caution": e.color === "warning",
      "tw-bg-fill-error": e.color === "error",
      "tw-bg-surface": e.color === "dashed",
      "hover:tw-bg-surface-hover": e.color === "dashed" && !e.disabled
    })), i = C(() => ({
      "tw-border-dashed tw-border tw-border-discrete3": e.color === "dashed",
      "tw-border-transparent tw-border": e.color !== "dashed",
      "focus-visible:tw-outline": !e.disabled && e.component !== "input",
      "focus-within:tw-outline": !e.disabled && e.component === "input"
    })), s = C(() => ({
      "tw-px-sm tw-py-xs": e.size === "sm",
      "tw-px-md tw-py-sm": e.size === "base"
    })), l = C(() => ({
      // color for disabled chips variants
      "tw-text-discrete3": e.disabled && ["default", "alt"].includes(e.color),
      "tw-text-discrete": !e.disabled && e.color === "default",
      "tw-text-inverse": !e.disabled && e.color === "alt",
      // color for never disabled chips variants
      "tw-text-success": e.color === "success",
      "tw-text-caution": e.color === "warning",
      "tw-text-error": e.color === "error",
      // size
      "tw-text-body-xs": e.size === "sm",
      "tw-text-body-sm": e.size === "base"
    })), c = C(() => ({
      // color for disabled chips variants
      "tw-text-discrete3": e.disabled && ["default", "alt"].includes(e.color),
      "tw-text-discrete": !e.disabled && e.color === "default",
      "tw-text-inverse": !e.disabled && e.color === "alt",
      // color for never disabled chips variants
      "tw-text-icon-success": e.color === "success",
      "tw-text-icon-caution": e.color === "warning",
      "tw-text-icon-error": e.color === "error"
    }));
    return (d, u) => d.component === "input" ? (g(), S("label", {
      key: 0,
      class: M([
        r.value,
        a.value,
        s.value,
        i.value
      ]),
      onClick: u[1] || (u[1] = (f) => n("click")),
      onKeypress: u[2] || (u[2] = yt((f) => n("click"), ["space"]))
    }, [
      R("input", {
        type: "checkbox",
        class: "tw-sr-only",
        disabled: d.disabled,
        checked: o.value,
        onClick: u[0] || (u[0] = Xt(() => {
        }, ["stop"]))
      }, null, 8, pi),
      d.iconLeftName ? (g(), D(j, {
        key: 0,
        name: d.iconLeftName,
        size: "sm",
        class: M(c.value)
      }, null, 8, ["name", "class"])) : A("", !0),
      d.text ? (g(), S("span", {
        key: 1,
        "data-test-id": "chip-text",
        class: M(["tw-px-3xs", [l.value]])
      }, Z(d.text), 3)) : A("", !0),
      d.iconRightName ? (g(), D(j, {
        key: 2,
        name: d.iconRightName,
        size: "sm",
        class: M(c.value)
      }, null, 8, ["name", "class"])) : A("", !0)
    ], 34)) : (g(), D(Fe(d.component), {
      key: 1,
      class: M([
        r.value,
        a.value,
        s.value,
        i.value
      ]),
      disabled: d.disabled ? !0 : void 0,
      onClick: u[3] || (u[3] = (f) => n("click"))
    }, {
      default: K(() => [
        d.iconLeftName ? (g(), D(j, {
          key: 0,
          name: d.iconLeftName,
          size: "sm",
          class: M(c.value)
        }, null, 8, ["name", "class"])) : A("", !0),
        d.text ? (g(), S("span", {
          key: 1,
          "data-test-id": "chip-text",
          class: M(["tw-px-3xs", [l.value]])
        }, Z(d.text), 3)) : A("", !0),
        d.iconRightName ? (g(), D(j, {
          key: 2,
          name: d.iconRightName,
          size: "sm",
          class: M(c.value)
        }, null, 8, ["name", "class"])) : A("", !0)
      ]),
      _: 1
    }, 8, ["class", "disabled"]));
  }
}), vi = ["src", "alt"], wi = {}, z0 = /* @__PURE__ */ B({
  ...wi,
  __name: "UIAvatar",
  props: {
    src: {},
    alt: { default: "" },
    size: { default: "lg" },
    variant: { default: "circle" }
  },
  setup(e) {
    const t = e, n = C(() => {
      switch (t.size) {
        case "xl":
          return "tw-size-[72px]";
        case "lg":
          return "tw-size-[56px]";
        case "md":
          return "tw-size-4xl";
        case "sm":
          return "tw-size-2xl";
        default:
          return "tw-size-[56px]";
      }
    });
    return (o, r) => (g(), S("img", {
      src: o.src,
      alt: o.alt,
      class: M(["tw-object-cover", [
        n.value,
        o.variant === "circle" ? "tw-rounded-full" : "tw-rounded-sm"
      ]]),
      loading: "lazy"
    }, null, 10, vi));
  }
});
function Ot(e) {
  const t = Er("NuxtLink"), n = it(), o = C(() => t === "NuxtLink" ? "a" : t), r = C(() => q(e) || n.href ? o.value : "button"), a = C(() => {
    const l = q(e) ?? n.href ?? "";
    return r.value === "button" ? {
      type: "button"
    } : { href: i(l) ? l : s(l) };
  });
  function i(l) {
    return l && l.startsWith("http");
  }
  function s(l) {
    return l;
  }
  return typeof useLocalePath == "function" && (s = useLocalePath()), {
    componentAttrs: a,
    isExternalLink: i,
    linkComponent: o,
    linkOrButtonComponent: r,
    localePath: s
  };
}
function Lt(e) {
  return go() ? (yo(e), !0) : !1;
}
const Kt = /* @__PURE__ */ new WeakMap(), bi = (...e) => {
  var t;
  const n = e[0], o = (t = yn()) == null ? void 0 : t.proxy;
  if (o == null && !xo())
    throw new Error("injectLocal must be called in setup");
  return o && Kt.has(o) && n in Kt.get(o) ? Kt.get(o)[n] : $r(...e);
}, En = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const gi = (e) => e != null, yi = Object.prototype.toString, nr = (e) => yi.call(e) === "[object Object]", Ce = () => {
}, un = /* @__PURE__ */ xi();
function xi() {
  var e, t;
  return En && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function no(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function Ci(e) {
  return yn();
}
function Se(e) {
  return Array.isArray(e) ? e : [e];
}
function ki(...e) {
  if (e.length !== 1)
    return xn(...e);
  const t = e[0];
  return typeof t == "function" ? Fr(Nr(() => ({ get: t, set: Ce }))) : G(t);
}
function Ti(e, t = !0, n) {
  Ci() ? gn(e, n) : t ? e() : Mr(e);
}
function Si(e = !1, t = {}) {
  const {
    truthyValue: n = !0,
    falsyValue: o = !1
  } = t, r = zr(e), a = G(e);
  function i(s) {
    if (arguments.length)
      return a.value = s, a.value;
    {
      const l = q(n);
      return a.value = a.value === l ? q(o) : l, a.value;
    }
  }
  return r ? i : [a, i];
}
function or(e, t, n) {
  return se(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
const zn = En ? window : void 0;
function rr(e) {
  var t;
  const n = q(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function dn(...e) {
  const t = [], n = () => {
    t.forEach((s) => s()), t.length = 0;
  }, o = (s, l, c, d) => (s.addEventListener(l, c, d), () => s.removeEventListener(l, c, d)), r = C(() => {
    const s = Se(q(e[0])).filter((l) => l != null);
    return s.every((l) => typeof l != "string") ? s : void 0;
  }), a = or(
    () => {
      var s, l;
      return [
        (l = (s = r.value) == null ? void 0 : s.map((c) => rr(c))) != null ? l : [zn].filter((c) => c != null),
        Se(q(r.value ? e[1] : e[0])),
        Se(I(r.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        q(r.value ? e[3] : e[2])
      ];
    },
    ([s, l, c, d]) => {
      if (n(), !(s != null && s.length) || !(l != null && l.length) || !(c != null && c.length))
        return;
      const u = nr(d) ? { ...d } : d;
      t.push(
        ...s.flatMap(
          (f) => l.flatMap(
            (h) => c.map((m) => o(f, h, m, u))
          )
        )
      );
    },
    { flush: "post" }
  ), i = () => {
    a(), n();
  };
  return Lt(n), i;
}
function Ii() {
  const e = Ae(!1), t = yn();
  return t && gn(() => {
    e.value = !0;
  }, t), e;
}
function Ai(e) {
  const t = Ii();
  return C(() => (t.value, !!e()));
}
const Ei = Symbol("vueuse-ssr-width");
function zi() {
  const e = xo() ? bi(Ei, null) : null;
  return typeof e == "number" ? e : void 0;
}
function Mi(e, t = {}) {
  const { window: n = zn, ssrWidth: o = zi() } = t, r = Ai(() => n && "matchMedia" in n && typeof n.matchMedia == "function"), a = G(typeof o == "number"), i = Ae(), s = Ae(!1), l = (c) => {
    s.value = c.matches;
  };
  return Or(() => {
    if (a.value) {
      a.value = !r.value;
      const c = q(e).split(",");
      s.value = c.some((d) => {
        const u = d.includes("not all"), f = d.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), h = d.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let m = !!(f || h);
        return f && m && (m = o >= no(f[1])), h && m && (m = o <= no(h[1])), u ? !m : m;
      });
      return;
    }
    r.value && (i.value = n.matchMedia(q(e)), s.value = i.value.matches);
  }), dn(i, "change", l, { passive: !0 }), C(() => s.value);
}
function $i(e = {}) {
  const {
    window: t = zn,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: o = Number.POSITIVE_INFINITY,
    listenOrientation: r = !0,
    includeScrollbar: a = !0,
    type: i = "inner"
  } = e, s = G(n), l = G(o), c = () => {
    if (t)
      if (i === "outer")
        s.value = t.outerWidth, l.value = t.outerHeight;
      else if (i === "visual" && t.visualViewport) {
        const { width: u, height: f, scale: h } = t.visualViewport;
        s.value = Math.round(u * h), l.value = Math.round(f * h);
      } else a ? (s.value = t.innerWidth, l.value = t.innerHeight) : (s.value = t.document.documentElement.clientWidth, l.value = t.document.documentElement.clientHeight);
  };
  c(), Ti(c);
  const d = { passive: !0 };
  if (dn("resize", c, d), t && i === "visual" && t.visualViewport && dn(t.visualViewport, "resize", c, d), r) {
    const u = Mi("(orientation: portrait)");
    se(u, () => c());
  }
  return { width: s, height: l };
}
var Ye = /* @__PURE__ */ ((e) => (e[e.sm = 320] = "sm", e[e.md = 768] = "md", e[e.lg = 1024] = "lg", e))(Ye || {});
function Fi() {
  const { width: e } = $i(), t = C(() => e.value < Ye.md), n = C(
    () => e.value >= Ye.md && e.value < Ye.lg
  ), o = C(() => e.value >= Ye.lg);
  return {
    isSm: t,
    isMd: n,
    isLg: o
  };
}
function ar(e) {
  const { isSm: t } = Fi(), n = C(() => {
    const r = q(e);
    return r === "large" && t.value ? "medium" : r === "medium" && t.value ? "small" : r;
  }), o = C(
    () => n.value === "large" ? "lg" : "base"
  );
  return {
    scaledButtonSize: n,
    scaledIconSize: o
  };
}
function _(e, t = {}) {
  return !Ni(e, t);
}
function Ni(e, t = {}) {
  return Oi(e == null ? void 0 : e(t));
}
function Oi(e) {
  return !e || Li(e).every(
    (t) => {
      var n, o;
      return t.type === Lr || t.type === Dr && !((n = t.children) != null && n.length) || t.type === tt && !((o = t.children) != null && o.length);
    }
  );
}
function Li(e) {
  return Array.isArray(e) ? e : e !== null ? [e] : [];
}
const Di = { class: "tw-flex tw-items-center tw-justify-center tw-gap-x-2xs" }, Ri = {
  key: 2,
  class: "tw-whitespace-nowrap"
}, Pi = {}, oo = /* @__PURE__ */ B({
  ...Pi,
  __name: "UIButton",
  props: {
    color: { default: "default" },
    iconLeftName: { default: null },
    iconRightName: { default: null },
    size: { default: "medium" },
    text: { default: null },
    to: { default: void 0 },
    variant: { default: "primary" }
  },
  setup(e) {
    const t = e, n = pe(), { linkOrButtonComponent: o, componentAttrs: r } = Ot(
      () => t.to
    ), { scaledButtonSize: a, scaledIconSize: i } = ar(
      xn(() => t.size)
    ), s = it(), l = "tw-p-3xs tw-text-sm tw-leading-sm tw-h-2xl", c = "tw-p-sm tw-text-sm tw-leading-sm tw-h-[36px]", d = "tw-p-md tw-text-base tw-leading tw-h-5xl", u = "tw-p-lg tw-text-lg tw-leading tw-h-[56px]", f = "tw-text-abovePrimary tw-bg-fill-primary tw-border-primary disabled:tw-bg-fill-primary-disabled hover:tw-bg-fill-primary-hover hover:tw-shadow-md", h = "tw-bg-fill-alt tw-text-inverse disabled:tw-bg-fill-alt-disabled hover:tw-bg-fill-alt-hover hover:tw-shadow-md", m = "tw-text-default-color tw-bg-fill-accent disabled:tw-bg-fill-accent-disabled hover:tw-bg-fill-accent-hover hover:tw-shadow-md disabled:tw-text-disabled", y = "tw-border tw-border-primary tw-text-primary disabled:tw-border-primary-disabled disabled:tw-text-primary-disabled hover:tw-bg-fill-hover-primary hover:tw-shadow-md", w = "tw-border tw-text disabled:tw-border-disabled disabled:tw-text-disabled hover:tw-bg-fill-hover hover:tw-shadow-md", p = "tw-border tw-border-accent tw-text-accent disabled:tw-border-inverse-accent disabled:tw-text-inverse-accent hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md", x = "tw-border tw-border-inverse-accent tw-text-inverse-accent disabled:tw-border-accent-disabled disabled:tw-text-accent-disabled hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md hover:tw-text-accent focus-visible:tw-bg-fill focus-visible:tw-text-accent", k = "tw-text-primary disabled:tw-text-primary-disabled hover:tw-bg-fill-hover-primary hover:tw-shadow-md", T = "tw-text tw-text-defaut-color disabled:tw-text-disabled hover:tw-bg-fill-hover hover:tw-shadow-md", F = "tw-text-accent disabled:tw-border-inverse-accent disabled:tw-text-inverse-accent hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md", z = "tw-text-inverse-accent disabled:tw-border-accent-disabled disabled:tw-text-accent-disabled hover:tw-bg-fill-accent-discrete2 hover:tw-shadow-md hover:tw-text-accent focus-visible:tw-bg-fill focus-visible:tw-text-accent", $ = C(() => [
      t.variant === "primary" && t.color === "default" && f,
      t.variant === "primary" && t.color === "neutral" && h,
      t.variant === "primary" && t.color === "accent" && m,
      t.variant === "outlined" && t.color === "default" && y,
      t.variant === "outlined" && t.color === "neutral" && w,
      t.variant === "outlined" && t.color === "accent" && p,
      t.variant === "outlined" && t.color === "alt-accent" && x,
      t.variant === "transparent" && t.color === "default" && k,
      t.variant === "transparent" && t.color === "neutral" && T,
      t.variant === "transparent" && t.color === "accent" && F,
      t.variant === "transparent" && t.color === "alt-accent" && z
    ].join(" ").replaceAll("false", "")), U = C(() => [
      a.value === "xsmall" && l,
      a.value === "small" && c,
      a.value === "medium" && d,
      a.value === "large" && u
    ].join(" ").replaceAll("false", ""));
    return (W, Q) => (g(), D(Fe(I(o)), me({
      class: ["tw-font-base tw-ease-linear tw-inline-block tw-rounded-sm tw-transition-all tw-duration-100 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus disabled:tw-pointer-events-none", [$.value, U.value]],
      "data-allow-mismatch": "class"
    }, { ...I(r), ...I(s) }), {
      default: K(() => [
        R("span", Di, [
          W.iconLeftName ? (g(), D(j, {
            key: 0,
            name: W.iconLeftName,
            size: I(i)
          }, null, 8, ["name", "size"])) : A("", !0),
          I(_)(n.default) ? V(W.$slots, "default", { key: 1 }) : W.text ? (g(), S("span", Ri, Z(W.text), 1)) : A("", !0),
          W.iconRightName ? (g(), D(j, {
            key: 3,
            name: W.iconRightName,
            size: I(i)
          }, null, 8, ["name", "size"])) : A("", !0)
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), Hi = { class: "tw-flex tw-flex-grow tw-flex-col tw-gap-3xs" }, Vi = {
  key: 1,
  class: "tw-flex-grow tw-gap-3xs"
}, Bi = {
  key: 2,
  class: "tw-flex tw-h-xl"
}, ji = /* @__PURE__ */ B({
  __name: "UIBanner",
  props: {
    state: { default: "brand" },
    customIconName: { default: "" },
    isDismissible: { type: Boolean, default: !1 },
    isSplitInTwoLines: { type: Boolean, default: !0 },
    link: { default: "" },
    target: { default: "_blank" },
    ctaText: { default: "" },
    ctaHref: { default: "" },
    ctaTarget: { default: "_blank" }
  },
  emits: ["dismiss", "previous", "next", "click", "ctaClick"],
  setup(e, { emit: t }) {
    const n = t, o = pe(), r = C(() => _(o.paginationText)), a = C(() => {
      if (e.customIconName) return e.customIconName;
      const u = {
        success: "mdi:check-circle",
        caution: "mdi:information-slab-circle",
        error: "mdi:alert-circle",
        brand: "groover:logo",
        tip: "mdi:lightbulb-on",
        accent: "groover:groover-plus-logo"
      };
      return u[e.state] || u.brand;
    }), i = C(() => {
      const u = {
        success: "tw-text-icon-success",
        caution: "tw-text-icon-caution",
        error: "tw-text-icon-error",
        brand: "tw-text-icon-brand",
        tip: "tw-text-icon-tip",
        accent: "tw-text-icon-accent"
      };
      return u[e.state] || u.brand;
    }), s = C(() => {
      const u = {
        success: "tw-bg-fill-success tw-border-success",
        caution: "tw-bg-fill-caution tw-border-caution",
        error: "tw-bg-fill-error tw-border-error",
        brand: "tw-bg-fill-brand tw-border-brand",
        tip: "tw-bg-fill-tip tw-border-tip",
        accent: "tw-bg-fill-accent-discrete2 tw-border-inverse-accent"
      };
      return u[e.state] || u.brand;
    }), l = C(() => {
      const u = {
        success: "tw-text-success",
        caution: "tw-text-caution",
        error: "tw-text-error",
        brand: "tw-text-primary",
        tip: "tw-text-black",
        accent: "tw-text-accent"
      };
      return "tw-font-bold " + (u[e.state] || u.brand);
    }), c = C(
      () => e.link ? {
        href: e.link,
        target: e.target,
        rel: "noopener"
      } : {}
    ), d = C(() => {
      const u = {
        success: "neutral",
        caution: "neutral",
        error: "neutral",
        brand: "default",
        tip: "neutral",
        accent: "accent"
      }, f = {
        success: "outlined",
        caution: "outlined",
        error: "outlined",
        brand: "outlined",
        tip: "outlined",
        accent: "primary"
      };
      return {
        color: u[e.state] || u.brand,
        variant: f[e.state] || f.brand,
        text: e.ctaText,
        to: e.ctaHref,
        target: e.ctaHref && e.ctaTarget ? e.ctaTarget : void 0
      };
    });
    return (u, f) => (g(), D(Fe(u.link ? "a" : "div"), me(c.value, {
      onClick: f[5] || (f[5] = (h) => n("click", h))
    }), {
      default: K(() => [
        R("div", {
          role: "note",
          class: M(["tw-text-body-sm tw-flex tw-gap-sm tw-rounded-sm tw-border-2 tw-p-md tw-text-sm tw-leading-sm", s.value])
        }, [
          re(j, {
            name: a.value,
            class: M(i.value)
          }, null, 8, ["name", "class"]),
          u.isSplitInTwoLines ? (g(), S("div", {
            key: 0,
            class: M(["tw-flex tw-flex-grow tw-flex-col tw-gap-xs", [
              r.value ? "lg:tw-flex-col" : "lg:tw-flex-row lg:tw-items-center"
            ]])
          }, [
            R("div", Hi, [
              I(_)(o.title) ? (g(), S("p", {
                key: 0,
                class: M(l.value)
              }, [
                V(u.$slots, "title")
              ], 2)) : A("", !0),
              R("p", null, [
                V(u.$slots, "content")
              ])
            ]),
            u.ctaText ? (g(), D(oo, me({ key: 0 }, d.value, {
              class: "tw-w-fit",
              size: "small",
              onClick: f[0] || (f[0] = (h) => n("ctaClick"))
            }), null, 16)) : A("", !0)
          ], 2)) : (g(), S("div", Vi, [
            R("p", null, [
              I(_)(o.title) ? (g(), S(tt, { key: 0 }, [
                R("span", {
                  class: M(l.value)
                }, [
                  V(u.$slots, "title")
                ], 2),
                f[6] || (f[6] = Co(" "))
              ], 64)) : A("", !0),
              V(u.$slots, "content")
            ]),
            u.ctaText ? (g(), D(oo, me({ key: 0 }, d.value, {
              class: "tw-mt-xs tw-w-fit",
              size: "small",
              onClick: f[1] || (f[1] = (h) => n("ctaClick"))
            }), null, 16)) : A("", !0)
          ])),
          r.value ? (g(), S("div", Bi, [
            R("button", {
              type: "button",
              "aria-label": "previous-arrow",
              class: "tw-text-icon-discrete",
              onClick: f[2] || (f[2] = Xt((h) => n("previous"), ["stop"]))
            }, [
              re(j, { name: "mdi:chevron-left" })
            ]),
            V(u.$slots, "paginationText"),
            R("button", {
              type: "button",
              class: "tw-text-icon-discrete",
              "aria-label": "next-arrow",
              onClick: f[3] || (f[3] = Xt((h) => n("next"), ["stop"]))
            }, [
              re(j, { name: "mdi:chevron-right" })
            ])
          ])) : A("", !0),
          u.isDismissible ? (g(), S("button", {
            key: 3,
            type: "button",
            class: "tw-font-semibold tw-mb-auto tw-ml-auto tw-h-xl tw-cursor-pointer tw-text-sm tw-text-icon-discrete",
            onClick: f[4] || (f[4] = (h) => n("dismiss"))
          }, [
            re(j, { name: "mdi:close" })
          ])) : A("", !0)
        ], 2)
      ]),
      _: 3
    }, 16));
  }
}), M0 = /* @__PURE__ */ B({
  __name: "UIBannerMulti",
  props: {
    config: {},
    pageSeparatorText: { default: "-" },
    isDismissible: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = pe(), n = G(0), o = C(() => e.config[n.value]);
    function r() {
      n.value === e.config.length - 1 ? n.value = 0 : n.value++;
    }
    function a() {
      n.value === 0 ? n.value = e.config.length - 1 : n.value--;
    }
    return e.config.length < 1 && console.error("UIBannerMulti requires at least one UIBanner component"), e.config.length !== Object.keys(t).filter((i) => i.startsWith("content")).length && console.error(
      "UIBannerMulti requires the same number of content slots and single UIBanner configs"
    ), (i, s) => (g(), D(ji, me(o.value, {
      "is-dismissible": i.isDismissible,
      onNext: r,
      onPrevious: a
    }), {
      paginationText: K(() => [
        Co(Z(n.value + 1) + " " + Z(i.pageSeparatorText) + " " + Z(i.config.length), 1)
      ]),
      title: K(() => [
        V(i.$slots, `title${n.value + 1}`)
      ]),
      content: K(() => [
        V(i.$slots, `content${n.value + 1}`)
      ]),
      _: 3
    }, 16, ["is-dismissible"]));
  }
}), Ui = {
  key: 1,
  class: "tw-relative"
}, Wi = { class: "link-text tw-inline-block tw-w-full tw-transform tw-transition-transform tw-duration-[650ms] tw-ease-smooth" }, _i = {}, Ki = /* @__PURE__ */ B({
  ..._i,
  __name: "UIButtonLink",
  props: {
    color: { default: "default" },
    theme: { default: "light" },
    iconLeftName: { default: null },
    iconRightName: { default: null },
    to: { default: void 0 },
    size: { default: "medium" },
    isExternal: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, { linkOrButtonComponent: n, localePath: o, isExternalLink: r } = Ot(
      () => t.to
    ), a = it(), { scaledButtonSize: i, scaledIconSize: s } = ar(
      xn(() => t.size)
    ), l = "tw-text-sm tw-leading-sm", c = "tw-text-base tw-leading", d = "tw-text-base tw-leading", u = C(() => t.theme === "light"), f = C(
      () => u.value ? "tw-text-primary tw-bg-gradient-to-r tw-from-bg-primary tw-to-bg-primary" : "tw-text-link-inverse tw-bg-gradient-to-r tw-from-bg-primary tw-to-bg-primary"
    ), h = C(
      () => u.value ? "tw-bg-gradient-to-r tw-from-bg-fill-alt" : "tw-text-inverse tw-bg-gradient-to-r tw-from-bg-fill"
    ), m = C(
      () => u.value ? "tw-text-accent tw-bg-gradient-to-r tw-from-bg-fill-accent" : "tw-text-inverse-accent tw-bg-gradient-to-r tw-from-bg-fill-accent"
    ), y = "tw-text-primary-disabled tw-pointer-events-none", w = C(
      () => u.value ? "!tw-text-disabled tw-pointer-events-none" : "!tw-text-inverse-disabled tw-pointer-events-none"
    ), p = "tw-text-accent-disabled tw-pointer-events-none", x = C(() => [
      t.color === "default" && f.value,
      t.color === "neutral" && h.value,
      t.color === "accent" && m.value,
      a.disabled !== void 0 && t.color === "default" && y,
      a.disabled !== void 0 && t.color === "neutral" && w.value,
      a.disabled !== void 0 && t.color === "accent" && p
    ].join(" ").replaceAll("false", "")), k = C(() => [
      i.value === "small" && l,
      i.value === "medium" && c,
      i.value === "large" && d
    ].join(" ").replaceAll("false", ""));
    return (T, F) => (g(), D(Fe(I(n)), {
      class: M(["link tw-ease-linear tw-flex tw-w-fit tw-items-center tw-gap-x-2xs tw-rounded-sm tw-transition-all tw-duration-100 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus", [x.value, k.value]]),
      href: T.isExternal || I(r)(T.to) ? T.to : I(o)(T.to),
      external: T.isExternal === !0 ? !0 : void 0,
      "data-allow-mismatch": "class"
    }, {
      default: K(() => [
        T.iconLeftName ? (g(), D(j, {
          key: 0,
          name: T.iconLeftName,
          size: I(s)
        }, null, 8, ["name", "size"])) : A("", !0),
        I(_)(T.$slots.default) ? (g(), S("span", Ui, [
          R("span", Wi, [
            V(T.$slots, "default", {}, void 0, !0)
          ]),
          F[0] || (F[0] = R("span", { class: "link-underline tw-absolute tw-bottom-zero tw-left-zero tw-h-4xs tw-w-full tw-ease-slow-down motion-safe:tw-transform motion-safe:tw-transition-transform motion-safe:tw-duration-[650ms]" }, null, -1))
        ])) : A("", !0),
        T.iconRightName ? (g(), D(j, {
          key: 2,
          name: T.iconRightName,
          size: I(s)
        }, null, 8, ["name", "size"])) : A("", !0)
      ]),
      _: 3
    }, 8, ["class", "href", "external"]));
  }
}), ir = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, r] of t)
    n[o] = r;
  return n;
}, $0 = /* @__PURE__ */ ir(Ki, [["__scopeId", "data-v-af341000"]]), qi = { key: 0 }, Gi = {
  key: 1,
  class: "tw-flex-1"
}, Qi = { key: 2 }, Yi = {}, F0 = /* @__PURE__ */ B({
  ...Yi,
  __name: "UICard",
  props: {
    hasError: { type: Boolean, default: !1 },
    hasHoverState: { type: Boolean, default: !1 },
    is: { default: "article" },
    shouldWrapContent: { type: Boolean, default: !1 },
    shouldWrapContentOnMobile: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, n = it(), o = C(
      () => n.disabled !== void 0 && n.disabled !== !1
    ), r = C(() => [
      t.shouldWrapContent ? "tw-flex-col tw-items-start" : t.shouldWrapContentOnMobile ? "tw-flex-col lg:tw-flex-row lg:tw-items-center" : "tw-flex-row tw-items-center"
    ]);
    return (a, i) => (g(), D(Fe(a.is), {
      class: M(["tw-flex tw-gap-md tw-rounded-md tw-border tw-bg-surface tw-px-lg tw-py-md", [
        [
          a.hasError ? "tw-border-error" : o.value ? "tw-border-disabled tw-opacity-25" : "tw-border-discrete3"
        ],
        r.value,
        {
          "tw-transition-colors hover:tw-border-default": a.hasHoverState && !o.value && !a.hasError
        }
      ]])
    }, {
      default: K(() => [
        I(_)(a.$slots.header) ? (g(), S("header", qi, [
          V(a.$slots, "header")
        ])) : A("", !0),
        I(_)(a.$slots.default) ? (g(), S("main", Gi, [
          V(a.$slots, "default")
        ])) : A("", !0),
        I(_)(a.$slots.footer) ? (g(), S("footer", Qi, [
          V(a.$slots, "footer")
        ])) : A("", !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Xi = {}, N0 = /* @__PURE__ */ B({
  ...Xi,
  __name: "UIChipButton",
  props: {
    text: {},
    iconLeftName: {},
    iconRightName: {},
    disabled: { type: Boolean },
    to: { default: () => {
    } }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t, { linkOrButtonComponent: o, componentAttrs: r } = Ot(() => e.to);
    return (a, i) => (g(), D(tr, me({ component: I(o) }, I(r), {
      text: a.text,
      "icon-left-name": a.iconLeftName,
      "icon-right-name": a.iconRightName,
      disabled: a.disabled,
      onClick: i[0] || (i[0] = (s) => n("click"))
    }), null, 16, ["component", "text", "icon-left-name", "icon-right-name", "disabled"]));
  }
}), Zi = {}, O0 = /* @__PURE__ */ B({
  ...Zi,
  __name: "UIChipSelection",
  props: /* @__PURE__ */ oe({
    text: {},
    disabled: { type: Boolean },
    size: {},
    iconLeftName: {}
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ oe(["click"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = t, o = fe(e, "modelValue");
    function r() {
      e.disabled || (o.value = !o.value, n("click"));
    }
    return (a, i) => (g(), D(tr, {
      modelValue: o.value,
      "onUpdate:modelValue": i[0] || (i[0] = (s) => o.value = s),
      component: "input",
      text: a.text,
      "icon-left-name": a.iconLeftName,
      "icon-right-name": o.value ? "mdi:check" : "mdi:plus",
      disabled: a.disabled,
      size: a.size,
      color: o.value ? "alt" : "dashed",
      onClick: r
    }, null, 8, ["modelValue", "text", "icon-left-name", "icon-right-name", "disabled", "size", "color"]));
  }
}), Ji = ["top", "right", "bottom", "left"], je = Math.min, Ie = Math.max, Tt = Math.round, vt = Math.floor, ge = (e) => ({
  x: e,
  y: e
}), es = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, ts = {
  start: "end",
  end: "start"
};
function fn(e, t, n) {
  return Ie(e, je(t, n));
}
function _e(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ze(e) {
  return e.split("-")[0];
}
function ct(e) {
  return e.split("-")[1];
}
function sr(e) {
  return e === "x" ? "y" : "x";
}
function Mn(e) {
  return e === "y" ? "height" : "width";
}
function Ue(e) {
  return ["top", "bottom"].includes(ze(e)) ? "y" : "x";
}
function $n(e) {
  return sr(Ue(e));
}
function ns(e, t, n) {
  n === void 0 && (n = !1);
  const o = ct(e), r = $n(e), a = Mn(r);
  let i = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = St(i)), [i, St(i)];
}
function os(e) {
  const t = St(e);
  return [hn(e), t, hn(t)];
}
function hn(e) {
  return e.replace(/start|end/g, (t) => ts[t]);
}
function rs(e, t, n) {
  const o = ["left", "right"], r = ["right", "left"], a = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? r : o : t ? o : r;
    case "left":
    case "right":
      return t ? a : i;
    default:
      return [];
  }
}
function as(e, t, n, o) {
  const r = ct(e);
  let a = rs(ze(e), n === "start", o);
  return r && (a = a.map((i) => i + "-" + r), t && (a = a.concat(a.map(hn)))), a;
}
function St(e) {
  return e.replace(/left|right|bottom|top/g, (t) => es[t]);
}
function is(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function lr(e) {
  return typeof e != "number" ? is(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function It(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: r
  } = e;
  return {
    width: o,
    height: r,
    top: n,
    left: t,
    right: t + o,
    bottom: n + r,
    x: t,
    y: n
  };
}
function ro(e, t, n) {
  let {
    reference: o,
    floating: r
  } = e;
  const a = Ue(t), i = $n(t), s = Mn(i), l = ze(t), c = a === "y", d = o.x + o.width / 2 - r.width / 2, u = o.y + o.height / 2 - r.height / 2, f = o[s] / 2 - r[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: d,
        y: o.y - r.height
      };
      break;
    case "bottom":
      h = {
        x: d,
        y: o.y + o.height
      };
      break;
    case "right":
      h = {
        x: o.x + o.width,
        y: u
      };
      break;
    case "left":
      h = {
        x: o.x - r.width,
        y: u
      };
      break;
    default:
      h = {
        x: o.x,
        y: o.y
      };
  }
  switch (ct(t)) {
    case "start":
      h[i] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      h[i] += f * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const ss = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: i
  } = n, s = a.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let c = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: d,
    y: u
  } = ro(c, o, l), f = o, h = {}, m = 0;
  for (let y = 0; y < s.length; y++) {
    const {
      name: w,
      fn: p
    } = s[y], {
      x,
      y: k,
      data: T,
      reset: F
    } = await p({
      x: d,
      y: u,
      initialPlacement: o,
      placement: f,
      strategy: r,
      middlewareData: h,
      rects: c,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = x ?? d, u = k ?? u, h = {
      ...h,
      [w]: {
        ...h[w],
        ...T
      }
    }, F && m <= 50 && (m++, typeof F == "object" && (F.placement && (f = F.placement), F.rects && (c = F.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : F.rects), {
      x: d,
      y: u
    } = ro(c, f, l)), y = -1);
  }
  return {
    x: d,
    y: u,
    placement: f,
    strategy: r,
    middlewareData: h
  };
};
async function At(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: r,
    platform: a,
    rects: i,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: u = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = _e(t, e), m = lr(h), w = s[f ? u === "floating" ? "reference" : "floating" : u], p = It(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(w))) == null || n ? w : w.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: d,
    strategy: l
  })), x = u === "floating" ? {
    x: o,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, k = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), T = await (a.isElement == null ? void 0 : a.isElement(k)) ? await (a.getScale == null ? void 0 : a.getScale(k)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, F = It(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: x,
    offsetParent: k,
    strategy: l
  }) : x);
  return {
    top: (p.top - F.top + m.top) / T.y,
    bottom: (F.bottom - p.bottom + m.bottom) / T.y,
    left: (p.left - F.left + m.left) / T.x,
    right: (F.right - p.right + m.right) / T.x
  };
}
const ls = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: a,
      platform: i,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: d = 0
    } = _e(e, t) || {};
    if (c == null)
      return {};
    const u = lr(d), f = {
      x: n,
      y: o
    }, h = $n(r), m = Mn(h), y = await i.getDimensions(c), w = h === "y", p = w ? "top" : "left", x = w ? "bottom" : "right", k = w ? "clientHeight" : "clientWidth", T = a.reference[m] + a.reference[h] - f[h] - a.floating[m], F = f[h] - a.reference[h], z = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c));
    let $ = z ? z[k] : 0;
    (!$ || !await (i.isElement == null ? void 0 : i.isElement(z))) && ($ = s.floating[k] || a.floating[m]);
    const U = T / 2 - F / 2, W = $ / 2 - y[m] / 2 - 1, Q = je(u[p], W), ie = je(u[x], W), P = Q, v = $ - y[m] - ie, b = $ / 2 - y[m] / 2 + U, E = fn(P, b, v), O = !l.arrow && ct(r) != null && b !== E && a.reference[m] / 2 - (b < P ? Q : ie) - y[m] / 2 < 0, L = O ? b < P ? b - P : b - v : 0;
    return {
      [h]: f[h] + L,
      data: {
        [h]: E,
        centerOffset: b - E - L,
        ...O && {
          alignmentOffset: L
        }
      },
      reset: O
    };
  }
}), cs = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: d = !0,
        crossAxis: u = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: y = !0,
        ...w
      } = _e(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const p = ze(r), x = Ue(s), k = ze(s) === s, T = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), F = f || (k || !y ? [St(s)] : os(s)), z = m !== "none";
      !f && z && F.push(...as(s, y, m, T));
      const $ = [s, ...F], U = await At(t, w), W = [];
      let Q = ((o = a.flip) == null ? void 0 : o.overflows) || [];
      if (d && W.push(U[p]), u) {
        const b = ns(r, i, T);
        W.push(U[b[0]], U[b[1]]);
      }
      if (Q = [...Q, {
        placement: r,
        overflows: W
      }], !W.every((b) => b <= 0)) {
        var ie, P;
        const b = (((ie = a.flip) == null ? void 0 : ie.index) || 0) + 1, E = $[b];
        if (E)
          return {
            data: {
              index: b,
              overflows: Q
            },
            reset: {
              placement: E
            }
          };
        let O = (P = Q.filter((L) => L.overflows[0] <= 0).sort((L, H) => L.overflows[1] - H.overflows[1])[0]) == null ? void 0 : P.placement;
        if (!O)
          switch (h) {
            case "bestFit": {
              var v;
              const L = (v = Q.filter((H) => {
                if (z) {
                  const N = Ue(H.placement);
                  return N === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  N === "y";
                }
                return !0;
              }).map((H) => [H.placement, H.overflows.filter((N) => N > 0).reduce((N, Y) => N + Y, 0)]).sort((H, N) => H[1] - N[1])[0]) == null ? void 0 : v[0];
              L && (O = L);
              break;
            }
            case "initialPlacement":
              O = s;
              break;
          }
        if (r !== O)
          return {
            reset: {
              placement: O
            }
          };
      }
      return {};
    }
  };
};
function ao(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function io(e) {
  return Ji.some((t) => e[t] >= 0);
}
const us = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: o = "referenceHidden",
        ...r
      } = _e(e, t);
      switch (o) {
        case "referenceHidden": {
          const a = await At(t, {
            ...r,
            elementContext: "reference"
          }), i = ao(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: io(i)
            }
          };
        }
        case "escaped": {
          const a = await At(t, {
            ...r,
            altBoundary: !0
          }), i = ao(a, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: io(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function ds(e, t) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = e, a = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), i = ze(n), s = ct(n), l = Ue(n) === "y", c = ["left", "top"].includes(i) ? -1 : 1, d = a && l ? -1 : 1, u = _e(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: m
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return s && typeof m == "number" && (h = s === "end" ? m * -1 : m), l ? {
    x: h * d,
    y: f * c
  } : {
    x: f * c,
    y: h * d
  };
}
const fs = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: r,
        y: a,
        placement: i,
        middlewareData: s
      } = t, l = await ds(t, e);
      return i === ((n = s.offset) == null ? void 0 : n.placement) && (o = s.arrow) != null && o.alignmentOffset ? {} : {
        x: r + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, hs = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: r
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (w) => {
            let {
              x: p,
              y: x
            } = w;
            return {
              x: p,
              y: x
            };
          }
        },
        ...l
      } = _e(e, t), c = {
        x: n,
        y: o
      }, d = await At(t, l), u = Ue(ze(r)), f = sr(u);
      let h = c[f], m = c[u];
      if (a) {
        const w = f === "y" ? "top" : "left", p = f === "y" ? "bottom" : "right", x = h + d[w], k = h - d[p];
        h = fn(x, h, k);
      }
      if (i) {
        const w = u === "y" ? "top" : "left", p = u === "y" ? "bottom" : "right", x = m + d[w], k = m - d[p];
        m = fn(x, m, k);
      }
      const y = s.fn({
        ...t,
        [f]: h,
        [u]: m
      });
      return {
        ...y,
        data: {
          x: y.x - n,
          y: y.y - o,
          enabled: {
            [f]: a,
            [u]: i
          }
        }
      };
    }
  };
};
function Dt() {
  return typeof window < "u";
}
function Oe(e) {
  return Fn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ae(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function he(e) {
  var t;
  return (t = (Fn(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Fn(e) {
  return Dt() ? e instanceof Node || e instanceof ae(e).Node : !1;
}
function le(e) {
  return Dt() ? e instanceof Element || e instanceof ae(e).Element : !1;
}
function de(e) {
  return Dt() ? e instanceof HTMLElement || e instanceof ae(e).HTMLElement : !1;
}
function so(e) {
  return !Dt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ae(e).ShadowRoot;
}
function ut(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: r
  } = ce(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(r);
}
function ms(e) {
  return ["table", "td", "th"].includes(Oe(e));
}
function Rt(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Nn(e) {
  const t = On(), n = le(e) ? ce(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function ps(e) {
  let t = ye(e);
  for (; de(t) && !We(t); ) {
    if (Nn(t))
      return t;
    if (Rt(t))
      return null;
    t = ye(t);
  }
  return null;
}
function On() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function We(e) {
  return ["html", "body", "#document"].includes(Oe(e));
}
function ce(e) {
  return ae(e).getComputedStyle(e);
}
function Pt(e) {
  return le(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ye(e) {
  if (Oe(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    so(e) && e.host || // Fallback.
    he(e)
  );
  return so(t) ? t.host : t;
}
function cr(e) {
  const t = ye(e);
  return We(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : de(t) && ut(t) ? t : cr(t);
}
function at(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = cr(e), a = r === ((o = e.ownerDocument) == null ? void 0 : o.body), i = ae(r);
  if (a) {
    const s = mn(i);
    return t.concat(i, i.visualViewport || [], ut(r) ? r : [], s && n ? at(s) : []);
  }
  return t.concat(r, at(r, [], n));
}
function mn(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function ur(e) {
  const t = ce(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = de(e), a = r ? e.offsetWidth : n, i = r ? e.offsetHeight : o, s = Tt(n) !== a || Tt(o) !== i;
  return s && (n = a, o = i), {
    width: n,
    height: o,
    $: s
  };
}
function Ln(e) {
  return le(e) ? e : e.contextElement;
}
function Be(e) {
  const t = Ln(e);
  if (!de(t))
    return ge(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: r,
    $: a
  } = ur(t);
  let i = (a ? Tt(n.width) : n.width) / o, s = (a ? Tt(n.height) : n.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const vs = /* @__PURE__ */ ge(0);
function dr(e) {
  const t = ae(e);
  return !On() || !t.visualViewport ? vs : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function ws(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== ae(e) ? !1 : t;
}
function Me(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), a = Ln(e);
  let i = ge(1);
  t && (o ? le(o) && (i = Be(o)) : i = Be(e));
  const s = ws(a, n, o) ? dr(a) : ge(0);
  let l = (r.left + s.x) / i.x, c = (r.top + s.y) / i.y, d = r.width / i.x, u = r.height / i.y;
  if (a) {
    const f = ae(a), h = o && le(o) ? ae(o) : o;
    let m = f, y = mn(m);
    for (; y && o && h !== m; ) {
      const w = Be(y), p = y.getBoundingClientRect(), x = ce(y), k = p.left + (y.clientLeft + parseFloat(x.paddingLeft)) * w.x, T = p.top + (y.clientTop + parseFloat(x.paddingTop)) * w.y;
      l *= w.x, c *= w.y, d *= w.x, u *= w.y, l += k, c += T, m = ae(y), y = mn(m);
    }
  }
  return It({
    width: d,
    height: u,
    x: l,
    y: c
  });
}
function bs(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: r
  } = e;
  const a = r === "fixed", i = he(o), s = t ? Rt(t.floating) : !1;
  if (o === i || s && a)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = ge(1);
  const d = ge(0), u = de(o);
  if ((u || !u && !a) && ((Oe(o) !== "body" || ut(i)) && (l = Pt(o)), de(o))) {
    const f = Me(o);
    c = Be(o), d.x = f.x + o.clientLeft, d.y = f.y + o.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + d.x,
    y: n.y * c.y - l.scrollTop * c.y + d.y
  };
}
function gs(e) {
  return Array.from(e.getClientRects());
}
function pn(e, t) {
  const n = Pt(e).scrollLeft;
  return t ? t.left + n : Me(he(e)).left + n;
}
function ys(e) {
  const t = he(e), n = Pt(e), o = e.ownerDocument.body, r = Ie(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), a = Ie(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let i = -n.scrollLeft + pn(e);
  const s = -n.scrollTop;
  return ce(o).direction === "rtl" && (i += Ie(t.clientWidth, o.clientWidth) - r), {
    width: r,
    height: a,
    x: i,
    y: s
  };
}
function xs(e, t) {
  const n = ae(e), o = he(e), r = n.visualViewport;
  let a = o.clientWidth, i = o.clientHeight, s = 0, l = 0;
  if (r) {
    a = r.width, i = r.height;
    const c = On();
    (!c || c && t === "fixed") && (s = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s,
    y: l
  };
}
function Cs(e, t) {
  const n = Me(e, !0, t === "fixed"), o = n.top + e.clientTop, r = n.left + e.clientLeft, a = de(e) ? Be(e) : ge(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, l = r * a.x, c = o * a.y;
  return {
    width: i,
    height: s,
    x: l,
    y: c
  };
}
function lo(e, t, n) {
  let o;
  if (t === "viewport")
    o = xs(e, n);
  else if (t === "document")
    o = ys(he(e));
  else if (le(t))
    o = Cs(t, n);
  else {
    const r = dr(e);
    o = {
      ...t,
      x: t.x - r.x,
      y: t.y - r.y
    };
  }
  return It(o);
}
function fr(e, t) {
  const n = ye(e);
  return n === t || !le(n) || We(n) ? !1 : ce(n).position === "fixed" || fr(n, t);
}
function ks(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = at(e, [], !1).filter((s) => le(s) && Oe(s) !== "body"), r = null;
  const a = ce(e).position === "fixed";
  let i = a ? ye(e) : e;
  for (; le(i) && !We(i); ) {
    const s = ce(i), l = Nn(i);
    !l && s.position === "fixed" && (r = null), (a ? !l && !r : !l && s.position === "static" && !!r && ["absolute", "fixed"].includes(r.position) || ut(i) && !l && fr(e, i)) ? o = o.filter((d) => d !== i) : r = s, i = ye(i);
  }
  return t.set(e, o), o;
}
function Ts(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = e;
  const i = [...n === "clippingAncestors" ? Rt(t) ? [] : ks(t, this._c) : [].concat(n), o], s = i[0], l = i.reduce((c, d) => {
    const u = lo(t, d, r);
    return c.top = Ie(u.top, c.top), c.right = je(u.right, c.right), c.bottom = je(u.bottom, c.bottom), c.left = Ie(u.left, c.left), c;
  }, lo(t, s, r));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Ss(e) {
  const {
    width: t,
    height: n
  } = ur(e);
  return {
    width: t,
    height: n
  };
}
function Is(e, t, n) {
  const o = de(t), r = he(t), a = n === "fixed", i = Me(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = ge(0);
  if (o || !o && !a)
    if ((Oe(t) !== "body" || ut(r)) && (s = Pt(t)), o) {
      const h = Me(t, !0, a, t);
      l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
    } else r && (l.x = pn(r));
  let c = 0, d = 0;
  if (r && !o && !a) {
    const h = r.getBoundingClientRect();
    d = h.top + s.scrollTop, c = h.left + s.scrollLeft - // RTL <body> scrollbar.
    pn(r, h);
  }
  const u = i.left + s.scrollLeft - l.x - c, f = i.top + s.scrollTop - l.y - d;
  return {
    x: u,
    y: f,
    width: i.width,
    height: i.height
  };
}
function qt(e) {
  return ce(e).position === "static";
}
function co(e, t) {
  if (!de(e) || ce(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return he(e) === n && (n = n.ownerDocument.body), n;
}
function hr(e, t) {
  const n = ae(e);
  if (Rt(e))
    return n;
  if (!de(e)) {
    let r = ye(e);
    for (; r && !We(r); ) {
      if (le(r) && !qt(r))
        return r;
      r = ye(r);
    }
    return n;
  }
  let o = co(e, t);
  for (; o && ms(o) && qt(o); )
    o = co(o, t);
  return o && We(o) && qt(o) && !Nn(o) ? n : o || ps(e) || n;
}
const As = async function(e) {
  const t = this.getOffsetParent || hr, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: Is(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Es(e) {
  return ce(e).direction === "rtl";
}
const zs = {
  convertOffsetParentRelativeRectToViewportRelativeRect: bs,
  getDocumentElement: he,
  getClippingRect: Ts,
  getOffsetParent: hr,
  getElementRects: As,
  getClientRects: gs,
  getDimensions: Ss,
  getScale: Be,
  isElement: le,
  isRTL: Es
};
function Ms(e, t) {
  let n = null, o;
  const r = he(e);
  function a() {
    var s;
    clearTimeout(o), (s = n) == null || s.disconnect(), n = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const {
      left: c,
      top: d,
      width: u,
      height: f
    } = e.getBoundingClientRect();
    if (s || t(), !u || !f)
      return;
    const h = vt(d), m = vt(r.clientWidth - (c + u)), y = vt(r.clientHeight - (d + f)), w = vt(c), x = {
      rootMargin: -h + "px " + -m + "px " + -y + "px " + -w + "px",
      threshold: Ie(0, je(1, l)) || 1
    };
    let k = !0;
    function T(F) {
      const z = F[0].intersectionRatio;
      if (z !== l) {
        if (!k)
          return i();
        z ? i(!1, z) : o = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      k = !1;
    }
    try {
      n = new IntersectionObserver(T, {
        ...x,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(T, x);
    }
    n.observe(e);
  }
  return i(!0), a;
}
function $s(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, c = Ln(e), d = r || a ? [...c ? at(c) : [], ...at(t)] : [];
  d.forEach((p) => {
    r && p.addEventListener("scroll", n, {
      passive: !0
    }), a && p.addEventListener("resize", n);
  });
  const u = c && s ? Ms(c, n) : null;
  let f = -1, h = null;
  i && (h = new ResizeObserver((p) => {
    let [x] = p;
    x && x.target === c && h && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var k;
      (k = h) == null || k.observe(t);
    })), n();
  }), c && !l && h.observe(c), h.observe(t));
  let m, y = l ? Me(e) : null;
  l && w();
  function w() {
    const p = Me(e);
    y && (p.x !== y.x || p.y !== y.y || p.width !== y.width || p.height !== y.height) && n(), y = p, m = requestAnimationFrame(w);
  }
  return n(), () => {
    var p;
    d.forEach((x) => {
      r && x.removeEventListener("scroll", n), a && x.removeEventListener("resize", n);
    }), u == null || u(), (p = h) == null || p.disconnect(), h = null, l && cancelAnimationFrame(m);
  };
}
const Fs = fs, Ns = hs, Os = cs, Ls = us, Ds = ls, Rs = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: zs,
    ...n
  }, a = {
    ...r.platform,
    _c: o
  };
  return ss(e, t, {
    ...r,
    platform: a
  });
};
function Ps(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function vn(e) {
  if (Ps(e)) {
    const t = e.$el;
    return Fn(t) && Oe(t) === "#comment" ? null : t;
  }
  return e;
}
function Re(e) {
  return typeof e == "function" ? e() : I(e);
}
function Hs(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const n = vn(Re(e.element));
      return n == null ? {} : Ds({
        element: n,
        padding: e.padding
      }).fn(t);
    }
  };
}
function mr(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function uo(e, t) {
  const n = mr(e);
  return Math.round(t * n) / n;
}
function Vs(e, t, n) {
  n === void 0 && (n = {});
  const o = n.whileElementsMounted, r = C(() => {
    var $;
    return ($ = Re(n.open)) != null ? $ : !0;
  }), a = C(() => Re(n.middleware)), i = C(() => {
    var $;
    return ($ = Re(n.placement)) != null ? $ : "bottom";
  }), s = C(() => {
    var $;
    return ($ = Re(n.strategy)) != null ? $ : "absolute";
  }), l = C(() => {
    var $;
    return ($ = Re(n.transform)) != null ? $ : !0;
  }), c = C(() => vn(e.value)), d = C(() => vn(t.value)), u = G(0), f = G(0), h = G(s.value), m = G(i.value), y = Ae({}), w = G(!1), p = C(() => {
    const $ = {
      position: h.value,
      left: "0",
      top: "0"
    };
    if (!d.value)
      return $;
    const U = uo(d.value, u.value), W = uo(d.value, f.value);
    return l.value ? {
      ...$,
      transform: "translate(" + U + "px, " + W + "px)",
      ...mr(d.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: h.value,
      left: U + "px",
      top: W + "px"
    };
  });
  let x;
  function k() {
    if (c.value == null || d.value == null)
      return;
    const $ = r.value;
    Rs(c.value, d.value, {
      middleware: a.value,
      placement: i.value,
      strategy: s.value
    }).then((U) => {
      u.value = U.x, f.value = U.y, h.value = U.strategy, m.value = U.placement, y.value = U.middlewareData, w.value = $ !== !1;
    });
  }
  function T() {
    typeof x == "function" && (x(), x = void 0);
  }
  function F() {
    if (T(), o === void 0) {
      k();
      return;
    }
    if (c.value != null && d.value != null) {
      x = o(c.value, d.value, k);
      return;
    }
  }
  function z() {
    r.value || (w.value = !1);
  }
  return se([a, i, s, r], k, {
    flush: "sync"
  }), se([c, d], F, {
    flush: "sync"
  }), se(r, z, {
    flush: "sync"
  }), go() && yo(T), {
    x: Le(u),
    y: Le(f),
    strategy: Le(h),
    placement: Le(m),
    middlewareData: Le(y),
    isPositioned: Le(w),
    floatingStyles: p,
    update: k
  };
}
const pr = En ? window : void 0;
function Xe(e) {
  var t;
  const n = q(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function Pe(...e) {
  const t = [], n = () => {
    t.forEach((s) => s()), t.length = 0;
  }, o = (s, l, c, d) => (s.addEventListener(l, c, d), () => s.removeEventListener(l, c, d)), r = C(() => {
    const s = Se(q(e[0])).filter((l) => l != null);
    return s.every((l) => typeof l != "string") ? s : void 0;
  }), a = or(
    () => {
      var s, l;
      return [
        (l = (s = r.value) == null ? void 0 : s.map((c) => Xe(c))) != null ? l : [pr].filter((c) => c != null),
        Se(q(r.value ? e[1] : e[0])),
        Se(I(r.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        q(r.value ? e[3] : e[2])
      ];
    },
    ([s, l, c, d]) => {
      if (n(), !(s != null && s.length) || !(l != null && l.length) || !(c != null && c.length))
        return;
      const u = nr(d) ? { ...d } : d;
      t.push(
        ...s.flatMap(
          (f) => l.flatMap(
            (h) => c.map((m) => o(f, h, m, u))
          )
        )
      );
    },
    { flush: "post" }
  ), i = () => {
    a(), n();
  };
  return Lt(n), i;
}
let fo = !1;
function ho(e, t, n = {}) {
  const { window: o = pr, ignore: r = [], capture: a = !0, detectIframe: i = !1, controls: s = !1 } = n;
  if (!o)
    return s ? { stop: Ce, cancel: Ce, trigger: Ce } : Ce;
  if (un && !fo) {
    fo = !0;
    const w = { passive: !0 };
    Array.from(o.document.body.children).forEach((p) => Pe(p, "click", Ce, w)), Pe(o.document.documentElement, "click", Ce, w);
  }
  let l = !0;
  const c = (w) => q(r).some((p) => {
    if (typeof p == "string")
      return Array.from(o.document.querySelectorAll(p)).some((x) => x === w.target || w.composedPath().includes(x));
    {
      const x = Xe(p);
      return x && (w.target === x || w.composedPath().includes(x));
    }
  });
  function d(w) {
    const p = q(w);
    return p && p.$.subTree.shapeFlag === 16;
  }
  function u(w, p) {
    const x = q(w), k = x.$.subTree && x.$.subTree.children;
    return k == null || !Array.isArray(k) ? !1 : k.some((T) => T.el === p.target || p.composedPath().includes(T.el));
  }
  const f = (w) => {
    const p = Xe(e);
    if (w.target != null && !(!(p instanceof Element) && d(e) && u(e, w)) && !(!p || p === w.target || w.composedPath().includes(p))) {
      if ("detail" in w && w.detail === 0 && (l = !c(w)), !l) {
        l = !0;
        return;
      }
      t(w);
    }
  };
  let h = !1;
  const m = [
    Pe(o, "click", (w) => {
      h || (h = !0, setTimeout(() => {
        h = !1;
      }, 0), f(w));
    }, { passive: !0, capture: a }),
    Pe(o, "pointerdown", (w) => {
      const p = Xe(e);
      l = !c(w) && !!(p && !w.composedPath().includes(p));
    }, { passive: !0 }),
    i && Pe(o, "blur", (w) => {
      setTimeout(() => {
        var p;
        const x = Xe(e);
        ((p = o.document.activeElement) == null ? void 0 : p.tagName) === "IFRAME" && !(x != null && x.contains(o.document.activeElement)) && t(w);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), y = () => m.forEach((w) => w());
  return s ? {
    stop: y,
    cancel: () => {
      l = !1;
    },
    trigger: (w) => {
      l = !0, f(w), l = !1;
    }
  } : y;
}
const Bs = {
  mounted(e, t) {
    const n = !t.modifiers.bubble;
    if (typeof t.value == "function")
      e.__onClickOutside_stop = ho(e, t.value, { capture: n });
    else {
      const [o, r] = t.value;
      e.__onClickOutside_stop = ho(e, o, Object.assign({ capture: n }, r));
    }
  },
  unmounted(e) {
    e.__onClickOutside_stop();
  }
};
function Gt(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function vr(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const n = e.parentNode;
    return !n || n.tagName === "BODY" ? !1 : vr(n);
  }
}
function js(e) {
  const t = e || window.event, n = t.target;
  return vr(n) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}
const Qt = /* @__PURE__ */ new WeakMap();
function Us(e, t = !1) {
  const n = G(t);
  let o = null, r = "";
  se(ki(e), (s) => {
    const l = Gt(q(s));
    if (l) {
      const c = l;
      if (Qt.get(c) || Qt.set(c, c.style.overflow), c.style.overflow !== "hidden" && (r = c.style.overflow), c.style.overflow === "hidden")
        return n.value = !0;
      if (n.value)
        return c.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const a = () => {
    const s = Gt(q(e));
    !s || n.value || (un && (o = Pe(
      s,
      "touchmove",
      (l) => {
        js(l);
      },
      { passive: !1 }
    )), s.style.overflow = "hidden", n.value = !0);
  }, i = () => {
    const s = Gt(q(e));
    !s || !n.value || (un && (o == null || o()), s.style.overflow = r, Qt.delete(s), n.value = !1);
  };
  return Lt(i), C({
    get() {
      return n.value;
    },
    set(s) {
      s ? a() : i();
    }
  });
}
function Ws() {
  let e = !1;
  const t = Ae(!1);
  return (n, o) => {
    if (t.value = o.value, e)
      return;
    e = !0;
    const r = Us(n, o.value);
    se(t, (a) => r.value = a);
  };
}
Ws();
const _s = { class: "tw-w-fit" }, Ks = {
  ref: "referenceEl",
  class: "tw-w-fit"
}, qs = {}, wr = /* @__PURE__ */ B({
  ...qs,
  __name: "BaseFloating",
  props: {
    forceShowFloatingEl: { type: Boolean, default: void 0 },
    hasArrow: { type: Boolean, default: !1 },
    isStatic: { type: Boolean, default: !1 },
    offset: { default: 8 },
    placement: { default: "bottom-start" }
  },
  emits: ["click-outside", "show-floating", "hide-floating"],
  setup(e, { emit: t }) {
    const n = e, o = t, [r, a] = Si(!1), i = He("referenceEl"), s = He("floatingEl"), l = He("floatingArrowEl"), c = 8, d = n.isStatic ? [] : [
      Os({ padding: c }),
      Ns({ padding: c })
    ], u = [
      Fs(n.offset),
      ...d,
      Hs({
        element: l,
        // the distance in px the arrow can show up against the side of the floating element itself.
        // Use to avoid overlapping rounded corners
        padding: 8
      }),
      Ls()
    ], {
      floatingStyles: f,
      middlewareData: h,
      placement: m
    } = Vs(i, s, {
      middleware: u,
      /**
       * Update the floating element's position when the reference element's size or scroll position changes.
       *
       * @param referenceEl - The reference element.
       * @param floatingEl - The floating element.
       * @param update - The update function.
       * @returns - The cleanup function.
       */
      whileElementsMounted(p, x, k) {
        return $s(p, x, k, {
          ancestorScroll: !0,
          elementResize: !0
        });
      },
      placement: n.placement,
      strategy: "fixed"
    }), y = C(() => {
      var z;
      const { x: p, y: x } = ((z = h.value) == null ? void 0 : z.arrow) ?? {}, k = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[m.value.split("-")[0]], F = typeof n.offset == "number" ? n.offset : 8;
      return {
        left: p != null ? `${p}px` : "",
        top: x != null ? `${x}px` : "",
        right: "",
        bottom: "",
        [k]: `-${F / 2}px`
      };
    });
    se(r, (p) => {
      o(p ? "show-floating" : "hide-floating");
    }), se(
      () => n.forceShowFloatingEl,
      (p) => {
        p !== void 0 && a(p);
      },
      { immediate: !0 }
    );
    function w() {
      o("click-outside"), n.forceShowFloatingEl !== !0 && a(!1);
    }
    return (p, x) => Ee((g(), S("div", _s, [
      R("div", Ks, [
        V(p.$slots, "reference", {
          isFloatingElDisplayed: I(r),
          toggleContentDisplay: I(a)
        })
      ], 512),
      re(ko, {
        name: "fade",
        mode: "out-in",
        appear: ""
      }, {
        default: K(() => {
          var k;
          return [
            I(r) ? (g(), S("div", {
              key: 0,
              ref: "floatingEl",
              style: Rn({
                ...I(f),
                visibility: (k = I(h).hide) != null && k.referenceHidden ? "hidden" : "visible"
              }),
              class: "tw-z-[999999]"
            }, [
              p.hasArrow ? (g(), S("span", {
                key: 0,
                ref: "floatingArrowEl",
                "data-testid": "floating-arrow",
                class: "tw-absolute tw-size-sm tw-rotate-45 tw-transform tw-bg-fill-alt",
                style: Rn(y.value)
              }, null, 4)) : A("", !0),
              V(p.$slots, "floating", { toggleContentDisplay: I(a) })
            ], 4)) : A("", !0)
          ];
        }),
        _: 3
      })
    ])), [
      [I(Bs), w]
    ]);
  }
}), Gs = ["aria-controlledby", "onMouseleave", "onClick"], Qs = {}, L0 = /* @__PURE__ */ B({
  ...Qs,
  __name: "UIDropdownMenu",
  props: {
    displayMenuOnHover: { type: Boolean, default: !1 },
    hideDelay: { default: 500 },
    referenceComponent: {},
    referenceComponentAttrs: { default: () => ({}) }
  },
  setup(e) {
    const t = e, n = pe(), o = G(), r = Ne();
    function a(l) {
      t.displayMenuOnHover && (clearTimeout(o.value), o.value = setTimeout(() => l(!1), t.hideDelay));
    }
    function i() {
      clearTimeout(o.value);
    }
    function s(l) {
      t.displayMenuOnHover && (clearTimeout(o.value), l(!0));
    }
    return _(n.menuLists) || console.error('UIDropdownMenu requires a slot named "menuLists"'), (l, c) => (g(), D(wr, null, {
      reference: K(({ toggleContentDisplay: d, isFloatingElDisplayed: u }) => [
        l.referenceComponent ? (g(), D(Fe(l.referenceComponent), me({ key: 0 }, l.referenceComponentAttrs, {
          id: I(r),
          "aria-expanded": u,
          onClick: (f) => d(),
          onMouseover: (f) => s(d),
          onMouseleave: (f) => a(d)
        }), {
          default: K(() => [
            V(l.$slots, "referenceText")
          ]),
          _: 2
        }, 1040, ["id", "aria-expanded", "onClick", "onMouseover", "onMouseleave"])) : A("", !0)
      ]),
      floating: K(({ toggleContentDisplay: d }) => [
        I(_)(n.menuLists) ? (g(), S("div", {
          key: 0,
          class: "tw-flex tw-min-w-[160px] tw-flex-col tw-gap-y-3xs tw-rounded-lg tw-bg-surface tw-p-2xs tw-shadow-lg",
          "aria-controlledby": I(r),
          onMouseover: i,
          onMouseleave: (u) => a(d),
          onClick: (u) => d(!1)
        }, [
          V(l.$slots, "menuLists")
        ], 40, Gs)) : A("", !0)
      ]),
      _: 3
    }));
  }
}), Ys = {
  key: 0,
  class: "tw-text-body tw-rounded tw-px-md tw-py-sm tw-text-discrete"
}, Xs = {}, D0 = /* @__PURE__ */ B({
  ...Xs,
  __name: "UIDropdownMenuList",
  props: {
    title: { default: "" }
  },
  setup(e) {
    return (t, n) => (g(), S("ul", null, [
      t.title ? (g(), S("li", Ys, Z(t.title), 1)) : A("", !0),
      V(t.$slots, "default")
    ]));
  }
}), Zs = { class: "tw-flex tw-flex-1 tw-flex-col tw-items-start tw-gap-y-3xs" }, Js = { class: "tw-text-body" }, el = {
  key: 0,
  class: "tw-text-body-xs tw-text-discrete"
}, tl = {
  key: 1,
  class: "tw-text-body tw-text-discrete"
}, nl = {}, R0 = /* @__PURE__ */ B({
  ...nl,
  inheritAttrs: !1,
  __name: "UIDropdownMenuListItem",
  props: {
    href: { default: "" },
    isActive: { type: Boolean, default: !1 },
    leftIconName: { default: "" },
    rightIconName: { default: "" },
    rightSideText: { default: "" },
    size: { default: "base" },
    subText: { default: "" },
    text: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = it(), { linkOrButtonComponent: a } = Ot(
      () => n.href || r.to
    ), i = C(() => n.href || r.to ? {
      href: n.href || r.to,
      "aria-current": n.isActive ? "page" : void 0,
      ...r
    } : {
      type: "button",
      "aria-checked": n.isActive ? n.isActive : void 0,
      ...r
    });
    return (s, l) => (g(), S("li", null, [
      (g(), D(Fe(I(a)), me(i.value, {
        class: ["tw-flex tw-w-full tw-min-w-[160px] tw-items-center tw-gap-x-md tw-rounded tw-px-md hover:tw-bg-surface-hover", [
          {
            "tw-bg-fill-discrete3": s.isActive
          },
          s.size === "lg" ? "tw-py-md" : "tw-py-sm"
        ]],
        onClick: l[0] || (l[0] = (c) => o("click"))
      }), {
        default: K(() => [
          s.leftIconName ? (g(), D(j, {
            key: 0,
            name: s.leftIconName,
            class: "tw-text-icon-discrete2"
          }, null, 8, ["name"])) : A("", !0),
          R("span", Zs, [
            R("span", Js, Z(s.text), 1),
            s.subText ? (g(), S("span", el, Z(s.subText), 1)) : A("", !0)
          ]),
          s.rightSideText ? (g(), S("span", tl, Z(s.rightSideText), 1)) : A("", !0),
          s.rightIconName && s.isActive ? (g(), D(j, {
            key: 2,
            name: s.rightIconName,
            class: "tw-text-icon"
          }, null, 8, ["name"])) : A("", !0)
        ]),
        _: 1
      }, 16, ["class"]))
    ]));
  }
}), ol = ["id", "name", "checked", "disabled", "valid", "readonly"], rl = ["for"], al = {}, il = /* @__PURE__ */ B({
  ...al,
  __name: "UIInputCheckbox",
  props: /* @__PURE__ */ oe({
    isDisabled: { type: Boolean, default: !1 },
    isIndeterminate: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Ne(), n = fe(e, "modelValue");
    return (o, r) => (g(), S("span", {
      class: M(["tw-flex tw-h-full tw-items-center tw-justify-center tw-gap-md", {
        "tw-pointer-events-none": o.isDisabled
      }])
    }, [
      R("span", {
        class: M(["tw-relative tw-flex tw-h-xl tw-w-xl tw-flex-col tw-items-center tw-justify-center tw-rounded tw-border tw-border-discrete2 tw-bg-surface hover:tw-border-default-color disabled:tw-pointer-events-none", {
          "!tw-border-default-color !tw-bg-fill-alt": n.value && !o.isDisabled,
          "tw-border-2 !tw-border-error": o.hasError && !o.isDisabled,
          "!tw-bg-fill-error": o.hasError && !n.value && !o.isDisabled,
          "!tw-border-disabled !tw-bg-fill-alt-disabled": o.isDisabled
        }])
      }, [
        Ee(R("input", {
          id: I(t),
          "onUpdate:modelValue": r[0] || (r[0] = (a) => n.value = a),
          type: "checkbox",
          name: I(t),
          checked: n.value,
          disabled: o.isDisabled,
          valid: o.hasError ? !1 : void 0,
          readonly: o.isDisabled,
          class: "tw-absolute tw-flex tw-h-full tw-w-full tw-appearance-none tw-rounded focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus"
        }, null, 8, ol), [
          [To, n.value]
        ]),
        n.value ? (g(), D(j, {
          key: 0,
          name: o.isIndeterminate ? "material-symbols:remove" : "material-symbols:check",
          size: "sm",
          class: M(["tw-text-inverse", {
            "!tw-text-disabled": o.isDisabled
          }])
        }, null, 8, ["name", "class"])) : A("", !0)
      ], 2),
      I(_)(o.$slots.label) ? (g(), S("label", {
        key: 0,
        for: I(t),
        class: "tw-flex-1 tw-items-center tw-justify-center"
      }, [
        V(o.$slots, "label")
      ], 8, rl)) : A("", !0)
    ], 2));
  }
}), sl = ["for"], ll = {
  key: 0,
  class: "tw-ml-sm tw-font-normal tw-text-discrete2"
}, cl = {}, br = /* @__PURE__ */ B({
  ...cl,
  __name: "UIInputLabel",
  props: {
    htmlFor: {},
    optionalText: { default: "" }
  },
  setup(e) {
    return (t, n) => (g(), S("label", {
      for: t.htmlFor,
      class: "tw-block tw-text-base tw-font-bold"
    }, [
      V(t.$slots, "default"),
      t.optionalText ? (g(), S("span", ll, Z(t.optionalText), 1)) : A("", !0)
    ], 8, sl));
  }
}), ul = ["id", "type", "placeholder", "name", "autocomplete", "disabled", "aria-invalid"], dl = {
  key: 1,
  class: "tw-text-form-error tw-mt-2xs tw-inline-block"
}, fl = {}, gr = /* @__PURE__ */ B({
  ...fl,
  __name: "BaseInput",
  props: /* @__PURE__ */ oe({
    errorText: { default: "" },
    helperText: { default: "" },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    name: {},
    placeholder: { default: "" },
    iconLeftName: { default: null },
    type: { default: "text" },
    optionalLabelText: { default: "" },
    autocomplete: { default: void 0 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ oe(["focus", "blur"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, o = t, r = pe(), a = Ne(), i = fe(e, "modelValue"), s = `error-message-${a}`, l = C(() => [
      (n.errorText || _(r["error-text"])) && "tw-border-2 tw-border-error tw-bg-fill-error",
      n.isDisabled && "tw-pointer-events-none tw-bg-fill-alt-disabled tw-border-disabled",
      n.inputSize === "large" ? "tw-h-5xl tw-py-md" : "tw-h-4xl tw-py-sm"
    ].join(" ").replaceAll("false", "")), c = C(() => !!n.errorText || _(r["error-text"])), d = C(() => i.value && n.type === "password" ? "tw-text-success" : "tw-text-discrete2");
    return (u, f) => (g(), S("div", null, [
      I(_)(u.$slots.label) ? (g(), D(br, {
        key: 0,
        "optional-text": u.optionalLabelText,
        "html-for": I(a),
        class: "tw-mb-2xs"
      }, {
        default: K(() => [
          V(u.$slots, "label")
        ]),
        _: 3
      }, 8, ["optional-text", "html-for"])) : A("", !0),
      R("div", {
        class: M(["tw-bg tw-relative tw-flex tw-w-full tw-items-center tw-gap-sm tw-rounded tw-border tw-border-discrete2 tw-px-md focus-within:tw-bg-surface focus-within:tw-outline focus-within:tw-outline-2 focus-within:tw-outline-focus hover:tw-border-default-color", l.value])
      }, [
        u.iconLeftName ? (g(), D(j, {
          key: 0,
          name: u.iconLeftName,
          size: "lg",
          class: "tw-text-icon-discrete2"
        }, null, 8, ["name"])) : A("", !0),
        Ee(R("input", {
          id: I(a),
          "onUpdate:modelValue": f[0] || (f[0] = (h) => i.value = h),
          type: u.type,
          placeholder: u.placeholder,
          name: u.name,
          autocomplete: u.autocomplete,
          disabled: u.isDisabled,
          "aria-invalid": c.value,
          "aria-errormessage": s,
          class: "tw-h-2xl tw-w-full tw-rounded tw-bg-transparent tw-outline-none placeholder:tw-text-discrete2",
          onFocus: f[1] || (f[1] = (h) => o("focus")),
          onBlur: f[2] || (f[2] = (h) => o("blur"))
        }, null, 40, ul), [
          [So, i.value]
        ]),
        V(u.$slots, "icon-button-right")
      ], 2),
      c.value ? (g(), S("span", {
        key: 1,
        id: s
      }, [
        I(_)(r["error-text"]) ? V(u.$slots, "error-text", { key: 0 }) : u.errorText ? (g(), S("span", dl, Z(u.errorText), 1)) : A("", !0)
      ])) : u.helperText ? (g(), S("span", {
        key: 2,
        class: M(["tw-mt-2xs tw-inline-block tw-text-sm", d.value])
      }, Z(u.helperText), 3)) : A("", !0)
    ]));
  }
}), hl = ["aria-label"], ml = {}, P0 = /* @__PURE__ */ B({
  ...ml,
  __name: "UIInputPassword",
  props: /* @__PURE__ */ oe({
    errorText: { default: "" },
    helperText: { default: "" },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    name: { default: "password" },
    placeholder: { default: "" },
    toggleVisibilityAriaText: { default: "" },
    autocomplete: { default: "current-password" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = fe(e, "modelValue"), n = G("material-symbols:visibility-outline"), o = G("password");
    function r() {
      o.value === "password" ? (n.value = "material-symbols:visibility-off-outline", o.value = "text") : (n.value = "material-symbols:visibility-outline", o.value = "password");
    }
    return (a, i) => (g(), D(gr, {
      modelValue: t.value,
      "onUpdate:modelValue": i[0] || (i[0] = (s) => t.value = s),
      "icon-left-name": "material-symbols:lock-outline",
      type: o.value,
      placeholder: a.placeholder,
      name: a.name,
      "helper-text": a.helperText,
      "error-text": a.errorText,
      autocomplete: a.autocomplete,
      "is-disabled": a.isDisabled
    }, Io({
      "icon-button-right": K(() => [
        R("button", {
          class: "tw-h-xl",
          type: "button",
          "aria-label": a.toggleVisibilityAriaText,
          onClick: r
        }, [
          re(j, {
            name: n.value,
            class: "tw-text-icon-discrete2"
          }, null, 8, ["name"])
        ], 8, hl)
      ]),
      _: 2
    }, [
      I(_)(a.$slots.label) ? {
        name: "label",
        fn: K(() => [
          V(a.$slots, "label")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["modelValue", "type", "placeholder", "name", "helper-text", "error-text", "autocomplete", "is-disabled"]));
  }
}), pl = ["aria-label"], vl = {}, H0 = /* @__PURE__ */ B({
  ...vl,
  __name: "UIInputText",
  props: /* @__PURE__ */ oe({
    clearInputAriaText: { default: "" },
    errorText: { default: "" },
    helperText: { default: "" },
    iconLeftName: { default: null },
    inputSize: { default: "normal" },
    isDisabled: { type: Boolean, default: !1 },
    isIconRightVisible: { type: Boolean, default: !0 },
    isValidating: { type: Boolean, default: !1 },
    name: {},
    optionalLabelText: { default: "" },
    placeholder: { default: "" },
    type: { default: "text" },
    autocomplete: { default: void 0 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = pe(), o = fe(e, "modelValue"), r = G(!1), a = G(!1), i = C(() => r.value || a.value), s = C(() => t.errorText || _(n["error-text"])), l = C(() => !!(t.isIconRightVisible && i.value && o.value && c.value !== "eos-icons:loading" || s.value && !t.isValidating)), c = C(() => t.isValidating ? "eos-icons:loading" : s.value || l.value ? "mdi:close" : o.value && !s.value ? "material-symbols:check" : ""), d = C(() => o.value && !s.value && !l.value && !t.isValidating ? "tw-text-icon-success" : "tw-text-icon-discrete2"), u = C(() => t.isIconRightVisible && !l.value && c.value);
    se(c, () => {
    });
    function f() {
      o.value = "";
    }
    function h() {
      setTimeout(() => {
        r.value = !1;
      }, 10);
    }
    return (m, y) => (g(), D(gr, {
      ref: "input",
      modelValue: o.value,
      "onUpdate:modelValue": y[2] || (y[2] = (w) => o.value = w),
      "icon-left-name": m.iconLeftName,
      type: m.type,
      placeholder: m.placeholder,
      name: m.name,
      "helper-text": m.helperText,
      "error-text": m.errorText,
      "input-size": m.inputSize,
      "optional-label-text": m.optionalLabelText,
      "is-disabled": m.isDisabled,
      autocomplete: m.autocomplete,
      onFocus: y[3] || (y[3] = (w) => r.value = !0),
      onBlur: h
    }, Io({
      "icon-button-right": K(() => [
        l.value && !m.isDisabled ? (g(), S("button", {
          key: 0,
          type: "button",
          class: "tw-h-xl",
          "aria-label": m.clearInputAriaText,
          onClick: f,
          onFocus: y[0] || (y[0] = (w) => a.value = !0),
          onBlur: y[1] || (y[1] = (w) => a.value = !1)
        }, [
          re(j, {
            name: c.value,
            class: M(d.value)
          }, null, 8, ["name", "class"])
        ], 40, pl)) : u.value && !m.isDisabled ? (g(), D(j, {
          key: 1,
          name: c.value,
          class: M(d.value)
        }, null, 8, ["name", "class"])) : A("", !0)
      ]),
      _: 2
    }, [
      I(_)(m.$slots.label) ? {
        name: "label",
        fn: K(() => [
          V(m.$slots, "label")
        ]),
        key: "0"
      } : void 0,
      I(_)(n["error-text"]) ? {
        name: "error-text",
        fn: K(() => [
          V(m.$slots, "error-text")
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["modelValue", "icon-left-name", "type", "placeholder", "name", "helper-text", "error-text", "input-size", "optional-label-text", "is-disabled", "autocomplete"]));
  }
}), wl = {
  key: 0,
  class: "tw-mb-2xl tw-mt-sm"
}, bl = ["id", "placeholder", "name", "disabled"], gl = {
  key: 1,
  class: "tw-text-form-error tw-mt-2xs tw-inline-block"
}, yl = {
  key: 2,
  class: "tw-mt-2xs tw-inline-block tw-text-sm tw-text-discrete2"
}, V0 = /* @__PURE__ */ B({
  __name: "UIInputTextarea",
  props: /* @__PURE__ */ oe({
    errorText: { default: "" },
    helperText: { default: "" },
    isDisabled: { type: Boolean, default: !1 },
    name: {},
    placeholder: { default: "" },
    optionalLabelText: { default: "" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, n = Ne(), o = fe(e, "modelValue"), r = C(() => [
      t.errorText && "tw-border-2 tw-border-error tw-bg-fill-error",
      t.isDisabled && "tw-pointer-events-none tw-bg-fill-alt-disabled tw-border-disabled"
    ].join(" ").replaceAll("false", ""));
    return (a, i) => (g(), S("div", null, [
      re(br, {
        "optional-text": a.optionalLabelText,
        "html-for": I(n)
      }, {
        default: K(() => [
          V(a.$slots, "label")
        ]),
        _: 3
      }, 8, ["optional-text", "html-for"]),
      I(_)(a.$slots.tip) ? (g(), S("div", wl, [
        V(a.$slots, "tip")
      ])) : A("", !0),
      Ee(R("textarea", {
        id: I(n),
        "onUpdate:modelValue": i[0] || (i[0] = (s) => o.value = s),
        class: M(["tw-text-body tw-relative tw-flex tw-max-h-[50vh] tw-min-h-[88px] tw-w-full tw-items-center tw-gap-sm tw-rounded tw-border tw-border-discrete2 tw-bg-transparent tw-p-md placeholder:tw-text-discrete2 focus-within:tw-bg-surface focus-within:tw-outline focus-within:tw-outline-2 focus-within:tw-outline-focus hover:tw-border-default-color", r.value]),
        placeholder: a.placeholder,
        name: a.name,
        disabled: a.isDisabled
      }, null, 10, bl), [
        [So, o.value]
      ]),
      a.errorText ? (g(), S("span", gl, Z(a.errorText), 1)) : a.helperText ? (g(), S("span", yl, Z(a.helperText), 1)) : A("", !0)
    ]));
  }
}), xl = ["id", "name", "checked", "disabled", "readonly", "valid"], Cl = {}, B0 = /* @__PURE__ */ B({
  ...Cl,
  __name: "UIInputToggleCheckbox",
  props: /* @__PURE__ */ oe({
    disabled: { type: Boolean, default: !1 },
    size: { default: "base" },
    iconName: { default: "mdi:check" },
    theme: { default: "light" },
    hasError: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = fe(e, "modelValue"), n = Ne(), o = C(
      () => e.size === "sm" ? "tw-rounded-2xl" : e.size === "lg" ? "tw-rounded-4xl" : "tw-rounded-3xl"
    ), r = C(
      () => e.size === "sm" ? "tw-px-2xs tw-py-3xs" : e.size === "lg" ? "tw-p-sm" : "tw-p-xs"
    ), a = C(
      () => e.size === "sm" ? "tw-h-2xl tw-min-w-2xl" : e.size === "lg" ? "tw-h-4xl tw-min-w-4xl" : "tw-h-3xl tw-min-w-3xl"
    ), i = C(() => e.disabled ? "tw-bg-fill-discrete" : e.theme === "light" ? t.value ? "tw-bg-fill-alt hover:tw-bg-fill-alt-hover" : "tw-bg-fill-neutral hover:tw-bg-fill-neutral-hover" : t.value ? "tw-bg-surface hover:tw-bg-surface-hover" : "tw-bg-fill-neutral hover:tw-bg-fill-neutral-alt-hover"), s = C(() => e.theme === "light" ? e.disabled ? "tw-bg-fill-alt-disabled" : "tw-bg-surface" : e.disabled ? "tw-bg-fill-alt-disabled" : "tw-bg-fill-alt"), l = C(() => e.disabled ? "tw-text-icon-disabled" : e.theme === "light" ? "tw-text-icon" : "tw-text-icon-inverse");
    return (c, d) => (g(), S("label", {
      class: M(["tw-relative tw-inline-flex tw-items-center", [
        c.disabled ? "tw-pointer-events-none tw-cursor-not-allowed" : "tw-cursor-pointer"
      ]])
    }, [
      Ee(R("input", {
        id: I(n),
        "onUpdate:modelValue": d[0] || (d[0] = (u) => t.value = u),
        type: "checkbox",
        name: I(n),
        class: "tw-sr-only tw-appearance-none",
        checked: t.value,
        disabled: c.disabled,
        readonly: c.disabled,
        valid: c.hasError ? !1 : void 0
      }, null, 8, xl), [
        [To, t.value]
      ]),
      R("div", {
        class: M(["tw-flex tw-p-3xs tw-transition-all tw-duration-200", {
          [i.value]: !0,
          [o.value]: !0,
          "tw-border-2 tw-border-error": c.hasError && !c.disabled
        }])
      }, [
        R("div", {
          class: M(["tw-rounded-full tw-transition-all tw-duration-200", {
            [s.value]: !t.value,
            [a.value]: !0
          }])
        }, null, 2),
        R("div", {
          class: M(["tw-items-center tw-rounded-full tw-transition-all tw-duration-200", {
            [s.value]: t.value,
            [r.value]: !0,
            [a.value]: !0
          }])
        }, [
          Ee(re(j, {
            name: c.iconName,
            size: c.size,
            class: M(l.value)
          }, null, 8, ["name", "size", "class"]), [
            [Ao, t.value]
          ])
        ], 2)
      ], 2)
    ], 2));
  }
}), kl = { class: "tw-inline-flex tw-items-center" }, Tl = ["aria-invalid"], Sl = ["for", "aria-label"], Il = ["id", "readonly", "checked", "value", "disabled", "valid", "onClick"], j0 = /* @__PURE__ */ B({
  __name: "UIInputToggleRadio",
  props: /* @__PURE__ */ oe({
    disabled: { type: Boolean, default: !1 },
    size: { default: "base" },
    theme: { default: "light" },
    hasError: { type: Boolean, default: !1 },
    options: {}
  }, {
    modelValue: void 0,
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ oe(["update:modelValue"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = t, o = fe(
      e,
      "modelValue",
      void 0
    ), r = Ne(), a = C(
      () => e.size === "sm" ? "tw-rounded-2xl" : e.size === "lg" ? "tw-rounded-4xl" : "tw-rounded-3xl"
    ), i = C(
      () => e.size === "sm" ? "tw-px-2xs tw-py-3xs" : e.size === "lg" ? "tw-p-sm" : "tw-p-xs"
    ), s = C(
      () => e.size === "sm" ? "tw-h-2xl tw-min-w-2xl" : e.size === "lg" ? "tw-h-4xl tw-min-w-4xl" : "tw-h-3xl tw-min-w-3xl"
    ), l = C(
      () => e.disabled ? "tw-bg-fill-discrete" : e.theme === "light" ? "tw-bg-fill-alt hover:tw-bg-fill-alt-hover" : "tw-bg-surface hover:tw-bg-surface-hover"
    ), c = C(
      () => e.size === "sm" ? "tw-text-body-sm tw-px-2xs tw-gap-x-2xs" : e.size === "lg" ? "tw-text-body-lg tw-px-sm tw-gap-x-sm" : "tw-text-body tw-px-xs tw-gap-x-xs"
    ), d = C(
      () => e.disabled ? "tw-bg-fill-alt-disabled" : e.theme === "light" ? "tw-bg-surface tw-text-icon" : "tw-bg-fill-alt tw-text-icon-inverse"
    ), u = C(
      () => e.disabled ? "tw-bg-fill-discrete" : e.theme === "dark" ? "tw-text-icon" : "tw-text-icon-inverse"
    ), f = C(
      () => e.theme === "light" ? "tw-text-icon-discrete2" : "tw-text-icon-disabled"
    );
    function h(y) {
      return o.value === y;
    }
    function m(y, w) {
      e.disabled || w || h(y) || (o.value = y, n("update:modelValue", y));
    }
    return (y, w) => (g(), S("div", kl, [
      R("div", {
        class: M(["tw-flex tw-p-3xs tw-transition-all tw-duration-200", {
          [l.value]: !0,
          [a.value]: !0,
          "tw-border-2 tw-border-error": y.hasError && !y.disabled
        }]),
        role: "radiogroup",
        "aria-invalid": y.hasError
      }, [
        (g(!0), S(tt, null, Zt(y.options, ({
          value: p,
          label: x,
          iconName: k,
          disabled: T = !1
        }) => (g(), S("label", {
          key: `${I(r)}-${p}`,
          class: M(["tw-flex tw-items-center tw-rounded-full tw-transition-all tw-duration-200", {
            "tw-cursor-pointer": !y.disabled && !T,
            "tw-cursor-not-allowed": y.disabled || T,
            [a.value]: !0,
            [s.value]: !0,
            [i.value]: !0,
            [d.value]: h(p),
            [u.value]: !h(p) && !T,
            [f.value]: T || y.disabled
          }]),
          for: `${I(r)}-${p}`,
          "aria-label": x
        }, [
          R("input", {
            id: `${I(r)}-${p}`,
            readonly: y.disabled || T,
            type: "radio",
            class: "tw-sr-only tw-appearance-none",
            checked: h(p),
            value: p,
            disabled: y.disabled || T,
            valid: y.hasError ? !1 : void 0,
            onClick: (F) => m(p, T)
          }, null, 8, Il),
          R("div", {
            class: M(["tw-flex tw-items-center", [c.value]])
          }, [
            k ? (g(), D(j, {
              key: 0,
              name: k,
              size: y.size
            }, null, 8, ["name", "size"])) : A("", !0),
            R("span", null, Z(x), 1)
          ], 2)
        ], 10, Sl))), 128))
      ], 10, Tl)
    ]));
  }
});
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var yr = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Et = /* @__PURE__ */ yr.join(","), xr = typeof Element > "u", $e = xr ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, zt = !xr && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, Mt = function e(t, n) {
  var o;
  n === void 0 && (n = !0);
  var r = t == null || (o = t.getAttribute) === null || o === void 0 ? void 0 : o.call(t, "inert"), a = r === "" || r === "true", i = a || n && t && e(t.parentNode);
  return i;
}, Al = function(t) {
  var n, o = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return o === "" || o === "true";
}, Cr = function(t, n, o) {
  if (Mt(t))
    return [];
  var r = Array.prototype.slice.apply(t.querySelectorAll(Et));
  return n && $e.call(t, Et) && r.unshift(t), r = r.filter(o), r;
}, kr = function e(t, n, o) {
  for (var r = [], a = Array.from(t); a.length; ) {
    var i = a.shift();
    if (!Mt(i, !1))
      if (i.tagName === "SLOT") {
        var s = i.assignedElements(), l = s.length ? s : i.children, c = e(l, !0, o);
        o.flatten ? r.push.apply(r, c) : r.push({
          scopeParent: i,
          candidates: c
        });
      } else {
        var d = $e.call(i, Et);
        d && o.filter(i) && (n || !t.includes(i)) && r.push(i);
        var u = i.shadowRoot || // check for an undisclosed shadow
        typeof o.getShadowRoot == "function" && o.getShadowRoot(i), f = !Mt(u, !1) && (!o.shadowRootFilter || o.shadowRootFilter(i));
        if (u && f) {
          var h = e(u === !0 ? i.children : u.children, !0, o);
          o.flatten ? r.push.apply(r, h) : r.push({
            scopeParent: i,
            candidates: h
          });
        } else
          a.unshift.apply(a, i.children);
      }
  }
  return r;
}, Tr = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, ke = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || Al(t)) && !Tr(t) ? 0 : t.tabIndex;
}, El = function(t, n) {
  var o = ke(t);
  return o < 0 && n && !Tr(t) ? 0 : o;
}, zl = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, Sr = function(t) {
  return t.tagName === "INPUT";
}, Ml = function(t) {
  return Sr(t) && t.type === "hidden";
}, $l = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(o) {
    return o.tagName === "SUMMARY";
  });
  return n;
}, Fl = function(t, n) {
  for (var o = 0; o < t.length; o++)
    if (t[o].checked && t[o].form === n)
      return t[o];
}, Nl = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || zt(t), o = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, r;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    r = o(window.CSS.escape(t.name));
  else
    try {
      r = o(t.name);
    } catch (i) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", i.message), !1;
    }
  var a = Fl(r, t.form);
  return !a || a === t;
}, Ol = function(t) {
  return Sr(t) && t.type === "radio";
}, Ll = function(t) {
  return Ol(t) && !Nl(t);
}, Dl = function(t) {
  var n, o = t && zt(t), r = (n = o) === null || n === void 0 ? void 0 : n.host, a = !1;
  if (o && o !== t) {
    var i, s, l;
    for (a = !!((i = r) !== null && i !== void 0 && (s = i.ownerDocument) !== null && s !== void 0 && s.contains(r) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !a && r; ) {
      var c, d, u;
      o = zt(r), r = (c = o) === null || c === void 0 ? void 0 : c.host, a = !!((d = r) !== null && d !== void 0 && (u = d.ownerDocument) !== null && u !== void 0 && u.contains(r));
    }
  }
  return a;
}, mo = function(t) {
  var n = t.getBoundingClientRect(), o = n.width, r = n.height;
  return o === 0 && r === 0;
}, Rl = function(t, n) {
  var o = n.displayCheck, r = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var a = $e.call(t, "details>summary:first-of-type"), i = a ? t.parentElement : t;
  if ($e.call(i, "details:not([open]) *"))
    return !0;
  if (!o || o === "full" || o === "legacy-full") {
    if (typeof r == "function") {
      for (var s = t; t; ) {
        var l = t.parentElement, c = zt(t);
        if (l && !l.shadowRoot && r(l) === !0)
          return mo(t);
        t.assignedSlot ? t = t.assignedSlot : !l && c !== t.ownerDocument ? t = c.host : t = l;
      }
      t = s;
    }
    if (Dl(t))
      return !t.getClientRects().length;
    if (o !== "legacy-full")
      return !0;
  } else if (o === "non-zero-area")
    return mo(t);
  return !1;
}, Pl = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var o = 0; o < n.children.length; o++) {
          var r = n.children.item(o);
          if (r.tagName === "LEGEND")
            return $e.call(n, "fieldset[disabled] *") ? !0 : !r.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, $t = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Mt(n) || Ml(n) || Rl(n, t) || // For a details element with a summary, the summary element gets the focus
  $l(n) || Pl(n));
}, wn = function(t, n) {
  return !(Ll(n) || ke(n) < 0 || !$t(t, n));
}, Hl = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Vl = function e(t) {
  var n = [], o = [];
  return t.forEach(function(r, a) {
    var i = !!r.scopeParent, s = i ? r.scopeParent : r, l = El(s, i), c = i ? e(r.candidates) : s;
    l === 0 ? i ? n.push.apply(n, c) : n.push(s) : o.push({
      documentOrder: a,
      tabIndex: l,
      item: r,
      isScope: i,
      content: c
    });
  }), o.sort(zl).reduce(function(r, a) {
    return a.isScope ? r.push.apply(r, a.content) : r.push(a.content), r;
  }, []).concat(n);
}, Bl = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = kr([t], n.includeContainer, {
    filter: wn.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: Hl
  }) : o = Cr(t, n.includeContainer, wn.bind(null, n)), Vl(o);
}, jl = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = kr([t], n.includeContainer, {
    filter: $t.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : o = Cr(t, n.includeContainer, $t.bind(null, n)), o;
}, De = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return $e.call(t, Et) === !1 ? !1 : wn(n, t);
}, Ul = /* @__PURE__ */ yr.concat("iframe").join(","), Yt = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return $e.call(t, Ul) === !1 ? !1 : $t(n, t);
};
/*!
* focus-trap 7.6.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function bn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function Wl(e) {
  if (Array.isArray(e)) return bn(e);
}
function _l(e, t, n) {
  return (t = Yl(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Kl(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function ql() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function po(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function vo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? po(Object(n), !0).forEach(function(o) {
      _l(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : po(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function Gl(e) {
  return Wl(e) || Kl(e) || Xl(e) || ql();
}
function Ql(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Yl(e) {
  var t = Ql(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Xl(e, t) {
  if (e) {
    if (typeof e == "string") return bn(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? bn(e, t) : void 0;
  }
}
var wo = {
  activateTrap: function(t, n) {
    if (t.length > 0) {
      var o = t[t.length - 1];
      o !== n && o._setPausedState(!0);
    }
    var r = t.indexOf(n);
    r === -1 || t.splice(r, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var o = t.indexOf(n);
    o !== -1 && t.splice(o, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, Zl = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, Jl = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, et = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, e0 = function(t) {
  return et(t) && !t.shiftKey;
}, t0 = function(t) {
  return et(t) && t.shiftKey;
}, bo = function(t) {
  return setTimeout(t, 0);
}, Qe = function(t) {
  for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
    o[r - 1] = arguments[r];
  return typeof t == "function" ? t.apply(void 0, o) : t;
}, wt = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, n0 = [], o0 = function(t, n) {
  var o = (n == null ? void 0 : n.document) || document, r = (n == null ? void 0 : n.trapStack) || n0, a = vo({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: e0,
    isKeyBackward: t0
  }, n), i = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, s, l = function(v, b, E) {
    return v && v[b] !== void 0 ? v[b] : a[E || b];
  }, c = function(v, b) {
    var E = typeof (b == null ? void 0 : b.composedPath) == "function" ? b.composedPath() : void 0;
    return i.containerGroups.findIndex(function(O) {
      var L = O.container, H = O.tabbableNodes;
      return L.contains(v) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (E == null ? void 0 : E.includes(L)) || H.find(function(N) {
        return N === v;
      });
    });
  }, d = function(v) {
    var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, E = b.hasFallback, O = E === void 0 ? !1 : E, L = b.params, H = L === void 0 ? [] : L, N = a[v];
    if (typeof N == "function" && (N = N.apply(void 0, Gl(H))), N === !0 && (N = void 0), !N) {
      if (N === void 0 || N === !1)
        return N;
      throw new Error("`".concat(v, "` was specified but was not a node, or did not return a node"));
    }
    var Y = N;
    if (typeof N == "string") {
      try {
        Y = o.querySelector(N);
      } catch (J) {
        throw new Error("`".concat(v, '` appears to be an invalid selector; error="').concat(J.message, '"'));
      }
      if (!Y && !O)
        throw new Error("`".concat(v, "` as selector refers to no known node"));
    }
    return Y;
  }, u = function() {
    var v = d("initialFocus", {
      hasFallback: !0
    });
    if (v === !1)
      return !1;
    if (v === void 0 || v && !Yt(v, a.tabbableOptions))
      if (c(o.activeElement) >= 0)
        v = o.activeElement;
      else {
        var b = i.tabbableGroups[0], E = b && b.firstTabbableNode;
        v = E || d("fallbackFocus");
      }
    else v === null && (v = d("fallbackFocus"));
    if (!v)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return v;
  }, f = function() {
    if (i.containerGroups = i.containers.map(function(v) {
      var b = Bl(v, a.tabbableOptions), E = jl(v, a.tabbableOptions), O = b.length > 0 ? b[0] : void 0, L = b.length > 0 ? b[b.length - 1] : void 0, H = E.find(function(J) {
        return De(J);
      }), N = E.slice().reverse().find(function(J) {
        return De(J);
      }), Y = !!b.find(function(J) {
        return ke(J) > 0;
      });
      return {
        container: v,
        tabbableNodes: b,
        focusableNodes: E,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: Y,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: O,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: L,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: H,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: N,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(xe) {
          var Ke = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, ve = b.indexOf(xe);
          return ve < 0 ? Ke ? E.slice(E.indexOf(xe) + 1).find(function(qe) {
            return De(qe);
          }) : E.slice(0, E.indexOf(xe)).reverse().find(function(qe) {
            return De(qe);
          }) : b[ve + (Ke ? 1 : -1)];
        }
      };
    }), i.tabbableGroups = i.containerGroups.filter(function(v) {
      return v.tabbableNodes.length > 0;
    }), i.tabbableGroups.length <= 0 && !d("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (i.containerGroups.find(function(v) {
      return v.posTabIndexesFound;
    }) && i.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, h = function(v) {
    var b = v.activeElement;
    if (b)
      return b.shadowRoot && b.shadowRoot.activeElement !== null ? h(b.shadowRoot) : b;
  }, m = function(v) {
    if (v !== !1 && v !== h(document)) {
      if (!v || !v.focus) {
        m(u());
        return;
      }
      v.focus({
        preventScroll: !!a.preventScroll
      }), i.mostRecentlyFocusedNode = v, Zl(v) && v.select();
    }
  }, y = function(v) {
    var b = d("setReturnFocus", {
      params: [v]
    });
    return b || (b === !1 ? !1 : v);
  }, w = function(v) {
    var b = v.target, E = v.event, O = v.isBackward, L = O === void 0 ? !1 : O;
    b = b || wt(E), f();
    var H = null;
    if (i.tabbableGroups.length > 0) {
      var N = c(b, E), Y = N >= 0 ? i.containerGroups[N] : void 0;
      if (N < 0)
        L ? H = i.tabbableGroups[i.tabbableGroups.length - 1].lastTabbableNode : H = i.tabbableGroups[0].firstTabbableNode;
      else if (L) {
        var J = i.tabbableGroups.findIndex(function(Ht) {
          var Vt = Ht.firstTabbableNode;
          return b === Vt;
        });
        if (J < 0 && (Y.container === b || Yt(b, a.tabbableOptions) && !De(b, a.tabbableOptions) && !Y.nextTabbableNode(b, !1)) && (J = N), J >= 0) {
          var xe = J === 0 ? i.tabbableGroups.length - 1 : J - 1, Ke = i.tabbableGroups[xe];
          H = ke(b) >= 0 ? Ke.lastTabbableNode : Ke.lastDomTabbableNode;
        } else et(E) || (H = Y.nextTabbableNode(b, !1));
      } else {
        var ve = i.tabbableGroups.findIndex(function(Ht) {
          var Vt = Ht.lastTabbableNode;
          return b === Vt;
        });
        if (ve < 0 && (Y.container === b || Yt(b, a.tabbableOptions) && !De(b, a.tabbableOptions) && !Y.nextTabbableNode(b)) && (ve = N), ve >= 0) {
          var qe = ve === i.tabbableGroups.length - 1 ? 0 : ve + 1, Dn = i.tabbableGroups[qe];
          H = ke(b) >= 0 ? Dn.firstTabbableNode : Dn.firstDomTabbableNode;
        } else et(E) || (H = Y.nextTabbableNode(b));
      }
    } else
      H = d("fallbackFocus");
    return H;
  }, p = function(v) {
    var b = wt(v);
    if (!(c(b, v) >= 0)) {
      if (Qe(a.clickOutsideDeactivates, v)) {
        s.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: a.returnFocusOnDeactivate
        });
        return;
      }
      Qe(a.allowOutsideClick, v) || v.preventDefault();
    }
  }, x = function(v) {
    var b = wt(v), E = c(b, v) >= 0;
    if (E || b instanceof Document)
      E && (i.mostRecentlyFocusedNode = b);
    else {
      v.stopImmediatePropagation();
      var O, L = !0;
      if (i.mostRecentlyFocusedNode)
        if (ke(i.mostRecentlyFocusedNode) > 0) {
          var H = c(i.mostRecentlyFocusedNode), N = i.containerGroups[H].tabbableNodes;
          if (N.length > 0) {
            var Y = N.findIndex(function(J) {
              return J === i.mostRecentlyFocusedNode;
            });
            Y >= 0 && (a.isKeyForward(i.recentNavEvent) ? Y + 1 < N.length && (O = N[Y + 1], L = !1) : Y - 1 >= 0 && (O = N[Y - 1], L = !1));
          }
        } else
          i.containerGroups.some(function(J) {
            return J.tabbableNodes.some(function(xe) {
              return ke(xe) > 0;
            });
          }) || (L = !1);
      else
        L = !1;
      L && (O = w({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: i.mostRecentlyFocusedNode,
        isBackward: a.isKeyBackward(i.recentNavEvent)
      })), m(O || i.mostRecentlyFocusedNode || u());
    }
    i.recentNavEvent = void 0;
  }, k = function(v) {
    var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    i.recentNavEvent = v;
    var E = w({
      event: v,
      isBackward: b
    });
    E && (et(v) && v.preventDefault(), m(E));
  }, T = function(v) {
    (a.isKeyForward(v) || a.isKeyBackward(v)) && k(v, a.isKeyBackward(v));
  }, F = function(v) {
    Jl(v) && Qe(a.escapeDeactivates, v) !== !1 && (v.preventDefault(), s.deactivate());
  }, z = function(v) {
    var b = wt(v);
    c(b, v) >= 0 || Qe(a.clickOutsideDeactivates, v) || Qe(a.allowOutsideClick, v) || (v.preventDefault(), v.stopImmediatePropagation());
  }, $ = function() {
    if (i.active)
      return wo.activateTrap(r, s), i.delayInitialFocusTimer = a.delayInitialFocus ? bo(function() {
        m(u());
      }) : m(u()), o.addEventListener("focusin", x, !0), o.addEventListener("mousedown", p, {
        capture: !0,
        passive: !1
      }), o.addEventListener("touchstart", p, {
        capture: !0,
        passive: !1
      }), o.addEventListener("click", z, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", T, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", F), s;
  }, U = function() {
    if (i.active)
      return o.removeEventListener("focusin", x, !0), o.removeEventListener("mousedown", p, !0), o.removeEventListener("touchstart", p, !0), o.removeEventListener("click", z, !0), o.removeEventListener("keydown", T, !0), o.removeEventListener("keydown", F), s;
  }, W = function(v) {
    var b = v.some(function(E) {
      var O = Array.from(E.removedNodes);
      return O.some(function(L) {
        return L === i.mostRecentlyFocusedNode;
      });
    });
    b && m(u());
  }, Q = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(W) : void 0, ie = function() {
    Q && (Q.disconnect(), i.active && !i.paused && i.containers.map(function(v) {
      Q.observe(v, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return i.active;
    },
    get paused() {
      return i.paused;
    },
    activate: function(v) {
      if (i.active)
        return this;
      var b = l(v, "onActivate"), E = l(v, "onPostActivate"), O = l(v, "checkCanFocusTrap");
      O || f(), i.active = !0, i.paused = !1, i.nodeFocusedBeforeActivation = o.activeElement, b == null || b();
      var L = function() {
        O && f(), $(), ie(), E == null || E();
      };
      return O ? (O(i.containers.concat()).then(L, L), this) : (L(), this);
    },
    deactivate: function(v) {
      if (!i.active)
        return this;
      var b = vo({
        onDeactivate: a.onDeactivate,
        onPostDeactivate: a.onPostDeactivate,
        checkCanReturnFocus: a.checkCanReturnFocus
      }, v);
      clearTimeout(i.delayInitialFocusTimer), i.delayInitialFocusTimer = void 0, U(), i.active = !1, i.paused = !1, ie(), wo.deactivateTrap(r, s);
      var E = l(b, "onDeactivate"), O = l(b, "onPostDeactivate"), L = l(b, "checkCanReturnFocus"), H = l(b, "returnFocus", "returnFocusOnDeactivate");
      E == null || E();
      var N = function() {
        bo(function() {
          H && m(y(i.nodeFocusedBeforeActivation)), O == null || O();
        });
      };
      return H && L ? (L(y(i.nodeFocusedBeforeActivation)).then(N, N), this) : (N(), this);
    },
    pause: function(v) {
      return i.active ? (i.manuallyPaused = !0, this._setPausedState(!0, v)) : this;
    },
    unpause: function(v) {
      return i.active ? (i.manuallyPaused = !1, r[r.length - 1] !== this ? this : this._setPausedState(!1, v)) : this;
    },
    updateContainerElements: function(v) {
      var b = [].concat(v).filter(Boolean);
      return i.containers = b.map(function(E) {
        return typeof E == "string" ? o.querySelector(E) : E;
      }), i.active && f(), ie(), this;
    }
  }, Object.defineProperties(s, {
    _isManuallyPaused: {
      value: function() {
        return i.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(v, b) {
        if (i.paused === v)
          return this;
        if (i.paused = v, v) {
          var E = l(b, "onPause"), O = l(b, "onPostPause");
          E == null || E(), U(), ie(), O == null || O();
        } else {
          var L = l(b, "onUnpause"), H = l(b, "onPostUnpause");
          L == null || L(), f(), $(), ie(), H == null || H();
        }
        return this;
      }
    }
  }), s.updateContainerElements(t), s;
};
function r0(e, t = {}) {
  let n;
  const { immediate: o, ...r } = t, a = Ae(!1), i = Ae(!1), s = (f) => n && n.activate(f), l = (f) => n && n.deactivate(f), c = () => {
    n && (n.pause(), i.value = !0);
  }, d = () => {
    n && (n.unpause(), i.value = !1);
  }, u = C(() => {
    const f = q(e);
    return Se(f).map((h) => {
      const m = q(h);
      return typeof m == "string" ? m : rr(m);
    }).filter(gi);
  });
  return se(
    u,
    (f) => {
      f.length && (n = o0(f, {
        ...r,
        onActivate() {
          a.value = !0, t.onActivate && t.onActivate();
        },
        onDeactivate() {
          a.value = !1, t.onDeactivate && t.onDeactivate();
        }
      }), o && s());
    },
    { flush: "post" }
  ), Lt(() => l()), {
    hasFocus: a,
    isPaused: i,
    activate: s,
    deactivate: l,
    pause: c,
    unpause: d
  };
}
const a0 = {
  key: 0,
  class: "tw-fixed tw-bottom-zero tw-left-zero tw-right-zero tw-top-zero tw-z-[999999] tw-flex tw-h-full tw-items-end tw-bg-fill-alt tw-bg-opacity-70 md:tw-items-center md:tw-justify-center"
}, i0 = {
  key: 1,
  class: "tw-flex-1"
}, s0 = { key: 3 }, l0 = {
  key: 0,
  id: "modalContent",
  class: "tw-overflow-y-auto tw-p-lg"
}, c0 = {
  key: 1,
  class: "tw-w-full tw-p-lg"
}, u0 = {}, U0 = /* @__PURE__ */ B({
  ...u0,
  __name: "UIModal",
  props: {
    hasBackButton: { type: Boolean, default: !1 },
    isDismissable: { type: Boolean, default: !0 },
    size: { default: "base" }
  },
  emits: ["close", "previous"],
  setup(e, { emit: t }) {
    const n = t, o = pe(), r = He("modal"), { activate: a, deactivate: i } = r0(r, { immediate: !0 }), s = G(!1);
    gn(() => {
      s.value = !0, a(), l();
    }), Rr(() => {
      s.value = !1, i(), c();
    });
    function l() {
      document && document.body && (document.body.style.overflow = "hidden");
    }
    function c() {
      document && document.body && (document.body.style.overflow = "auto");
    }
    return (d, u) => (g(), D(Pr, { to: "body" }, [
      re(ko, {
        name: "fade",
        mode: "out-in"
      }, {
        default: K(() => [
          s.value ? (g(), S("div", a0, [
            R("article", {
              ref: "modal",
              "aria-modal": "",
              role: "dialog",
              "aria-labelledby": "modalTitle",
              "aria-describedby": "modalContent",
              class: M(["tw-flex tw-max-h-[90%] tw-w-full tw-flex-col tw-rounded-t-xl tw-bg-surface tw-p-sm md:tw-rounded-md", {
                "md:tw-w-[400px]": d.size === "sm",
                "md:tw-w-[640px]": d.size === "base",
                "md:tw-w-[800px]": d.size === "lg",
                "md:tw-w-[1024px]": d.size === "xl"
              }]),
              onKeydown: u[2] || (u[2] = yt((f) => d.isDismissable && n("close"), ["escape"]))
            }, [
              R("header", {
                class: M(["tw-p-lg tw-text-center", {
                  "tw-flex tw-items-center": d.hasBackButton || d.isDismissable,
                  "md:tw-text-left": !d.hasBackButton && !d.isDismissable
                }])
              }, [
                d.hasBackButton ? (g(), S("button", {
                  key: 0,
                  type: "button",
                  class: "tw-flex tw-size-2xl tw-cursor-pointer tw-items-center tw-justify-center",
                  onClick: u[0] || (u[0] = (f) => n("previous"))
                }, [
                  re(j, {
                    name: "famicons:chevron-back-sharp",
                    size: "lg",
                    class: "tw-text-icon-discrete"
                  })
                ])) : A("", !0),
                I(_)(o.title) ? (g(), S("div", i0, [
                  V(d.$slots, "title")
                ])) : A("", !0),
                d.isDismissable ? (g(), S("button", {
                  key: 2,
                  type: "button",
                  class: "tw-flex tw-size-xl tw-cursor-pointer tw-items-center tw-justify-center",
                  onClick: u[1] || (u[1] = (f) => n("close"))
                }, [
                  re(j, {
                    name: "material-symbols:close",
                    size: "lg",
                    class: "tw-text-icon-discrete"
                  })
                ])) : (g(), S("span", s0))
              ], 2),
              I(_)(o.content) ? (g(), S("section", l0, [
                V(d.$slots, "content")
              ])) : A("", !0),
              I(_)(o.cta) ? (g(), S("footer", c0, [
                V(d.$slots, "cta")
              ])) : A("", !0)
            ], 34)
          ])) : A("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), d0 = /* @__PURE__ */ B({
  __name: "UITag",
  props: {
    color: { default: "default" },
    iconLeftName: { default: "" },
    iconRightName: { default: "" },
    size: { default: "base" },
    text: { default: "" },
    variant: { default: "filled" }
  },
  setup(e) {
    const t = e;
    t.variant === "transparent" && t.color === "alt" && console.error("Variant `transparent` cannot be used with color `alt`");
    const n = C(() => t.variant === "transparent" ? { "tw-bg-fill-transparent": t.variant === "transparent" } : {
      "tw-bg-fill-discrete3": t.color === "default" || t.color === "disabled",
      "tw-bg-fill-primary-discrete2": t.color === "primary",
      "tw-bg-fill-alt": t.color === "alt",
      "tw-bg-fill-success": t.color === "success",
      "tw-bg-fill-caution": t.color === "warning",
      "tw-bg-fill-error": t.color === "error",
      "tw-bg-fill-accent-discrete": t.color === "accent"
    }), o = C(() => ({
      "tw-p-2xs": t.size === "base",
      "tw-py-3xs tw-px-2xs": t.size === "sm"
    })), r = C(() => [
      {
        // color
        "tw-text-discrete": t.color === "default",
        "tw-text-discrete3": t.color === "disabled",
        "tw-text-primary": t.color === "primary",
        "tw-text-inverse": t.color === "alt",
        "tw-text-success": t.color === "success",
        "tw-text-caution": t.color === "warning",
        "tw-text-error": t.color === "error",
        "tw-text-accent": t.color === "accent",
        // size
        "tw-text-body-xs": t.size === "sm",
        "tw-text-body-sm": t.size === "base"
      }
    ]), a = C(() => ({
      "tw-text-icon-discrete": t.color === "default",
      "tw-text-icon-discrete3": t.color === "disabled",
      "tw-text-icon-primary": t.color === "primary",
      "tw-text-icon-inverse": t.color === "alt",
      "tw-text-icon-success": t.color === "success",
      "tw-text-icon-caution": t.color === "warning",
      "tw-text-icon-error": t.color === "error",
      "tw-text-icon-accent": t.color === "accent"
    }));
    return (i, s) => (g(), S("span", {
      class: M(["tw-flex tw-w-fit tw-items-center tw-rounded-lg", [n.value, o.value]])
    }, [
      i.iconLeftName ? (g(), D(j, {
        key: 0,
        name: i.iconLeftName,
        size: "sm",
        class: M(a.value)
      }, null, 8, ["name", "class"])) : A("", !0),
      i.text ? (g(), S("span", {
        key: 1,
        class: M(["tw-px-3xs", r.value])
      }, Z(i.text), 3)) : A("", !0),
      i.iconRightName ? (g(), D(j, {
        key: 2,
        name: i.iconRightName,
        size: "sm",
        class: M(a.value)
      }, null, 8, ["name", "class"])) : A("", !0)
    ], 2));
  }
}), f0 = { class: "tw-flex tw-w-full tw-items-center tw-gap-x-md" }, h0 = { class: "tw-flex tw-flex-1 tw-items-center tw-gap-x-2xs" }, m0 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-y-3xs" }, p0 = {
  key: 0,
  class: "tw-text-body tw-font-medium"
}, v0 = {}, W0 = /* @__PURE__ */ B({
  ...v0,
  __name: "UISelectionCard",
  props: /* @__PURE__ */ oe({
    displayCheckbox: { type: Boolean, default: !0 },
    isDisabled: { type: Boolean, default: !1 },
    hasError: { type: Boolean, default: !1 },
    iconName: { default: "" },
    size: { default: "base" },
    subText: { default: "" },
    tagText: { default: "" },
    text: { default: "" }
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = fe(e, "modelValue");
    return (n, o) => (g(), S("label", {
      class: M(["tw-flex tw-w-full tw-min-w-[176px] tw-cursor-pointer tw-items-center tw-justify-between tw-gap-x-md tw-rounded-lg tw-border tw-border-discrete2 tw-bg-surface focus-within:tw-outline hover:tw-bg-fill-hover", [
        {
          "!tw-border-default tw-shadow-[inset_0px_0px_0px_1px] tw-shadow-text-default-color": t.value && !n.isDisabled,
          "tw-pointer-events-none tw-text-discrete3": n.isDisabled,
          "!tw-border-error": n.hasError
        },
        n.size === "sm" ? "tw-p-sm tw-pl-md" : "tw-p-lg"
      ]])
    }, [
      R("span", f0, [
        re(il, {
          modelValue: t.value,
          "onUpdate:modelValue": o[0] || (o[0] = (r) => t.value = r),
          "has-error": n.hasError,
          "is-disabled": n.isDisabled,
          class: M(["tw-pointer-events-none", {
            "tw-sr-only": !n.displayCheckbox
          }])
        }, null, 8, ["modelValue", "has-error", "is-disabled", "class"]),
        R("span", h0, [
          R("span", m0, [
            n.text ? (g(), S("span", p0, Z(n.text), 1)) : A("", !0),
            n.subText ? (g(), S("span", {
              key: 1,
              class: M(n.text ? "tw-text-body-sm" : "tw-text-body")
            }, Z(n.subText), 3)) : A("", !0)
          ]),
          n.tagText ? (g(), D(d0, {
            key: 0,
            text: n.tagText,
            color: n.isDisabled ? "disabled" : "default",
            class: M({
              "!tw-bg-fill-discrete2": t.value
            })
          }, null, 8, ["text", "color", "class"])) : A("", !0)
        ]),
        n.iconName ? (g(), D(j, {
          key: 0,
          name: n.iconName,
          size: n.size === "sm" ? "xl" : "2xl",
          class: "tw-text-icon"
        }, null, 8, ["name", "size"])) : A("", !0)
      ])
    ], 2));
  }
}), w0 = { class: "tabs" }, b0 = {
  role: "tablist",
  class: "tw-flex tw-gap-x-2xl"
}, g0 = ["aria-selected", "aria-controls", "disabled", "tabindex", "onClick", "onKeydown"], y0 = ["id", "aria-labelledby"], x0 = {}, _0 = /* @__PURE__ */ B({
  ...x0,
  __name: "UITab",
  props: {
    tabsTitles: {},
    disabledTabsTitles: { default: () => [] },
    isTextColorInverse: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = pe(), r = t, a = G(0), i = He("tabRefs"), s = Object.keys(o), l = C(() => n.tabsTitles.map((u, f) => s.includes(`tab-${f}`) ? f : null).filter((u) => u !== null));
    function c(u) {
      n.disabledTabsTitles.includes(n.tabsTitles[u]) || (a.value = u, r("click"));
    }
    function d(u, f) {
      var h, m;
      if (i.value) {
        if (f.key === "ArrowRight") {
          const y = u === n.tabsTitles.length - 1 ? u : u + 1;
          (h = i.value[y]) == null || h.focus();
        } else if (f.key === "ArrowLeft") {
          const y = u === 0 ? u : u - 1;
          (m = i.value[y]) == null || m.focus();
        }
      }
    }
    return (u, f) => (g(), S("div", w0, [
      R("div", b0, [
        (g(!0), S(tt, null, Zt(u.tabsTitles, (h, m) => (g(), S("button", {
          key: h,
          ref_for: !0,
          ref_key: "tabRefs",
          ref: i,
          role: "tab",
          "aria-selected": a.value === m,
          "aria-controls": `tab-${m}`,
          disabled: u.disabledTabsTitles.includes(h),
          tabindex: a.value === m ? 0 : -1,
          class: M(["tw-border-b-4 tw-border-b-transparent tw-pb-sm tw-font-bold", {
            "!tw-border-b-primary": a.value === m,
            "tw-text-inverse": u.isTextColorInverse,
            "!tw-text-discrete3": u.disabledTabsTitles.includes(h),
            "hover:!tw-border-b-discrete3": !u.disabledTabsTitles.includes(h)
          }]),
          onClick: (y) => c(m),
          onKeydown: (y) => d(m, y)
        }, Z(h), 43, g0))), 128))
      ]),
      (g(!0), S(tt, null, Zt(l.value, (h) => Ee((g(), S("section", {
        id: `tab-${h}`,
        key: h,
        role: "tabpanel",
        "aria-labelledby": u.tabsTitles[h]
      }, [
        V(u.$slots, `tab-${h}`)
      ], 8, y0)), [
        [Ao, a.value === h]
      ])), 128))
    ]));
  }
}), C0 = ["aria-controlledby", "onMouseleave", "onKeydown"], k0 = {}, T0 = /* @__PURE__ */ B({
  ...k0,
  __name: "UITooltip",
  props: {
    forceHidden: { type: Boolean, default: !1 },
    forceShown: { type: Boolean, default: !1 },
    hideArrow: { type: Boolean, default: !1 },
    hideDelay: { default: 0 },
    placement: { default: "bottom" },
    showWhenClicked: { type: Boolean, default: !1 }
  },
  emits: ["show", "hide"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = pe(), a = G(), i = Ne(), s = `${i}-tooltip-content`, l = He("tooltipContentRef"), c = G(!1), d = C(() => c.value ? "" : n.placement.includes("top") ? "emptyHoverAreaBottom" : n.placement.includes("bottom") ? "emptyHoverAreaTop" : n.placement.includes("left") ? "emptyHoverAreaRight" : n.placement.includes("right") ? "emptyHoverAreaLeft" : "");
    function u(p, x = !0) {
      !x || c.value || n.forceShown || (clearTimeout(a.value), a.value = setTimeout(() => p(!1), n.hideDelay));
    }
    function f() {
      clearTimeout(a.value);
    }
    function h(p) {
      var x;
      n.forceHidden || n.forceShown || (clearTimeout(a.value), p(!0), (x = l.value) == null || x.focus());
    }
    function m(p, x) {
      var k;
      if (!(!n.showWhenClicked || n.forceHidden || n.forceShown)) {
        if (!c.value) {
          c.value = !0, p(!0), (k = l.value) == null || k.focus();
          return;
        }
        c.value = !c.value, x && p(!1);
      }
    }
    function y(p) {
      p(!1), c.value = !1;
    }
    function w() {
      c.value = !1;
    }
    return (p, x) => (g(), D(wr, {
      placement: p.placement,
      "has-arrow": !p.hideArrow,
      "force-show-floating-el": p.forceShown,
      onClickOutside: w,
      onHideFloating: x[0] || (x[0] = (k) => o("hide")),
      onShowFloating: x[1] || (x[1] = (k) => o("show"))
    }, {
      reference: K(({ toggleContentDisplay: k, isFloatingElDisplayed: T }) => [
        I(_)(r.referenceEl) ? V(p.$slots, "referenceEl", {
          key: 0,
          id: I(i),
          ariaDescribedby: s,
          ariaExpanded: T,
          onClick: (F) => m(k, T),
          onMouseenter: (F) => h(k),
          onMouseleave: (F) => u(k, T),
          onKeydown: yt((F) => y(k), ["escape"])
        }, void 0, !0) : A("", !0)
      ]),
      floating: K(({ toggleContentDisplay: k }) => [
        I(_)(r.tooltipContent) ? (g(), S("div", {
          key: 0,
          id: s,
          ref: "tooltipContentRef",
          class: M(["tw-text-body-xs tw-relative tw-z-[999999] tw-flex tw-max-w-[224px] tw-flex-col tw-gap-y-sm tw-rounded-sm tw-bg-fill-alt tw-p-sm tw-text-inverse focus:tw-outline-none", d.value]),
          "aria-controlledby": I(i),
          tabindex: "-1",
          role: "tooltip",
          onMouseenter: f,
          onMouseleave: (T) => u(k),
          onKeydown: yt((T) => y(k), ["escape"])
        }, [
          V(p.$slots, "tooltipContent", {}, void 0, !0)
        ], 42, C0)) : A("", !0)
      ]),
      _: 3
    }, 8, ["placement", "has-arrow", "force-show-floating-el"]));
  }
}), K0 = /* @__PURE__ */ ir(T0, [["__scopeId", "data-v-5ddfca42"]]);
Zo(Wr);
export {
  A0 as Iconify,
  z0 as UIAvatar,
  ji as UIBanner,
  M0 as UIBannerMulti,
  oo as UIButton,
  $0 as UIButtonLink,
  F0 as UICard,
  tr as UIChip,
  N0 as UIChipButton,
  O0 as UIChipSelection,
  L0 as UIDropdownMenu,
  D0 as UIDropdownMenuList,
  R0 as UIDropdownMenuListItem,
  j as UIIcon,
  il as UIInputCheckbox,
  P0 as UIInputPassword,
  H0 as UIInputText,
  V0 as UIInputTextarea,
  B0 as UIInputToggleCheckbox,
  j0 as UIInputToggleRadio,
  U0 as UIModal,
  W0 as UISelectionCard,
  _0 as UITab,
  d0 as UITag,
  K0 as UITooltip,
  E0 as grooverUITailwindPlugin
};
